window.theme = window.theme || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

function calculateBespokePrice(req = false) {
  var finalTotalBespoke = 0;
  var cmp_price = 0;
  var width = parseFloat($('.bespoke_width').val());    
  if (window.location.href.indexOf("pedestrian") > -1) {  
    width = parseFloat($('.pedestriangates_ip').val());   
  }
  var idd = $('#productidkit').val();
  var height = parseFloat($('.bespoke_height').val()); 
  
  var selectedVariant = $('.product-single__variants').find(":selected").text();
  var selectedVariantLowerCase = selectedVariant.toLowerCase();
  
  if (selectedVariant && selectedVariant.includes('18mm')) {
    $('#ProductPrice-'+idd).html('From £105');
    $('#ProductPrice-'+idd+'-1').html('From £105');
    $('#ProductPrice-'+idd+'-2').html('From £105');
    $('#ProductPrice-'+idd+'-3').html('From £105');
  } else if (selectedVariant && selectedVariant.includes('6mm')) {
    $('#ProductPrice-'+idd).html('From £85');
    $('#ProductPrice-'+idd+'-1').html('From £85');
    $('#ProductPrice-'+idd+'-2').html('From £85');
    $('#ProductPrice-'+idd+'-3').html('From £85');
  }
  if (window.location.href.indexOf("pedestrian") > -1) {     
    $('#ProductPrice-'+idd).html('From <s class="colorred">£643.50</s><span class="price-current">£566.28</span>');
    $('#ProductPrice-'+idd+'-1').html('From <s class="colorred">£643.50</s><span class="price-current">£566.28</span>');
    $('#ProductPrice-'+idd+'-2').html('From <s class="colorred">£643.50</s><span class="price-current">£566.28</span>');
    $('#ProductPrice-'+idd+'-3').html('From <s class="colorred">£643.50</s><span class="price-current">£566.28</span>');
  }

  var initialPriceGate = $('#ProductPriceGetByVariantSelection').html();
  initialPriceGate = parseFloat(initialPriceGate.replace('£', '').replace(',', '')) * 100;
  
  var crntcmpprice = $('#ProductCompPriceGetByVariantSelection').html();
  crntcmpprice = parseFloat(crntcmpprice.replace('£', '').replace(',', '')) * 100;
  
  if (window.location.href.indexOf("driveway-gate") > -1) {    
    $('#ProductPrice-'+idd).html('From '+theme.Currency.formatMoney(initialPriceGate, theme.settings.moneyFormat));
    $('#ProductPrice-'+idd+'-1').html('From '+theme.Currency.formatMoney(initialPriceGate, theme.settings.moneyFormat));
    $('#ProductPrice-'+idd+'-2').html('From '+theme.Currency.formatMoney(initialPriceGate, theme.settings.moneyFormat));
    $('#ProductPrice-'+idd+'-3').html('From '+theme.Currency.formatMoney(initialPriceGate, theme.settings.moneyFormat));
    finalTotalBespoke = initialPriceGate;
    cmp_price = crntcmpprice;
  }

  if (height && width) {
    var packs = width * height;
    if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("driveway-gate") > -1) { 
      packs = (width * height)/100;
    }

    var price = packs * 0.011;
    var selectedVariant = $('.product-single__variants').find(":selected").text();
    if (selectedVariant && selectedVariant.includes('18mm')) {
      price = packs * 0.017;
    }
    price = parseFloat(price) * 100;
    if (price < 8500) {
      price = 8500;
    }
    
    if (window.location.href.indexOf("pedestrian") > -1) {
      cmp_price = packs * 0.068;
      price = packs * 0.060;
      price = parseFloat(price) * 100;
      cmp_price = parseFloat(cmp_price) * 100;
      if (price < 64350) {
        price = 64350;
        cmp_price = 56628;
      }
    }
    
    if (window.location.href.indexOf("driveway-gate") > -1) {
      price = packs * 0.027;
      cmp_price = packs * 0.031;
      price = parseFloat(price) * 100;
      cmp_price = parseFloat(cmp_price) * 100;

      if (price < initialPriceGate) {
        price = initialPriceGate;
        cmp_price = crntcmpprice;
      }
    }
    finalTotalBespoke = price;
    if (cmp_price > price) {
        var ab = '<s class="colorred">'+theme.Currency.formatMoney(cmp_price, theme.settings.moneyFormat)+'</s>'
        ab += '<span class="price-current">'+theme.Currency.formatMoney(price, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
      $('#ProductPrice-'+idd+'-3').html(ab);
    } else {
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-3').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
    }
  }

  if (window.location.href.indexOf("pedestrian") > -1 && selectedVariantLowerCase && selectedVariantLowerCase.includes('bespoke') && finalTotalBespoke == 0 && req == true) {
    finalTotalBespoke = 64350; 
    cmp_price = 56628;
  }
  var farray = [];
  farray.push(finalTotalBespoke);
  farray.push(cmp_price);
  return farray;
}
  
(function($){
  var $ = jQuery = $;

  theme.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };

  theme.a11y = {

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
        keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
      };

      /**
       * Get every possible visible focusable element
       */
      var $focusableElements = options.$container.find(
        $(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        ).filter(':visible')
      );
      var firstFocusable = $focusableElements[0];
      var lastFocusable = $focusableElements[$focusableElements.length - 1];

      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }

      function _manageFocus(evt) {
        // Tab key
        if (evt.keyCode !== 9) return;

        /**
         * On the last focusable element and tab forward,
         * focus the first element.
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
        /**
         * On the first focusable element and tab backward,
         * focus the last element.
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }

      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();

      $(document).off('focusin');

      $(document).on(eventsName.focusout, function() {
        $(document).off(eventsName.keydown);
      });

      $(document).on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        $(document).on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }

      $(document).off(eventName);
    },

    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },

    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }

      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });

      this.instances.push(instance);
    },

    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

      if (!container) {
        return;
      }

      this.createInstance(container);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      if (!subSection) {
        this._loadSubSections();
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },

    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },

    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },

    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },

    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;

      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');

      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }

      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });


  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */

  theme.Currency = (function() {
    var moneyFormat = '$';

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();


  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */

  theme.Images = (function() {

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    /**
     * Create lazyloading-friendly image string
     *
     * @param string
     * @returns string with _{width}x as size param
     */
    function lazyloadImagePath(string) {
      var image;

      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }

      return image;
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();

  theme.Variants = (function() {

    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);

        return currentOptions;
      },

      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function(e) {
        var variant = this._getVariantFromOptions();

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        if (!variant) {
          return;
        }
        var vn = variant.title;
        if (variant && vn.includes('Bespoke')) {
          $('.price-wrapper-ele').css('opacity', '0');          
        }
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        
        if (variant && vn.includes('Bespoke')) {
          setTimeout(() => {
            $('.price-wrapper-ele').css('opacity', '1');
          }, 110);
        }
        var scrnsku = e.target.dataset.skuip;
        var scrnavailablity = e.target.dataset.isavailable;
        var vname = $('fieldset[name="Screen colour"]');
        if ($('fieldset[name="Screen colour"]')) {
          vname = $('fieldset[name="Screen colour"]');
        } else {
          vname = $('fieldset[name="screen colour"]');
        }
        var ch = vname.find('.colorcheckbox:checked').attr('data-skuip');
        var varavailable = vname.find('.colorcheckbox:checked').attr('data-isavailable');
        
        var variantid_ele = variant.id;
        var variantsku = variant.sku;
        if (ch && ch != '') {
          variantsku = ch;
        }
        if (varavailable == undefined && !($('body').hasClass('product.bundle-three'))) {
          varavailable = 'true';
        }
        // Preorder        
        if (variant.available && varavailable == 'true') {
          var nm = variant.name.toLowerCase();
          // if (variantsku == 'HABI-06-CRE-120X60-727359' ||
          //   variantsku == 'BLOS-06-CRE-180X60-531066') {
          //   $('.template-product .btn.add-to-cart span').html('Pre-order delivery w/c 30th September');
          //   $('.template-product .btn.add-to-cart span').addClass('presku');  
          // } else {
            $('.template-product .btn.add-to-cart span').html('Add to basket');
            $('.template-product .btn.add-to-cart span').removeClass('presku');
          // }
        }
        DY.recommendationContext = { type: "PRODUCT", data: [variantid_ele] };
      },

      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var img = {};
        if (this.currentVariant && this.currentVariant.featured_image) {
          img = this.currentVariant.featured_image;
        }
        var currentVariantImage = img || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      _updatePrice: function(variant) {
        var aurl = location.href;
        var isVertical = false;
        var idd = $('#ProductPriceGetByVariantSelection').attr('idd');
      
        if (variant.price === this.currentVariant && this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
        setTimeout(() => {
          var idd = $('#ProductPriceGetByVariantSelection').attr('idd');
          if ($('#Quantity-'+idd).val()) {
            var a = $('#Quantity-'+idd).val();
            a = parseInt(a);

            var finalklarna = a * variant.price;
            var pp = variant.price;
            var additionalSlat = [];
            var additionalScreen = [];
            if ($('#additional-slatpack').val()) {
              additionalSlat = JSON.parse($('#additional-slatpack').val());
            }

            if ($('#additional-screen').val()) {
              additionalScreen = JSON.parse($('#additional-screen').val());
            }
            
            if (additionalSlat) {
              var slatPkP = additionalSlat.price;
            }

        var vvprice = a * variant.price;
        var vvcprice = a * variant.compare_at_price;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());
        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
        }

        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;
        var vn = variant.title;
        var vnhandle = (variant.title).toLowerCase();
              if (variant.compare_at_price > variant.price) {
                
              var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="price-current">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
                
                $('#ProductPrice-'+idd+'-2').html(ab);
                $('#ProductPrice-'+idd+'-1').html(ab);
                $('#ProductPrice-'+idd).html(ab);
              } else {
                $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
                $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
                $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
              }
              finalklarna = vvprice;

            setTimeout(() => {
               $('klarna-placement').each(function() {
                $(this).attr("data-purchase-amount", finalklarna);
              });
              window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
              window.Klarna.OnsiteMessaging.refresh()
            }, 100);

        }
                   
        var deva = (finalklarna / 3);
        var devac = (finalklarna / 4);

        var devideby = (finalklarna / 4);
        if (finalklarna > 100000) {
          var devideby = (finalklarna / 12);
        }
        $('.dynamic_financers').html(theme.Currency.formatMoney(deva, theme.settings.moneyFormat));
        $('.minrange-spreadcost').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat));

        $('.dynamic_financers_clear').html(theme.Currency.formatMoney(devac, theme.settings.moneyFormat));
        $('.divideby_dynamic').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat));
        var vnhn = (variant.name).toLowerCase();

            if (variant && vnhandle.includes('bespoke') && vnhandle.includes('ral') && vnhandle.includes('colour')) {
              $('.bespoke_panel_ral').addClass('active');
              $('.bespoke-confirmation').addClass('active');
            } else if (variant && vnhandle.includes('bespoke') && (variant && vnhandle.includes('size') || variant && vnhandle.includes('height'))) {
              calculateBespokePrice();
              $('.bespoke_panel_size').addClass('active');
              $('.bespoke-confirmation').addClass('active');
            } else {          
              $('.bespoke_panel_size').removeClass('active');
             if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("bin-store") > -1) {}else {
              $('.bespoke-confirmation').removeClass('active');
             }
            }
            if (vnhn.includes('driveway gate')) {
              calculateBespokePrice();
              $('.bespoke-confirmation').addClass('active');
            }
         }, 100);
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },

      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },

      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },

      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },

      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
    return Variants;
  })();

  theme.rte = {
    init: function() {
      theme.rte.wrapTable();
      theme.rte.wrapVideo();
      theme.rte.imageLinks();
    },

    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },

    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });

      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },

    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };


  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };

      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));

      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });

      $('body')
      .trigger('productModalOpen')
      .trigger('modalOpen.' + this.id);

      this.bindEvents();
    };

    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function() {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 550); // modal close css transition

      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));

        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  })();

  theme.Drawers = (function() {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };

      this.$drawer = $('#' + id);

      if (!this.$drawer.length) {
        return false;
      }

      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };

    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);

        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');

        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));

        // Close modal if a drawer is opened
        $('body').on('productModalOpen', function() {
          this.close();
        }.bind(this));
      },

      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }
    
        $.getJSON('/cart.js', function(cart) {
          if(cart.items.length > 0){
            var cartId = cart.token;
            var cartTotalValue = cart.total_price;
            var cartTotalQuantity = cart.item_count;
            var cartCurrency = cart.currency;
            var cartItemsName = [];
            var cartItemsBrand = [];
            var cartItemsType = [];
            var cartItemsSku = [];
            var cartItemsId = [];
            var cartItemsVariantId = [];
            var cartItemsVariantTitle = [];
            var cartItemsPrice = [];
            var cartItemsQuantity = [];
            var cartItemsQuantity = [];
            var cartGProductIds = [];

            $.each(cart.items, function(key,val) {
              cartItemsName.push(val.title);
              cartItemsBrand.push(val.vendor);
              cartItemsType.push(val.product_type);
              cartItemsSku.push(val.sku);
              cartItemsId.push(val.product_id);
              cartItemsVariantId.push(val.variant_id);
              cartItemsVariantTitle.push(val.title);
              cartItemsPrice.push(parseFloat(parseInt(val.original_price)/100));
              cartItemsQuantity.push(val.quantity);
              cartGProductIds.push("shopify_GB_"+val.product_id+"_"+val.variant_id);
            });
            window.dataLayer.push({
              event: 'ee_checkout',
              page_type: 'cart',
              name: cartItemsName,
              brand: cartItemsBrand,
              product_type: cartItemsType,
              sku: cartItemsSku,
              id: cartItemsId,
              variant_id: cartItemsVariantId,
              variant: cartItemsVariantTitle,
              price: cartItemsPrice,
              quantity: cartItemsQuantity,
              cart_id: cart.token,
              currency: cartCurrency,
              totalValue: parseFloat(cart.total_price)/100,
              totalQuantity: cart.item_count,
              g_product_id: cartGProductIds
            });
          }
        });
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
        } else if (returnFocusEl) {
          var $el = $(returnFocusEl);
          this.$activeSource = $el.attr('aria-expanded', 'true');
        }

        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        $('body')
        .trigger('drawerOpen')
        .trigger('drawerOpen.' + this.config.id);

        this.bindEvents();
      },

      close: function() {
        if (!this.isOpen) {
          return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        window.setTimeout(function() {
          this.$nodes.parent.removeClass(this.config.closingClass);
          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false').focus();
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();
      },

      bindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }

        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }

        }.bind(this));

        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },

      unbindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },

      // Check if clicked element is inside the drawer
      elementInsideDrawer: function($el) {
        return this.$drawer.find($el).length;
      }
    });

    return Drawer;
  })();

  theme.cart = {
    getCart: function() {
      return $.getJSON(theme.routes.cart);
    },

    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartChange,
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },

    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json'
      });
    },

    _updateCart: function(params) {
      return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
    },

    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };

      $.ajax(params);

    },

    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }

  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });

    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });


    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });

    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });

  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;
this.isnamespace = '';
      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };

      this.options = $.extend(defaults, options);

      this.initEventListeners();
    };

    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      initEventListeners: function() {
        this.$plus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          
                this.isnamespace = this.options.namespace;
          this.addQty(qty);
        }.bind(this));

        this.$minus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
                this.isnamespace = this.options.namespace;

          this.subtractQty(qty);
        }.bind(this));

        this.$input.on('change', function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },

      addQty: function(number) {
        var qty = number + 1;
          if (this.isnamespace == '.product') {
        setTimeout(function() {
          if ($('#ProductPriceGetByVariantSelection').text()) {
            var a = $('#ProductPriceGetByVariantSelection').text();
            var b = $('#ProductCompPriceGetByVariantSelection').text();
            var idd = $('#ProductPriceGetByVariantSelection').attr('idd');
            a = a.replace('£', '');
            a = a.replace(',', '');
            a = parseFloat(a);
            a = a * 100;
            
            b = b.replace('£', '');
            b = b.replace(',', '');
            b = parseFloat(b);
            b = b * 100;


        var vvprice = a * qty;
        var vvcprice = b * qty;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());
        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
        }

        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;
            
            if (b > a) {
              var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="price-current">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
            
              $('#ProductPrice-'+idd).html(ab);
              $('#ProductPrice-'+idd+'-2').html(ab);
            } else {
              $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
              $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
            }

        var finalklarna = vvprice;
        var deva = (finalklarna / 3);
        var devac = (finalklarna / 4);
        var devideby = (finalklarna / 4);
        if (finalklarna > 100000) {
          var devideby = (finalklarna / 12);
        }
        $('.dynamic_financers').html(theme.Currency.formatMoney(deva, theme.settings.moneyFormat))

        $('.dynamic_financers_clear').html(theme.Currency.formatMoney(devac, theme.settings.moneyFormat))
        $('.divideby_dynamic').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat))
        $('.minrange-spreadcost').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat));
          if ($('#templatesuffix').val() == 'gates-kit') {
            $('.elehide-gate-post-required .manageipv').trigger('click');        
          }
            if ($(".elehide-planter-post-required")[0]){
              $('.elehide-planter-post-required').find('input:checked').parent('.manageipv').trigger('click');
            }
          }
        }, 100);
          }
        this.changeQty(qty);
      },

      subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
          if (this.isnamespace == '.product') {
        setTimeout(function() {
          if (qty > 0) {
          if ($('#ProductPriceGetByVariantSelection').text()) {
            var a = $('#ProductPriceGetByVariantSelection').text();
            var b = $('#ProductCompPriceGetByVariantSelection').text();

            var idd = $('#ProductPriceGetByVariantSelection').attr('idd');
            a = parseFloat(a.replace('£', '').replace(',', '')) * 100;
            b = parseFloat(b.replace('£', '').replace(',', '')) * 100;

        var vvprice = a * qty;
        var vvcprice = b * qty;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());
        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
        }

        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;
            
            if (b > a) {
              var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="price-current">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
            
              $('#ProductPrice-'+idd).html(ab);
              $('#ProductPrice-'+idd+'-2').html(ab);
            } else {
              $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
              $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
            }
            var finalklarna = vvprice;
            var deva = (finalklarna / 3);
            var devac = (finalklarna / 4);
            var devideby = (finalklarna / 4);
            if (finalklarna > 100000) {
              var devideby = (finalklarna / 12);
            }
            $('.dynamic_financers').html(theme.Currency.formatMoney(deva, theme.settings.moneyFormat));
            $('.minrange-spreadcost').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat));
        
            $('.dynamic_financers_clear').html(theme.Currency.formatMoney(devac, theme.settings.moneyFormat))
            $('.divideby_dynamic').html(theme.Currency.formatMoney(devideby, theme.settings.moneyFormat))
            if ($('#templatesuffix').val() == 'gates-kit') {
              $('.elehide-gate-post-required .manageipv').trigger('click');        
            } 
            if ($(".elehide-planter-post-required")[0]){
              $('.elehide-planter-post-required').find('input:checked').parent('.manageipv').trigger('click');
            }
            
          }
          }
        }, 100);
          }
        this.changeQty(qty);
      },

      changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
        var a = $('.dynamci_isis_area_input').val();
        if (a) {
          a = parseFloat(a);
          var aa = a*qty;
          $('.dynamci_isis_area').html(aa.toFixed(2));
        }
      },

      validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });

    return QtySelector;
  })();

  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };

    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    };

    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };

      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);

      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));

      this.initEventListeners();
    };

    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));

        $('body').on('added.ajaxProduct', function(evt, returnFocusEl) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, true, returnFocusEl);
          }.bind(this));
        }.bind(this));
      },

      buildCart: function(cart, openDrawer, returnFocusEl) {
        this.loading(true);
        this.emptyCart();

        var battenSizeColour = '';
        var insuslatProductLine = '';
        
        var PedestrianGateProductLineWidth = '';
        var PedestrianGateProductLineHeight = '';
        var CalculatedGatePrice = '';
        
        var wallWithLighting = '';
        if (cart.item_count === 0) {
          $(selectors.container).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p></div>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;

          $.each(cart.items, function(index, product) {

            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }

            var bespokeParentReference = '';
            if (product.properties !== null) {
              $.each(product.properties, function(key, value) {
                if (key == 'ParentReferenceID') {
                  bespokeParentReference = value;
                }
                if (key == 'Height of your insuslat wall (in mm)') {
                  insuslatProductLine = 'Height of your insuslat wall: '+value+' \n';
                }

                if (key == 'Width of your gate (in mm)') {
                  PedestrianGateProductLineWidth = '**Width of your gate (in mm): '+value+' ** \n';
                }
                if (key == 'Height of your gate (in mm)') {
                  PedestrianGateProductLineHeight = '**Height of your gate (in mm): '+value+' ** \n';
                }
                if (key == 'Gate Price') {
                  CalculatedGatePrice = '** Gate Price: '+value+' ** \n'
                }
                if (key == 'With Lighting' && value) {
                  wallWithLighting = 'With Lighting: '+value+'\n'
                }

                // if (key == 'Batten Size' || key == 'Additional Batten Size') {
                //   if (value != 'no') {
                //     battenSizeColour += 'Batten Size: '+value+'\n';
                //   }
                // }
                // if (key == 'Batten Colour') {
                //   battenSizeColour += 'Batten Colour: '+value+'\n';
                // }
                
                if (key.charAt(0) === '_' || !value) {
                  delete product.properties[key];
                }
                
                if (key == 'Additional Batten Size' && value == 'no') {
                  delete product.properties[key];
                }
              });
            }

            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;

                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }

            animation_row+=2;

            var atitle = product.product_title;
            var metainf = product.variant_title;
            var imgPost = prodImg;
            
            
            var hideqty = "false";
            // product.product_type == 'planters-small' || product.product_type == 'planters-medium' || product.product_type == 'planters-large-high' || product.product_type == 'planters-large-low' || product.product_type == 'planter-additional' || 
            if (product.product_type == 'garden-trellis') {
              var hideqty = "truehideimp";
            }

            var metainfLower = '';
            if(metainf) {
              metainfLower = metainf.toLowerCase();
            }
            var isBespoke = false;
            var isDriveway = false;
            var isSamplePack = false;
            if (metainfLower && metainfLower.includes('bespoke')) {
              isBespoke = true;
            }
            if (product && product.handle && (product.handle).includes('driveway-gate')) {
              isDriveway = true;
            }
            if (product && product.handle && (product.handle).includes('sample-pack')) {
              isSamplePack = true;
            }

            var hideQtySelector = false;
            if (product.handle == 'bespoke-size' || product.handle == 'bespoke-size-driveway-gate' || product.handle == 'bespoke-size-pedestrian-gate') {
              hideQtySelector = true;
            }

            item = {
              key: product.key,
              url: product.url,
              id: 'hide-'+product.product_id,
              variantId: product.variant_id,
              img: imgPost,
              hideqty: hideqty,
              animationRow: animation_row,
              name: atitle,
              variation: metainf,
              type: product.product_type,
              properties: product.properties,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price * product.quantity, theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              vendor: product.vendor,
              handle: product.handle,
              isBespoke: isBespoke,
              isDriveway: isDriveway,
              isSamplePack: isSamplePack,
              bespokeParentReference: bespokeParentReference,
              hideQtySelector: hideQtySelector
            };

            items.push(item);
          });

          animation_row+=2;

          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;

              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }

          var ordernotes = '';
          // if (openDrawer === true) {
          if (cart.items.length > 0) {
            for(var il = 0; il < cart.items.length; il++) {
              var item = cart.items[il];
              var prtags = item.product_type;
              var prtitle = item.product_title;
              var prtitlelower = prtitle.toLowerCase();
              if (prtags == 'Insuslat_Batten') {
                var battencolour = '';
                if (item.product_title && item.product_title.includes('Trim Battens - ')) {
                  battencolour = item.product_title.split('Trim Battens - ');
                } else {
                  battencolour = item.product_title.split('Trim Batten - ');
                }
                var btnqty_ele = 1;
                if (prtitlelower && prtitlelower.includes('side trim')) {
                  btnqty_ele = 2;
                }
                ordernotes += 'Quantity: '+(item.quantity)*btnqty_ele+'\n';
                ordernotes += 'Colour: '+battencolour[1]+'\n';
                ordernotes += 'Size: '+item.variant_title.replace('No / ','').replace('Yes / ','')+'\n\n';
              }
            }
          }
          // }

          var notes_ele_set = '';
          if (insuslatProductLine != '') {
            notes_ele_set += insuslatProductLine+'\n';
          }
          if (PedestrianGateProductLineHeight != '') {
            notes_ele_set += PedestrianGateProductLineHeight+'\n';
          }
          if (PedestrianGateProductLineWidth != '') {
            notes_ele_set += PedestrianGateProductLineWidth+'\n';
          }
          if (CalculatedGatePrice != '') {
            notes_ele_set += CalculatedGatePrice+'\n';
          }
          if (wallWithLighting != '') {
            notes_ele_set += wallWithLighting+'\n';
          }
          if (ordernotes != '') {
            notes_ele_set += ordernotes+'\n';
          }

          var cartnote = cart.note;
          var cartnotetrim = cartnote.trim();
          cartnotetrim = cartnotetrim.replace(/[\r\n]+/gm,'');
          cartnotetrim = cartnotetrim.replace(' ', '');
          var notes_ele_settrim = notes_ele_set.trim();
          notes_ele_settrim = notes_ele_settrim.replace(/[\r\n]+/gm,'');
          notes_ele_settrim = notes_ele_settrim.replace(' ', '');
          if (openDrawer === true || notes_ele_settrim.length > cartnotetrim.length) {
            cartnote = notes_ele_set;
          } else if (cartnotetrim != notes_ele_settrim) {
            cartnote = cartnote+'\n'+notes_ele_set;
          }
          
          data = {
            items: items,
            note: cartnote,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
          };

          $(selectors.container).append(this.template(data));
        }

        this.status.loaded = true;
        this.loading(false);

        $('body').trigger('updateCart' + config.namespace, cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }

        
      },

      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__wrapper').each(function(index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        }.bind(this));

        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },

      updateItem: function(evt, key, qty) {
        if (this.status.loading) {
          return;
        }

        this.loading(true);

        theme.cart.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(cart);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));
      },

      loading: function(state) {
        this.status.loading = state;

        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },

      emptyCart: function() {
        $(selectors.container).empty();
      },

      updateSuccess: function(cart) {
        var cartItems = cart.items;
        var qtyInTheCart = 0;
        var isFenceDeecorative = 0;
        var cartUpdates = {};
        var cartTotal = cart.total_price;
        var freecartPostId = '';
        var isfenceBuilder = false;
        var isPost = false,
            isFixingKit = false,
            isClapping = false,
            isFenceSlat = false,
            isScreen = false;
        var fixingQuantity;
        var freecartFixingKitId;
        var cappingId;
        if (cartItems.length > 0 && cartTotal == 0) {
          location.href = "/cart/clear";
          return;
        }

        for (var i=0; i<cartItems.length; i++) {
          if ( cartItems[i].handle == 'fence-posts' &&
              cartItems[i].id != 39799775985835 &&
              cartItems[i].id != 39799776018603 &&
              cartItems[i].id != 39799776051371 &&
              cartItems[i].id != 39799776084139 &&
              cartItems[i].id != 39799776116907 &&
              cartItems[i].id != 39799776149675 &&
              cartItems[i].id != 39799776182443) {
            var incartPost = cartItems[i].variant_title;
            isFenceDeecorative++;
            isPost = true;
          }

          if ( cartItems[i].handle == 'fixing-kit' ) {
            isFenceDeecorative++;
            isFixingKit = true;
            fixingQuantity = cartItems[i].quantity;
            freecartFixingKitId = cartItems[i].variant_id;
          }
          if ( cartItems[i].handle == 'fence-slat-capping' ) {
            isFenceDeecorative++;
            isClapping = true;
            cappingId = cartItems[i].variant_id;
          }
          if ( cartItems[i].handle == 'fence-slats-2-pack' || cartItems[i].handle == 'fence-grained-slats-2-pack') {
            isFenceDeecorative++;
            isFenceSlat = true;
          }
          if ( cartItems[i].handle.includes('-screen') ) {
            isFenceDeecorative++;
            isScreen = true;
          }

          if ( cartItems[i].handle === 'fence-post-gift' ) {
            freecartPostId = cartItems[i].id;
          }
        }
        var lastvisited = localStorage.getItem("lastvisited");
        var lastvisitedbundle = localStorage.getItem("lastvisitedbundle");
        if (lastvisited == 'design-your-fence-decorative') {
          if (isScreen && isPost && isFixingKit && isClapping && isFenceDeecorative >= 4) {
            isfenceBuilder = true;
          }
        } else if (lastvisited == 'design-your-fence-slatted') {
          if (isPost && isFixingKit && isClapping && isFenceSlat && isFenceDeecorative >= 4) {
            isfenceBuilder = true;
          }
        }  else if (lastvisited == 'design-your-fence-classic') {
          if (isPost && isFixingKit && isClapping && isFenceDeecorative >= 4) {
            isfenceBuilder = true;
          }
        } else {
          if (isScreen && isPost && isFixingKit && isClapping && isFenceSlat && isFenceDeecorative >= 4) {
            isfenceBuilder = true;
          }
        }

        for (var i=0; i<cartItems.length; i++) {
          if ( cartItems[i].id === freecartPostId ) {
            qtyInTheCart = cartItems[i].quantity;
            break;
          }
        }
        if ( !isfenceBuilder && ( qtyInTheCart > 0 )) {
          cartUpdates[freecartPostId] = 0;
          cartUpdates[freecartFixingKitId] = 0;
          cartUpdates[cappingId] = 0;
        } else {
          this.buildCart(cart);
          return;
        }
        var that = this;
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: { updates: cartUpdates },
          dataType: 'json',
          success: function(stuff) { 
            if(window.location.href.includes('/cart')) {
              location.reload();
            } else {
              var cartContents = fetch('/cart.js')
              .then(response => {
                response.json().then((cart) => {
                  that.buildCart(cart);
                });
              });
            }
          }
        };
        
        if (!($('body').hasClass('js-drawer-open'))) {
        $.ajax(params);
        } else {
          var cartContents = fetch('/cart.js')
          .then(response => {
            response.json().then((cart) => {
              that.buildCart(cart);
            });
          });
        }
      },

      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          // console.warn(XMLHttpRequest.responseJSON.description);
        }
      },

      updateCartNotification: function(evt, cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
        
        if (cart.total_price == 12500 || cart.total_price > 12500) {
          $('.freeshippingcong').show();
            $('.freeshippingcalc').hide();
        } else {
          $('.freeshippingcong').hide();
          $('.freeshippingcalc').show();
          var rem = 12500 - cart.total_price;
          $('.freeshippingcalc p span').text(theme.Currency.formatMoney(rem, theme.settings.moneyFormat));

        }
        $('.add-to-cart').removeClass('btn--loading');
      }
    });

    return CartDrawer;
  })();

  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');

      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };

    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();

        if (status.loading) {
          return;
        }


          if($('.vv-bespoke-ral-colour').find('input').is(':checked')) {
            var nm_ip = $('input.bespoke_ral_colour').attr('name');
            nm_ip = nm_ip.replace('ele_not_req_', '');
            $('input.bespoke_ral_colour').attr('name', nm_ip);
            $('input.bespoke_ral_colour').attr('required', true);
          } else {
              var nm_ip = $('input.bespoke_ral_colour').attr('name');
             $('input.bespoke_ral_colour').attr('name', 'ele_not_req_'+nm_ip); 
            $('input.bespoke_ral_colour').removeAttr('required');
          }

        
        $('.check_active_automation').each(function() {
          var nm = $(this).find('input[type="radio"]').attr('name');
          if ($(this).hasClass('active_automation')) {
            nm = nm.replace('ele_not_req_', '');
            $(this).find('input[type="radio"]').attr('name', nm);
          } else {
            $(this).find('input[type="radio"]').attr('name', 'ele_not_req_'+nm);
          } 
        });
        
        if ($(".bespoke-confirmation")[0]){
          
          var atrname = $('.bespoke-confirmation .tc-accepted-bespoke').attr('name');
          $('.bespoke-confirmation .tc-accepted-bespoke').attr('name', 'ele_not_selected_'+atrname);
          if ($(".bespoke-confirmation").hasClass('active')){
            if ($('.bespoke-confirmation input.bespoke-confirmation-ip').is(':checked')) {   
            atrname = atrname.replace('ele_not_selected_', '');
            $('.bespoke-confirmation .tc-accepted-bespoke').attr('name', atrname);
            } else {
              $('.bespoke-confirmation.active').append('<p class="error">Please select above checkbox to add product to Basket.</p>');
              setTimeout(function() {
                $('.bespoke-confirmation.active p.error').remove();
              }, 2500);
              return;
            }

          } else {
            $('.bespoke-confirmation .tc-accepted-bespoke').attr('name', 'ele_not_selected_'+atrname);
          }
        }

        if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("driveway") > -1 || window.location.href.indexOf("bin-store") > -1) {
          if ($(".bespoke-confirmation").hasClass('active')){} else {
              $('.bespoke-confirmation.active').append('<p class="error">Please select above checkbox to add product to Basket.</p>');
              setTimeout(function() {
                $('.bespoke-confirmation.active p.error').remove();
              }, 2500);
            return;
          }
        }

        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading'); 

        status.loading = true;
        
        var quantitytotal = this.$form.find('.js-qty__num').val();
        var dblqty = parseInt(quantitytotal) + parseInt(quantitytotal);
        var trplqty = parseInt(quantitytotal) + parseInt(quantitytotal) + parseInt(quantitytotal);
        

        if ($('#templatesuffix').val() == 'wall_panel') {
          var typeOfBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('datatype');
          var sizeOfBatten = $('.extra-step-wall-panel-sizes.active .variant-input.current_active').attr('data-value');
          var ledBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('data-value');

          var sidetrim_batten = false;
          if ($('.led_lighting_wall_panel .variant-input.current_active').hasClass('sidetrim_batten')) {
            sidetrim_batten = true;
          }
          var battenId = '';
          if (sidetrim_batten) {
            if (typeOfBatten == 'black-side') {
              battenId = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
            } else if (typeOfBatten == 'slat-colour-side') {
              battenId = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
            }
          } else {
            if (typeOfBatten == 'black') {
              battenId = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
            } else if (typeOfBatten == 'slat-colour') {
              battenId = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
            }                
          }
          if (battenId) {
            
            var nm = $('#batten_qty_value_dynmic').attr('name');
            var nmf = nm.replace('ele__', '');
            $('#batten_qty_value_dynmic').attr('name', nmf);

            
            var nq = $('.batten_size_value_dynmic').attr('name');
            var nqf = nq.replace('ele__', '');
            $('.batten_size_value_dynmic').attr('name', nqf);

            
            var pid = $('#productidkit').val();
            var quantityy = parseInt($('#Quantity-'+pid).val());
            var qt = 1;
            var additionalBatten = $('.dflx_additional_batten_type input:checked').val();
                
            if (additionalBatten == sizeOfBatten) {
              qt = 2;
              $('#batten_qty_value_dynmic').val(2);
            } else {
              $('#batten_qty_value_dynmic').val(parseInt(qt)+1);
            }
            
          } else {
            var nm = $('#batten_qty_value_dynmic').attr('name');
            nm = nm.replace('ele__', '');
            $('#batten_qty_value_dynmic').attr('name', 'ele__'+nm);
            
            var nq = $('.batten_size_value_dynmic').attr('name');
            nq = nq.replace('ele__', '');
            $('.batten_size_value_dynmic').attr('name', 'ele__'+nq);
          }
        }
        
        var data = this.$form.serialize();
//         Planters calculation
        var dataArray = this.$form.serializeArray();
        var dataPlantIndex = dataArray.findIndex(d => {
          return d.name == 'id';
        });
        
        var currentId = '';
        var currentProductId = '';
        if (dataPlantIndex > -1) {
          currentId = dataArray[dataPlantIndex].value;
        }
        var currentPId = $('.getVariantIdBasedOnSKU').find(":selected").attr('data-planterid');
        var currentPConcId = $('.getVariantIdBasedOnSKU').find(":selected").attr('data-concid');
        var currentProductId = $('.getVariantIdBasedOnSKU').find(":selected").attr('data-planterProductId');
        var producttags = $('.product-section').attr('data-product-tags');        
        
        if (currentPId) {
            data = data.replace('&id='+currentId, '&id='+currentPId);
        }
        
        if (currentPConcId) {
           data = data.replace('&quantity='+quantitytotal, '&quantity='+dblqty);
        }
        
        theme.cart.addItemFromForm(data)
        .then(function(product) {
          //           Free product disabled
          if (product.product_id == 7800166678744 || product.product_id == 6586814365867 || product.product_id == 7800166678744 ||
             product.product_id == 7896964366552 || product.product_id == 7896961482968) {
            $('#AddToCart-' + product.product_id).attr('type', 'button');
            return;
          }
          
          var incartPost = product.title;
          let incartPostLower = incartPost.toLowerCase();
              if ($(".bespoke-confirmation")[0]){
          if ($(".bespoke-confirmation").hasClass('active')){
            
              if (incartPostLower.includes('bespoke ral colour')) {                
                var finalTy4 = 'form_type=product'+'&id='+45334109683928+'&quantity='+quantitytotal;
                theme.cart.addItemFromForm(finalTy4)
                .then(function(product4) {
                    this.success(product4);
                }.bind(this))
                .catch(function(XMLHttpRequest) {
                  // that.error(XMLHttpRequest)
                }.bind(this))
                .always(function() {
                  // status.loading = false;
                  // that.$addToCart.removeClass('btn--loading');
                }.bind(this));
              }
            }
          }
          
          var product1 = product;
          var product2;
          var product3;
          var product4;
          var avald = $('.additionalproduct input:checked').val();
          var aval = $('.additionalproduct input:checked').attr('da-val'); 
          var addwith = $('.additionalproduct input:checked').attr('add-with'); 

          var destruc = data.split('&');
          var qt = destruc[destruc.length - 1];
          var finalTy = 'form_type=product&fixing kit='+avald+'&id='+aval+'&quantity='+qt;

          var isThreeBundle = $('.bundlethree').attr('data-bundle');
          var finalMirror = '';
          var temp = 0;
          
          // Additiona bin store
          var yesRequiredAdditionalBin = $('.v-yes-additional-bin-store.current_active').attr('dataid');
          if (yesRequiredAdditionalBin) {
            addwith = 'true';
            qt = 1;
            var productHandle = $('#product-template-product-handle').val();
            // if (productHandle.includes('2-bin')) {
            //   qt = 2;
            // } else if (productHandle.includes('3-bin')) {
            //   qt = 3;
            // }
            // console.log(product);
            finalTy = 'form_type=product&id='+yesRequiredAdditionalBin+'&quantity='+qt;
          }

          if ($('.bespoke_panel_size').hasClass('active') || window.location.href.indexOf("driveway-gate") > -1) {            
            var screenColour = $('.colour.elehide-colour.variant-wrapper input:checked').val();
            var screenName = $('.variant-input-wrap_ele.extra-step[class_ele="extra-step-cls"] .variant-input.current_active').attr('data-value');
            
            var idd = $('#productidkit').val();
            var width = parseFloat($('.bespoke_width').val());    
            if (window.location.href.indexOf("pedestrian") > -1) {  
              width = parseFloat($('.pedestriangates_ip').val());   
            }
            var height = parseFloat($('.bespoke_height').val()); 
            if (height && width) {
              addwith = 'true';
              qt = height*width;
              if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("driveway-gate") > -1) { 
                qt = (height*width)/100;
              }
              qt = qt/10;
              var qtt = parseInt(qt);

              if (qt < 773) {
                qtt = 773;
              }
              var selectedVariant = $('.product-single__variants').find(":selected").text();
              var idbespoke = 44666671857880;
              if (selectedVariant && selectedVariant.includes('18mm')) {
                if (qt < 618) {
                  qtt = 618;
                }
                idbespoke = 44666671890648;
              }

              if (window.location.href.indexOf("pedestrian") > -1) { 
                if (qt < 990) {
                  qtt = 990;
                }
                idbespoke = 45112763777240;
              }

              if (window.location.href.indexOf("driveway-gate") > -1) { 
                idbespoke = undefined;
                var initialPriceGate = $('#ProductPriceGetByVariantSelection').html();
                initialPriceGate = parseFloat(initialPriceGate.replace('£', '').replace(',', '')) * 100;
                var priceCalculated = qt * 0.27 * 100;

                var diffPrice = 0;
                if (priceCalculated > initialPriceGate) {
                  diffPrice = priceCalculated - initialPriceGate;
                  qtt = Math.ceil((diffPrice/100)/0.27);
                  idbespoke = 45121951596760;
                }
                
                // if (qt < 4000) {
                //   qtt = 4000;
                // }
              }
              
            }
            finalTy = 'form_type=product&id='+idbespoke+'&quantity='+qtt+'&properties[ParentReferenceID]='+product1.variant_id+'&properties[ParentReferenceUniqueID]='+product1.key;
            finalTy2 = 'form_type=product&id='+idbespoke+'&quantity='+qtt+'&properties[ParentReferenceID]='+product1.variant_id+'&properties[ParentReferenceUniqueID]='+product1.key;

            //   finalTy2 = 'form_type=product'+'&id[]='+freecartPostId+'&id[]='+45334109683928+'&quantity='+1;


            // if (screenName) {
            //   finalTy += '&properties[Screen name]='+screenName;
            // }
            // if (screenColour) {
            //   finalTy += '&properties[Screen colour]='+screenColour;
            // }
          }
          
            var additional_driveway_products = [];
            $('.active_automation').each(function() {              
              var id_driveway = $(this).find('input:checked').attr('da-val');
              if (id_driveway) {
                additional_driveway_products.push(id_driveway);
              }
            });
            var addadditional_frame_handle = false;
            if (additional_driveway_products && additional_driveway_products.length > 0) {
              addadditional_frame_handle = true;
                var atr = [{
                  'id': idbespoke+'',
                  'quantity': qtt+'',
                   'properties': {
                     'ParentReferenceID': product1.variant_id,
                     'ParentReferenceUniqueID': product1.key
                   }
                  }];
                let formData = {
                 'items': atr
                };
              
              if (idbespoke) {
                finalTy = JSON.stringify(formData);
                finalTy2 = JSON.stringify(formData);
              } else {
                atr = [];
              }
              
              for(var i = 0; i <= additional_driveway_products.length - 1; i++) {
                var lcl = {
                  'id':additional_driveway_products[i],
                  'quantity': quantitytotal,
                   'properties': {
                     'ParentReferenceID': product1.variant_id,
                     'ParentReferenceUniqueID': product1.key
                   }
                }
                atr.push(lcl);
                formData = {
                 'items': atr
                };
                finalTy = JSON.stringify(formData);
                finalTy2 = JSON.stringify(formData);
              }
            }

          
          var currentHandle = $('#ProductSection-'+product.product_id).attr('data-product-handle');
    if (window.location.href.indexOf("pedestrian") > -1  && addadditional_frame_handle == true) {
                  var that = this;
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: finalTy
                })
                .then(response => {
                    status.loading = false;
                    this.$addToCart.removeClass('btn--loading');
                  that.success(product);
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
                
                  // theme.cart.addItemFromForm(finalTy)
                  // .then(function(product1) {
                  //   that.success(product);
                  //   this.success(product1);
                  // }.bind(this))
                  // .catch(function(XMLHttpRequest) {
                  //   this.error(XMLHttpRequest)
                  // }.bind(this))
                  // .always(function() {
                  //   status.loading = false;
                  //   this.$addToCart.removeClass('btn--loading');
                  // }.bind(this));

    }
         else if ($('#templatesuffix').val() == 'wall_panel') {
            var that = this;
            var typeOfBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('datatype');
            var sizeOfBatten = $('.extra-step-wall-panel-sizes.active .variant-input.current_active').attr('data-value');
            var ledBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('data-value');

           var shelvingSelected = $('.insuslat-insuslat-hook-shelving.selected_ele').find('.current_active').find('input').attr('data-value');
           var ledStripSelected = $('.insuslat-insuslat-led-strip-quantity.selected_ele').find('.current_active').find('input').attr('data-value');
            var sidetrim_batten = false;
            if ($('.led_lighting_wall_panel .variant-input.current_active').hasClass('sidetrim_batten')) {
              sidetrim_batten = true;
            }
              var battenId = '';
              if (sidetrim_batten) {
                if (typeOfBatten == 'black-side') {
                  battenId = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
                } else if (typeOfBatten == 'slat-colour-side') {
                  battenId = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
                }
              } else {
                if (typeOfBatten == 'black') {
                  battenId = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
                } else if (typeOfBatten == 'slat-colour') {
                  battenId = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').val();
                }                
              }
              if (battenId) {
                var pid = $('#productidkit').val();
                var quantityy = parseInt($('#Quantity-'+pid).val());
                var qt = 1;
                var additionalBatten = $('.dflx_additional_batten_type input:checked').val();
                    
                if (additionalBatten == sizeOfBatten) {
                  qt = 2;
                }
                var additionalBattenForm = '';
                if (additionalBatten != 'no' && additionalBatten != sizeOfBatten) {
                  var additionalBattenId = '';
                  if (sidetrim_batten) {
                    if (typeOfBatten == 'black-side') {
                      additionalBattenId = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').val();
                    } else if (typeOfBatten == 'slat-colour-side') {
                      additionalBattenId = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').val();
                    }
                  } else {
                    if (typeOfBatten == 'black') {
                      additionalBattenId = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').val();
                    } else if (typeOfBatten == 'slat-colour') {
                      additionalBattenId = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').val();
                    }                
                  }
                  additionalBattenForm = 'form_type=product'+'&id='+additionalBattenId+'&quantity='+ 1;
                }
                // qt = qt * quantityy;
                var finalTy = 'form_type=product'+'&id='+battenId+'&quantity='+ qt;

                if (ledStripSelected && shelvingSelected) {
                  finalTy = 'form_type=product'+'&id[]='+battenId+'&id[]='+ledStripSelected+'&id[]='+ledStripSelected+'&quantity='+qt;
                } else if (ledStripSelected) {
                  finalTy = 'form_type=product'+'&id[]='+battenId+'&id[]='+ledStripSelected+'&quantity='+qt;
                } else if (shelvingSelected) {
                  finalTy = 'form_type=product'+'&id[]='+battenId+'&id[]='+shelvingSelected+'&quantity='+qt;
                }
                  
                status.loading = true;
                that.$addToCart.addClass('btn--loading');
                if (additionalBattenForm == '') {                  
                  theme.cart.addItemFromForm(finalTy)
                  .then(function(product2) {
                    setTimeout(() => {
                        if (product2) {
                          that.success(product2);}
                        if (product) {
                          that.success(product);}
                        }, 200);
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                    that.error(XMLHttpRequest)
                  }.bind(this))
                  .always(function() {
                    status.loading = false;
                    that.$addToCart.removeClass('btn--loading');
                  }.bind(this));
                } else {
                  theme.cart.addItemFromForm(finalTy)
                  .then(function(product2) {
                            theme.cart.addItemFromForm(additionalBattenForm)
                          .then(function(product3) {
                                setTimeout(() => {
                                if (product3) {
                                  that.success(product3);}
                                if (product2) {
                                  that.success(product2);}
                                if (product) {
                                  that.success(product);}
                                }, 50);
                          }.bind(this))
                          .catch(function(XMLHttpRequest) {
                            that.error(XMLHttpRequest)
                          }.bind(this))
                          .always(function() {
                            status.loading = false;
                            that.$addToCart.removeClass('btn--loading');
                          }.bind(this));
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                  }.bind(this))
                  .always(function() {
                  }.bind(this));
                }
                
              } else {
                  var shelving_led = '';

                if (ledStripSelected && shelvingSelected) {
                  shelving_led = 'form_type=product'+'&id[]='+shelvingSelected+'&id[]='+ledStripSelected+'&quantity='+qt;
                } else if (ledStripSelected) {
                  shelving_led = 'form_type=product'+'&id='+ledStripSelected+'&quantity='+qt;
                } else if (shelvingSelected) {
                  shelving_led = 'form_type=product'+'&id='+shelvingSelected+'&quantity='+qt;
                }

                if (shelving_led) {
                  theme.cart.addItemFromForm(shelving_led)
                  .then(function(product2) {
                    setTimeout(() => {
                        if (product2) {
                          that.success(product2);}
                        if (product) {
                          that.success(product);}
                        }, 200);
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                    that.error(XMLHttpRequest)
                  }.bind(this))
                  .always(function() {
                    status.loading = false;
                    that.$addToCart.removeClass('btn--loading');
                  }.bind(this));
                } else {
                  that.success(product);
                }
              }
            
          }
          else if (currentHandle.includes('-planter-')) {
            var that = this;
            var sk = product.sku;
            this.$addToCart.addClass('btn--loading');
            var additionalProId = '';
            if ((sk.includes('-S-') && sk.includes('-DAGR')) || (sk.includes('/SM') && sk.includes('DARK'))) {
              additionalProId = 43633344381144;
            } else if ((sk.includes('-S-') && sk.includes('-LIGR')) || (sk.includes('/SM') && sk.includes('LIGHT'))) {
              additionalProId = 43633344348376;
            } else if ((sk.includes('-M-') && sk.includes('-DAGR'))|| (sk.includes('/ME') && sk.includes('DARK'))) {
              additionalProId = 43633344446680;
            } else if ((sk.includes('-M-') && sk.includes('-LIGR'))|| (sk.includes('/ME') && sk.includes('LIGHT'))) {
              additionalProId = 43633344413912;
            } else if ((sk.includes('-L-') && sk.includes('-DAGR'))|| (sk.includes('/LG') && sk.includes('DARK'))) {
              additionalProId = 43633344512216;
            } else if ((sk.includes('-L-') && sk.includes('-LIGR'))|| (sk.includes('/LG') && sk.includes('LIGHT'))) {
              additionalProId = 43633344479448;
            } else if (((sk.includes('-XLL-') || sk.includes('-XLH-')) && sk.includes('-DAGR'))|| (sk.includes('/XL') && sk.includes('DARK'))) {
              additionalProId = 43633344577752;
            } else if (((sk.includes('-XLL-') || sk.includes('-XLH-')) && sk.includes('-LIGR'))|| (sk.includes('/XL') && sk.includes('LIGHT'))) {
              additionalProId = 43633344544984;
            } else if ((sk.includes('-XXL-') && sk.includes('-LIGR')) || (sk.includes('/XXL') && sk.includes('LIGHT'))) {
              additionalProId = 44934136824024;
            } else if ((sk.includes('-XXL-') && sk.includes('-DAGR'))|| (sk.includes('/XXL') && sk.includes('DARK'))) {
              additionalProId = 44934136856792;
            }    

            var yesSelected = $('.elehide-planter-post-required').find('input:checked').val();
            yesSelected = yesSelected.toLowerCase();
            if (yesSelected == 'no') {
              that.success(product);
            } else {
              var pid = $('#productidkit').val();
              var quantityy = parseInt($('#Quantity-'+pid).val());
              var qt = 1;
              qt = qt * quantityy;
                            
              var finalTy = 'form_type=product'+'&id='+additionalProId+'&quantity='+ qt;

              theme.cart.addItemFromForm(finalTy)
              .then(function(product2) {
                setTimeout(() => {
                    if (product2) {
                      that.success(product2);}
                    if (product) {
                      that.success(product);}
                    }, 200);
              }.bind(this))
              .catch(function(XMLHttpRequest) {
                that.error(XMLHttpRequest)
              }.bind(this))
              .always(function() {
                status.loading = false;
                that.$addToCart.removeClass('btn--loading');
              }.bind(this));
            }
          }
          else if ($('#templatesuffix').val() == 'gates-kit') {
            // Gates Kit products
            this.$addToCart.addClass('btn--loading');

            status.loading = true;
            var that = this;
            var time = 500;
            var lenplanters = $('.elehide-gate-post-required').length;

            var yesSelected = $('.elehide-gate-post-required').find('input:checked').val();
            yesSelected = yesSelected.toLowerCase();
            if (lenplanters == 0 || yesSelected == 'no') {
              if ((addwith == 'true' && idbespoke) || addadditional_frame_handle == true) {
                if (addadditional_frame_handle) {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: finalTy
                })
                .then(response => {
                    status.loading = false;
                    this.$addToCart.removeClass('btn--loading');
                  that.success(product);
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
                } else {
                
                  theme.cart.addItemFromForm(finalTy)
                  .then(function(product1) {
                    that.success(product);
                    this.success(product1);
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                    this.error(XMLHttpRequest)
                  }.bind(this))
                  .always(function() {
                    status.loading = false;
                    this.$addToCart.removeClass('btn--loading');
                  }.bind(this));
                }
              } else {
                that.success(product);
              }
            } else {
              var freecartPostId = '';
              var incartPost = product.title;
              
              var isBun = $('.elehide-gate-post-required').find('input:checked').attr('da-val');
              
              var pid = $('#productidkit').val();
              var quantityy = parseInt($('#Quantity-'+pid).val());
              var qt = 1;
              qt = qt * quantityy;
                            
              var finalTy = 'form_type=product'+'&id='+isBun+'&quantity='+ (qt * 2);

              theme.cart.addItemFromForm(finalTy)
              .then(function(product2) {
                setTimeout(() => {
                    if (product2) {
                      if ((addwith == 'true' && idbespoke) || addadditional_frame_handle == true) {
                        
                        const isValidJSON = str => {
                                try {
                                  JSON.parse(str);
                                  return true;
                                } catch (e) {
                                  return false;
                                }
                              };
                        
                        if (isValidJSON(finalTy2)) {
                          fetch(window.Shopify.routes.root + 'cart/add.js', {
                          method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: finalTy2
                          })
                          .then(response => {
                            status.loading = false;
                            this.$addToCart.removeClass('btn--loading');
                            that.success(product);
                          })
                          .catch((error) => {
                            console.error('Error:', error);
                          });
                        } else {                        
                          theme.cart.addItemFromForm(finalTy2)
                          .then(function(product1) {
                            that.success(product2);
                            this.success(product1);
                          }.bind(this))
                          .catch(function(XMLHttpRequest) {
                            this.error(XMLHttpRequest)
                          }.bind(this))
                          .always(function() {
                            status.loading = false;
                            this.$addToCart.removeClass('btn--loading');
                          }.bind(this));
                        }
                      }
                    }
                    if (product) {
                      that.success(product);}
                    }, 200);
              }.bind(this))
              .catch(function(XMLHttpRequest) {
                that.error(XMLHttpRequest)
              }.bind(this))
              .always(function() {
                status.loading = false;
                that.$addToCart.removeClass('btn--loading');
              }.bind(this));
            }
          }
          else if ($('#templatesuffix').val() == 'kit' || producttags.includes('by-type_decorative-screen-fence') || producttags.includes('bin-screen')) {
            // Kit products
            this.$addToCart.addClass('btn--loading');

            status.loading = true;
            var that = this;
            var time = 500;
            var lenplanters = $('.additionalproduct').length;

            var currentHandle = $('#ProductSection-'+product.product_id).attr('data-product-handle');
            
            if (lenplanters == 0) {
              that.success(product);
            } else {
              var freecartPostId = '';
              var incartPost = product.title;
              if (producttags.includes('bin-screen')) {}
              else if (producttags.includes('post-type_composite')) {
                    if (incartPost.includes('180x30cm') || incartPost.includes('180x40cm')) {
                      freecartPostId = 43541547450584;
                    } else if (incartPost.includes('60x120cm')) {
                      freecartPostId = 43541547647192;
                    } else if (incartPost.includes('120x60cm')) {
                      freecartPostId = 43541547516120;
                    } else if (incartPost.includes('180x90cm')) {
                      freecartPostId = 43541547581656;
                    } else if (incartPost.includes('90x180cm')) {
                      freecartPostId = 43541547778264;
                    } else if (incartPost.includes('120x180cm')) {
                      freecartPostId = 43541547778264;
                    } else if (incartPost.includes('120x120cm')) {
                      freecartPostId = 43541547647192;
                    } 
               
                if (incartPost.includes('/ Black') || producttags.includes('slat-colour_Black')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541547909336;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541547843800;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541547778264;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541547712728;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541547647192;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541547581656;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541547516120;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541547450584;
                  }   
                }
                else if (incartPost.includes('/ Mid Grey')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541574156504;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541574123736;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541574090968;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541574058200;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541573992664;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541573959896;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541573927128;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541573894360;
                  }   
                }
                else if (incartPost.includes('/ Dark Grey')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541554266328;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541554233560;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541554200792;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541554168024;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541554135256;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541554102488;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541554069720;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541554036952;
                  }   
                }
                else if (incartPost.includes('/ Light Grey')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541555904728;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541555871960;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541555839192;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541555806424;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541555773656;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541555740888;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541555708120;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541555675352;
                  }   
                }
                else if (incartPost.includes('/ Dark Oak')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541547942104;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541547876568;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541547811032;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541547745496;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541547679960;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541547614424;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541547548888;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541547483352;
                  }   
                }
                else if (incartPost.includes('/ Light Oak')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541552660696;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541552627928;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541552595160;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541552562392;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541552529624;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541552496856;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541552464088;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541552431320;
                  }   
                }
                else if (incartPost.includes('/ Light Stone')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43541556855000;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43541556822232;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43541556789464;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43541556756696;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43541556723928;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43541556691160;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43541556658392;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43541556625624;
                  }   
                }
                else if (incartPost.includes('/ Mid Brown')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43543665082584;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43543665017048;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43543664951512;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43543664885976;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43543664820440;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43543664754904;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43543664689368;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43543664623832;
                  }   
                }
                else if (incartPost.includes('/ Teak')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 43543665049816;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43543664984280;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43543664918744;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43543664853208;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43543664787672;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43543664722136;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43543664656600;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43543664591064;
                  }   
                }
                else if (incartPost.includes('/ Anthracite')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 44891694596312;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 44891694563544;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 44891694530776;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 44891694498008;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 44891694465240;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 44891694432472;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 44891694399704;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 44891694366936;
                  }   
                }
                else if (incartPost.includes('/ Mid Stone')) {
                  if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                    freecartPostId = 44578268283096;
                  } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 44578268250328;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 44578268217560;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 44578268184792;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 44578268152024;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 44578268119256;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 44578268086488;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 44578268053720;
                  }   
                }
                if (incartPost.includes('cm BG') || incartPost.includes('cm-BG')) {
                  if (incartPost.includes('/ Black') || incartPost.includes('Black /') || incartPost.includes('- Black') || incartPost.includes('Black -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364073688;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541547909336;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541547843800;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541547712728;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541547647192;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541547581656;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541547516120;
                    } 
                  }
                  else if (incartPost.includes('/ Mid Grey') || incartPost.includes('Mid Grey /') || incartPost.includes('- Mid Grey') || incartPost.includes('Mid Grey -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364270296;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541574156504;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541574123736;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541574058200;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541573992664;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541573959896;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541573927128;
                    } 
                  }
                  else if (incartPost.includes('/ Dark Grey') || incartPost.includes('Dark Grey /') || incartPost.includes('- Dark Grey') || incartPost.includes('Dark Grey -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364171992;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541554266328;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541554233560;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541554168024;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541554135256;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541554102488;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541554069720;
                    }   
                  }
                  else if (incartPost.includes('/ Light Grey') || incartPost.includes('Light Grey /') || incartPost.includes('- Light Grey') || incartPost.includes('Light Grey -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364204760;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541555904728;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541555871960;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541555806424;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541555773656;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541555740888;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541555708120;
                    }  
                  }
                  else if (incartPost.includes('/ Dark Oak') || incartPost.includes('Dark Oak /') || incartPost.includes('- Dark Oak') || incartPost.includes('Dark Oak -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364106456;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541547942104;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541547876568;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541547745496;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541547679960;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541547614424;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541547548888;
                    }  
                  }
                  else if (incartPost.includes('/ Light Oak') || incartPost.includes('Light Oak /') || incartPost.includes('- Light Oak') || incartPost.includes('Light Oak -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364139224;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541552660696;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541552627928;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541552562392;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541552529624;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541552496856;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541552464088;
                    }  
                  }
                  else if (incartPost.includes('/ Light Stone') || incartPost.includes('Light Stone /') || incartPost.includes('- Light Stone') || incartPost.includes('Light Stone -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364237528;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43541556855000;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43541556822232;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43541556756696;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43541556723928;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43541556691160;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43541556658392;
                    } 
                  }
                  else if (incartPost.includes('/ Mid Brown') || incartPost.includes('Mid Brown /') || incartPost.includes('- Mid Brown') || incartPost.includes('Mid Brown -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364335832;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43543665082584;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43543665017048;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43543664885976;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43543664820440;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43543664754904;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43543664689368;
                    } 
                  }
                  else if (incartPost.includes('/ Teak') || incartPost.includes('Teak /') || incartPost.includes('- Teak') || incartPost.includes('Teak -')) {
                    if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                      freecartPostId = 43659364303064;
                    } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                      freecartPostId = 43543665049816;
                    } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                      freecartPostId = 43543664984280;
                    } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                      freecartPostId = 43543664853208;
                    } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                      freecartPostId = 43543664787672;
                    } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                      freecartPostId = 43543664722136;
                    } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                      freecartPostId = 43543664656600;
                    }   
                  }
                }
                
              }
              else {
                if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                  freecartPostId = 39799775985835;
                } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                  freecartPostId = 39799776018603;
                } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                  freecartPostId = 39799776051371;
                } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                  freecartPostId = 39799776084139;
                } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                  freecartPostId = 39799776116907;
                } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                  freecartPostId = 39799776149675;
                } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                  freecartPostId = 39799776182443;
                }

                if (incartPost.includes('cm BG') || incartPost.includes('cm-BG')) {
                  if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 42440592589016; 
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 42440586002648;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 39799775985835;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 39799776051371;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 39799776084139;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 39799776116907;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 39799776149675;
                  }
                }
              }

              // FOR ALUMINIUM SLAT PRODUCTS
              var producttagsL = producttags.toLowerCase();
              var incartPostL = incartPost.toLowerCase();     
              if ((producttagsL.includes('slat-type_aluminium') || producttagsL.includes('post-type_aluminium')) && incartPostL.includes('/ grey')) {
                if (incartPost.includes('270cm') || incartPost.includes('275cm')) {
                  freecartPostId = 43761175494872;
                } else if (incartPost.includes('250cm') || incartPost.includes('240cm') || incartPost.includes('245cm')) {
                  freecartPostId = 43761175527640;
                } else if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                  freecartPostId = 43761175560408;
                } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                  freecartPostId = 43761175593176;
                } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                  freecartPostId = 43761175625944;
                } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                  freecartPostId = 43761175658712;
                } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                  freecartPostId = 43761175691480;
                } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                  freecartPostId = 43761175724248;
                } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                  freecartPostId = 43761175757016;
                }

                if (incartPost.includes('cm BG') || incartPost.includes('cm-BG')) {
                  if (incartPost.includes('220cm') || incartPost.includes('210cm') || incartPost.includes('215cm')) {
                    freecartPostId = 43761175494872;
                  } else if (incartPost.includes('190cm') || incartPost.includes('180cm') || incartPost.includes('185cm')) {
                    freecartPostId = 43761175527640;
                  } else if (incartPost.includes('160cm') || incartPost.includes('150cm') || incartPost.includes('155cm')) {
                    freecartPostId = 43761175560408;
                  } else if (incartPost.includes('130cm') || incartPost.includes('120cm') || incartPost.includes('125cm')) {
                    freecartPostId = 43761175625944;
                  } else if (incartPost.includes('100cm') || incartPost.includes('90cm') || incartPost.includes('95cm')) {
                    freecartPostId = 43761175658712;
                  } else if (incartPost.includes('70cm') || incartPost.includes('60cm') || incartPost.includes('65cm')) {
                    freecartPostId = 43761175691480;
                  } else if (incartPost.includes('30cm') || incartPost.includes('35cm') || incartPost.includes('40cm')) {
                    freecartPostId = 43761175724248;
                  }
                }
              }
              
              var isBun = $('.additionalproduct').find('input:checked').attr('da-val');
              
              var pid = $('#productidkit').val();
              var quantityy = parseInt($('#Quantity-'+pid).val());
              var qt = 1;
              qt = qt * quantityy;
                            
              var finalTy = 'form_type=product'+'&id='+isBun+'&quantity='+ (qt + 1);
              var finalTy2 = 'form_type=product'+'&id='+freecartPostId+'&quantity='+1;

              let incartPostLower = incartPost.toLowerCase();
              // if (incartPostLower.includes('bespoke ral colour')) {
              //   finalTy2 = 'form_type=product'+'&id[]='+freecartPostId+'&id[]='+45334109683928+'&quantity='+1;
              // }

              if(currentHandle.includes('-2-bin-screen')) {
                qt = 4;
                if (quantityy) {
                  qt = qt * quantityy;
                }
              }  else if(currentHandle.includes('-3-bin-screen')) {
                qt = 5;
                if (quantityy) {
                  qt = qt * quantityy;
                }
              } else if(currentHandle.includes('-4-bin-screen')) {
                qt = 6;
                if (quantityy) {
                  qt = qt * quantityy;
                }
              }
              
              if(currentHandle.includes('bin-screen')) {            
                finalTy = 'form_type=product'+'&id='+isBun+'&quantity='+ (qt);
                finalTy2 = 'form_type=product'+'&id='+freecartPostId+'&quantity='+1;
              }
              var finalTy3;
              var lightengingvalue = $('.type_of_power_lightening:checked').val();
              var idlumi = '';
              var isLighteningSelected = $('.dflx_lumifence input:checked').val();
              if (lightengingvalue && isLighteningSelected == 'Yes') {
                if (lightengingvalue && lightengingvalue.includes('solar')) {
                  idlumi = $('.solar_lumifence[data-qty="'+quantityy+'"]').val();
                } else {
                  idlumi = $('.mains_lumifence[data-qty="'+quantityy+'"]').val();
                }
  
                finalTy3 = 'form_type=product'+'&id='+idlumi+'&quantity='+1;
              }
              if (isBun) {
                var product1, product2;
                theme.cart.addItemFromForm(finalTy)
                .then(function(product1) {
                  setTimeout(() => {
                      if (product1) {
                        that.success(product1);
                        // product1 = product1;
                      }

                    theme.cart.addItemFromForm(finalTy2)
                    .then(function(product2) {
                      setTimeout(() => {
                        if (product2) {
                          that.success(product2);}
                          // product2 = product2;
                        if (product) {
                          that.success(product);}

                        // Lumifence add to cart
                        if (finalTy3) {
                    theme.cart.addItemFromForm(finalTy3)
                    .then(function(product3) {
                      setTimeout(() => {
                        that.success(product3);
                      }, 200);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                      that.error(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                      status.loading = false;
                      that.$addToCart.removeClass('btn--loading');
                    }.bind(this));
                        }

                        
                        }, 200);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                      that.error(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                      status.loading = false;
                      that.$addToCart.removeClass('btn--loading');
                    }.bind(this));

                    
                  }, 200);
                }.bind(this))
                .catch(function(XMLHttpRequest) {
                  that.error(XMLHttpRequest)
                }.bind(this))
                .always(function() {
                  status.loading = false;
                  that.$addToCart.removeClass('btn--loading');
                }.bind(this));
              } else {
                    theme.cart.addItemFromForm(finalTy2)
                    .then(function(product2) {
                      setTimeout(() => {
                          if (product2) {
                            that.success(product2);}
                          if (product) {
                            that.success(product);}
                          }, 200);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                      that.error(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                      status.loading = false;
                      that.$addToCart.removeClass('btn--loading');
                    }.bind(this));
              }
            }
          } 
//           HERE------------------------------------------------------
        else if (addwith == 'true') {
          theme.cart.addItemFromForm(finalTy)
          .then(function(product) {
            this.success(product);
            this.success(product1);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
//           HERE------------------------------------------------------
        } else {
         status.loading = false;
         this.$addToCart.removeClass('btn--loading');
          this.success(product1);
        }
      }.bind(this))
      .catch(function(XMLHttpRequest) {
        status.loading = false;
        this.$addToCart.removeClass('btn--loading');
        this.error(XMLHttpRequest)
    }.bind(this))
    .always(function() {
      var lastvisitedbundle = localStorage.getItem("lastvisitedbundle");
      status.loading = false;
      this.$addToCart.removeClass('btn--loading');
      

        // if ($('body').hasClass('ele_insuslat_trim_batten')) {
        //   setTimeout(() => {
        //   console.log("inininininininininininini");
        //       $('body').trigger('added.ajaxProduct', this.$addToCart);
        //   },1000)
        // }

    }.bind(this));
  },
 success: function(product) {
    this.$form.find('.errors').remove();
    $('body').trigger('added.ajaxProduct', this.$addToCart);
  },

    error: function(XMLHttpRequest) {
      this.$form.find('.errors').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
});

return ProductForm;
})();

theme.collapsibles = (function() {

  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height'
  };

  var namespace = '.collapsible';

  var isTransitioning = false;

  function init() {
    $(selectors.trigger).each(function() {
      var $el = $(this);
      var state = $el.hasClass(classes.open);
      $el.attr('aria-expanded', state);
    });

    // Event listeners (hack for modals)
    $('body, .modal__inner')
    .off(namespace)
    .on('click' + namespace, selectors.trigger, function() {

      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var $el = $(this);
      var isOpen = $el.hasClass(classes.open);
      var moduleId = $el.attr('aria-controls');
      var $module = $('#' + moduleId);
      var height = $module.find(selectors.moduleInner).outerHeight();
      var isAutoHeight = $el.hasClass(classes.autoHeight);

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight($module, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      $el
      .attr('aria-expanded', !isOpen)
      .toggleClass(classes.open, !isOpen);

      setTransitionHeight($module, height, isOpen, isAutoHeight);
    });
  }

  function setTransitionHeight($module, height, isOpen, isAutoHeight) {
    $module
    .removeClass(classes.hide)
    .prepareTransition()
    .css('height', height)
    .toggleClass(classes.open, !isOpen);

    if (!isOpen && isAutoHeight) {
      var o = $module;
      window.setTimeout(function() {
        o.css('height','auto');
        isTransitioning = false;
      }, 350);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init
  };
})();

theme.headerNav = (function() {

  var $parent = $(document.documentElement).add('body');
  var $page = $('#MainContent');
  var selectors = {
    wrapper: '.header-wrapper',
    siteHeader: '.site-header',
    searchBtn: '.js-search-header',
    closeSearch: '.js-search-header-close',
    searchContainer: '.site-header__search-container',
    logoContainer: '.site-header__logo',
    logo: '.site-header__logo img',
    navigation: '.site-navigation',
    megamenu: '.megamenu',
    navContainerWithLogo: '.header-item--logo',
    navItems: '.site-nav__item',
    navLinks: '.site-nav__link',
    navLinksWithDropdown: '.site-nav__link--has-dropdown',
    navDropdownLinks: '.site-nav__dropdown-link--second-level'
  };

  var classes = {
    hasDropdownClass: 'site-nav--has-dropdown',
    hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
    dropdownActive: 'is-focused',
    overlaidBodyClass: 'overlaid-header',
    stickyBodyClass: 'sticky-header'
  };

  var config = {
    namespace: '.siteNav',
    wrapperOverlayed: false,
    overlayedClass: 'is-light',
    stickyEnabledClass: 'header-wrapper--sticky',
    stickyEnabled: false,
    stickyActive: false,
    stickyInitialized: false,
    forceStopSticky: false,
    stickyClass: 'site-header--stuck',
    openTransitionClass: 'site-header--opening',
    lastScroll: 0
  };

  // Elements used in resize functions, defined in init
  var $window;
  var $navContainerWithLogo;
  var $logoContainer;
  var $nav;
  var $wrapper;
  var $siteHeader;

  function init() {
    $window = $(window);
    $navContainerWithLogo = $(selectors.navContainerWithLogo);
    $logoContainer = $(selectors.logoContainer);
    $nav = $(selectors.navigation);
    $wrapper = $(selectors.wrapper);
    $siteHeader = $(selectors.siteHeader);

    config.wrapperOverlayed = theme.settings.overlayHeader = $wrapper.hasClass(config.overlayedClass);
    config.stickyEnabled = $siteHeader.data('sticky');

    if (config.stickyEnabled) {
      stickyHeaderCheck();
      $window.on('resize' + config.namespace, $.debounce(150, stickyHeaderCheck));
    }

    if (config.wrapperOverlayed) {
      $('body').addClass(classes.overlaidBodyClass);
    }

    accessibleDropdowns();
    searchDrawer();
  }

  function unload() {
    $(window).off(config.namespace);
    $(selectors.searchBtn).off(config.namespace);
    $(selectors.closeSearch).off(config.namespace);
    $parent.off(config.namespace);
    $(selectors.navLinks).off(config.namespace);
    $(selectors.navDropdownLinks).off(config.namespace);
  }

  function searchDrawer() {
    $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
      evt.preventDefault();
      openSearchDrawer();
    });

    $(selectors.closeSearch).on('click' + config.namespace, function() {
      closeSearchDrawer();
    });
  }

  function openSearchDrawer() {
    $(selectors.searchContainer).addClass('is-active');
    $parent.addClass('js-drawer-open--search');

    theme.a11y.trapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search',
      $elementToFocus: $(selectors.searchContainer).find('input')
    });

    // If sticky is enabled, scroll to top on mobile when close to it
    // so you don't get an invisible search box
    if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
      window.scrollTo(0,0);
    }

    // Bind events
    theme.a11y.lockMobileScrolling(config.namespace);

    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeSearchDrawer();
      return false;
    });

    $parent.on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeSearchDrawer();
      }
    });
  }

  function closeSearchDrawer() {
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    $parent.removeClass('js-drawer-open--search').off(config.namespace);
    $(selectors.searchContainer).removeClass('is-active');

    theme.a11y.removeTrapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search'
    });

    theme.a11y.unlockMobileScrolling(config.namespace);
    $page.off('click' + config.namespace);
    $parent.off('keyup' + config.namespace);
  }

  function accessibleDropdowns() {
    var hasActiveDropdown = false;
    var hasActiveSubDropdown = false;
    var closeOnClickActive = false;

    // Touch devices open dropdown on first click, navigate to link on second
    if (theme.config.isTouch) {
      $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
        var $el = $(this);
        var $parentItem = $el.parent();
        if (!$parentItem.hasClass(classes.dropdownActive)) {
          evt.preventDefault();
          closeDropdowns();
          openFirstLevelDropdown($el);
        } else {
          window.location.replace($el.attr('href'));
        }
      });

      $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
        var $el = $(this);
        var $parentItem = $el.parent();

        // Open third level menu or go to link based on active state
        if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeThirdLevelDropdown();
            openSecondLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        } else {
          // No third level nav, go to link
          window.location.replace($el.attr('href'));
        }
      });

      // tapping outside of the dropdown closes it
      $('body').on('touchend' + config.namespace, function() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });

      // Exception to above: clicking anywhere on the megamenu content will NOT close it
      $(selectors.megamenu).on('touchend' + config.namespace, function(evt) {
        evt.stopImmediatePropagation();
      });
    }

    $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
      if (hasActiveDropdown) {
        closeSecondLevelDropdown();
      }

      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      openFirstLevelDropdown($(this));
    });

    // Force remove focus on sitenav links because focus sometimes gets stuck
    $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
      closeSecondLevelDropdown();
      closeThirdLevelDropdown();
    });

    // Open/hide sub level dropdowns
    $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      openSecondLevelDropdown($(this), true);
    });

    // Private dropdown methods
    function openFirstLevelDropdown($el) {
      var $parentItem = $el.parent();
      if ($parentItem.hasClass(classes.hasDropdownClass)) {
        $parentItem.addClass(classes.dropdownActive);
        hasActiveDropdown = true;
      }

      if (!theme.config.isTouch) {
        if (!closeOnClickActive) {
          var eventType = theme.config.isTouch ? 'touchend' : 'click';
          closeOnClickActive = true;
          $('body').on(eventType + config.namespace, function() {
            closeDropdowns();
            $('body').off(config.namespace);
            closeOnClickActive = false;
          });
        }
      }
    }

    function openSecondLevelDropdown($el, skipCheck) {
      var $parentItem = $el.parent();
      if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
        $parentItem.addClass(classes.dropdownActive);
        hasActiveSubDropdown = true;
      }
    }

    function closeDropdowns() {
      closeSecondLevelDropdown();
      closeThirdLevelDropdown();
    }

    function closeSecondLevelDropdown() {
      $(selectors.navItems).removeClass(classes.dropdownActive);
    }

    function closeThirdLevelDropdown() {
      $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
    }
  }

  function stickyHeaderCheck() {
    // Disable sticky header if any mega menu is taller than window
    theme.config.stickyHeader = doesMegaMenuFit();

    if (theme.config.stickyHeader) {
      config.forceStopSticky = false;
      stickyHeaderSetup();
    } else {
      config.forceStopSticky = true;
    }
  }

  function stickyHeaderSetup() {
    if (!config.stickyInitialized) {
      $parent.addClass(classes.stickyBodyClass);
      $siteHeader.wrap('<div class="site-header-sticky"></div>');

      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();
      }, 200);

      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
      $window.on('scroll' + config.namespace, $.throttle(20, stickyHeaderScroll));
    }

    config.stickyInitialized = true;
  }

  function doesMegaMenuFit() {
    var largestMegaNav = 0;
    $(selectors.megamenu).each(function() {
      var h = $(this).outerHeight();
      if (h > largestMegaNav) {
        largestMegaNav = h;
      }
    });

    // 120 ~ space of visible header when megamenu open
    if (window.innerHeight < (largestMegaNav + 120)) {
      return false;
    }

    return true;
  }

  function stickyHeaderHeight() {
    var height = $siteHeader.outerHeight(true);
    var $stickyHeader = $('.site-header-sticky').css('height', height);

    // Also update top position of sticky sidebar
    if ($('.grid__item--sidebar').length) {
      $('.grid__item--sidebar').css('top', height + 10);
    }
  }

  function stickyHeaderScroll() {
    if (config.forceStopSticky) {
      return;
    }

    var scroll = $window.scrollTop();
    var threshold = 150;

    if (scroll > threshold) {
      if (config.stickyActive) {
        return;
      }

      config.stickyActive = true;

      $siteHeader.addClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.removeClass(config.overlayedClass);
      }

      // Add open transition class after element is set to fixed
      // so CSS animation is applied correctly
      setTimeout(function() {
        $siteHeader.addClass(config.openTransitionClass);
      }, 100);
    } else {
      if (!config.stickyActive) {
        return;
      }

      config.stickyActive = false;

      $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.addClass(config.overlayedClass);
      }
    }

    config.lastScroll = scroll;
  }

  // If the header setting to overlay the menu on the collection image
  // is enabled but the collection setting is disabled, we need to undo
  // the init of the sticky nav
  function disableOverlayHeader() {
    $(selectors.wrapper)
    .removeClass(config.stickyEnabledClass)
    .removeClass(config.overlayedClass);

    $('body').removeClass(classes.overlaidBodyClass);
    config.wrapperOverlayed = false;
  }

  return {
    init: init,
    disableOverlayHeader: disableOverlayHeader,
    unload: unload
  };
})();

theme.Slideshow = (function() {
  this.$slideshow = null;

  var classes = {
    next: 'is-next',
    init: 'is-init',
    animateOut: 'animate-out',
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    allSlides: 'slick-slide',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el, args) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      fade: args.fade ? true : false,
      speed: args.speed ? args.speed : 500,
      draggable: true,
      touchThreshold: 5,
      pauseOnHover: false,
      autoplay: args.autoplay ? true : false,
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.off('beforeChange');
    this.$slideshow.off('afterSlideChange');
    this.$slideshow.on('init', this.init.bind(this));
    this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
    this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));

    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this._togglePause.bind(this));
  }

  slideshow.prototype = $.extend({}, slideshow.prototype, {
    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      this.$slideshow.addClass(classes.init);
      this._a11y();
      this._clonedLazyloading();
    },
    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
    },
    afterSlideChange: function(event, slick, currentSlide) {
      var $slider = slick.$slider;
      var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
    },
    destroy: function() {
      this.$slideshow.slick('unslick');
    },

    // Playback
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(classes.pauseButton).addClass('is-paused');
    },
    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(classes.pauseButton).removeClass('is-paused');
    },
    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },

    // Helpers
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },
    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },
    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },
    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },

    // a11y fixes
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      if (!$list) {
        return;
      }

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(classes.wrapper).on('focusin', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));

      // Resume autoplay
      $(classes.wrapper).on('focusout', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    },

    // Make sure lazyloading works on cloned slides
    _clonedLazyloading: function() {
      var $slideshow = this.$slideshow;

      $slideshow.find('.slick-slide').each(function(index, el) {
        var $slide = $(el);
        if ($slide.hasClass('slick-cloned')) {
          var slideId = $slide.data('id');
          var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

          // Get inline style attribute from non-cloned slide with arbitrary timeout
          // so the image is loaded
          setTimeout(function() {
            var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

            if (loadedImageStyle) {
              $slideImg.attr('style', loadedImageStyle);
            }

          }, this.settings.autoplaySpeed / 1.5);

        }
      }.bind(this));
    }
  });

  return slideshow;
})();

theme.announcementBar = (function() {
  var slideCount = 0;
  var compact = false;
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    touchThreshold: 20,
    slidesToShow: 1
  };
  var $slider;

  function init() {
    $slider = $('#AnnouncementSlider2');
    if (!$slider.length) {
      return;
    }

    slideCount = $slider.data('block-count');
    compact = $slider.data('compact-style');

    var desktopOptions = $.extend({}, defaults, {
      slidesToShow: compact ? 1 : slideCount,
      slidesToScroll: 1
    });

    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1
    });

    if (theme.config.bpSmall) {
      initSlider($slider, mobileOptions);
    } else {
      initSlider($slider, desktopOptions);
    }

    $('body').on('matchSmall', function() {
      initSlider($slider, mobileOptions);
    }.bind(this));

    $('body').on('matchLarge', function() {
      initSlider($slider, desktopOptions);
    }.bind(this));
  }

  function initSlider($slider, args) {
    if (isInitialized($slider)) {
      $slider.slick('unslick');
    }
    $slider.slick(args);
  }

  function isInitialized($slider) {
    return $slider.length && $slider.hasClass('slick-initialized');
  }

  // Go to slide if selected in the editor
  function onBlockSelect(id) {
    var $slide = $('#AnnouncementSlide-' + id);
    if ($slider.length) {
      $slider.slick('slickPause');
    }
    if ($slide.length) {
      $slider.slick('slickGoTo', $slide.data('index'));
    }
  }

  function onBlockDeselect(id) {
    if ($slider.length && isInitialized($slider)) {
      $slider.slick('slickPlay');
    }
  }

  function unload() {
    if (isInitialized($slider)) {
      $slider.slick('unslick');
    }
  }

  return {
    init: init,
    onBlockSelect: onBlockSelect,
    onBlockDeselect: onBlockDeselect,
    unload: unload
  };
})();

theme.predictiveSearch = (function() {
  var currentString = '';
  var isLoading = false;
  var searchTimeout;
  var namespace = '.predictive';

  var selectors = {
    form: '#HeaderSearchFormDesk',
    input: 'input[type="search"]',
    wrapper: '.predictive-results',

    searchButton: '[data-predictive-search-button]',

    resultDiv: '#PredictiveResultsDesk',
    resultTemplate: '#PredictiveTemplate'
  };
  var newWindowWidth = $(window).width();
  if (newWindowWidth < 600) {
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '.predictive-results',

      searchButton: '[data-predictive-search-button]',

      resultDiv: '#PredictiveResults',
      resultTemplate: '#PredictiveTemplate'
    };
  }
  var classes = {
    isActive: 'predicitive-active'
  };

  var keys = {
    up_arrow: 38,
    down_arrow: 40,
    tab: 9
  };

  function init() {
    // Only some languages support predictive search
    if (document.getElementById('shopify-features')) {
      var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
      if (!supportedShopifyFeatures.predictiveSearch) {
        return;
      }
    }

    $(selectors.form).attr('autocomplete', 'off');
    $(selectors.form).on('submit' + namespace, submitSearch);

    $(selectors.input, selectors.form).on('keyup' + namespace, handleKeyup);
    $(selectors.searchButton, selectors.wrapper).on('click' + namespace, triggerSearch);

    // Prep handlebars template
    var source = $(selectors.resultTemplate).html();
    resultTemplate = Handlebars.compile(source);
  }

  function reset() {
    $(selectors.wrapper).addClass('hide');
    clearTimeout(searchTimeout);
  }

  function triggerSearch() {
    $(selectors.form).trigger('submit');
  }

  // Append * wildcard to search
  function submitSearch(evt) {
    var $form = $(this);
    evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

    var data = $form.serializeArray().reduce(function(obj, item) {
      obj[item.name] = item.value;
      return obj;
    }, {});

    if (data.q) {
      data.q += '*';
    }

    var query = $.param(data);

    window.location.href = '/search?' + query;
    return false;
  }

  function handleKeyup(evt) {
    if (evt.keyCode === keys.up_arrow) {
      navigationEvent(evt, 'up');
      return;
    }

    if (evt.keyCode === keys.down_arrow) {
      navigationEvent(evt, 'down');
      return;
    }

    if (evt.keyCode === keys.tab) {
      return;
    }

    search();
  }

  function search() {
    var keyword = $(selectors.input, selectors.form).val();

    if (keyword === '') {
      reset();
      return;
    }

    var q = _normalizeQuery(keyword);

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(
      function () {
        predictQuery(q);
      }.bind(this),
      500
    );
  }

  function predictQuery(q) {
    if (isLoading) {
      return;
    }

    // Do not re-search the same thing
    if (currentString === q) {
      return;
    }

    currentString = q;
    isLoading = true;

    jQuery.getJSON('/search/suggest.json', {
      "q": q,
      "resources": {
        "type": theme.settings.predictiveSearchType,
        "limit": 4,
        "options": {
          "unavailable_products": "last",
          "fields": "title,product_type,tag,variants.title,vendor"
        }
      }
    }).done(function(response) {
      isLoading = false;
      var data = {};
      var resultCount = 0;

      $(selectors.wrapper).removeClass('hide');

      var resultTypes = Object.entries(response.resources.results);

      for (var i = resultTypes.length - 1; i >= 0; i--) {
        var obj = resultTypes[i];
        var type = obj[0];
        var results = obj[1];
        resultCount += results.length;

        switch(type) {
          case 'products':
            data[type] = buildProducts(results);
            break;
          default:
            data[type] = parseResultImages(results);
            break;
        }
      }

      if (resultCount === 0) {
        reset();
      }

      // Append result markup
      $(selectors.resultDiv).empty().append(resultTemplate(data));
    });
  }

  function buildProducts(results) {
    var products = [];

    for (var i = results.length - 1; i >= 0; i--) {
      var product = results[i];
      var titleip = product.title;

      var ahandle = '#v-'+product.handle;
      var bundletitle = $(ahandle).val();
      if (bundletitle && bundletitle != '') {
        titleip = bundletitle;
      }

      var new_product = {
        title: titleip,
        url: product.url,
        image: theme.Images.lazyloadImagePath(product.image),
        vendor: product.vendor,
        price: theme.Currency.formatMoney(product.price),
        compare_price_max: theme.Currency.formatMoney(product.compare_at_price_max),
        on_sale: parseInt(product.compare_at_price_max) > parseInt(product.price),
        custom_label: _checkCustomLabel(product.tags)
      };

      if (product.id != 7800166678744 && product.id != 7536112599256 && product.id != 6674104975531 && product.id != 6597810454699 && product.id != 6597875499179 && product.id != 6685486579883 && product.id != 6685496279211 && product.id != 6685496574123 && product.id != 6685496836267 && product.id != 6685497262251
         && product.type != 'planter-additionala') {
        products.push(new_product);
      }
    }

    return products;
  }

  // Overwrite full sized image returned form API
  // with lazyloading-friendly path
  function parseResultImages(results) {
    for (var i = results.length - 1; i >= 0; i--) {
      if (!results[i].image) {
        continue;
      }

      var image = theme.Images.lazyloadImagePath(results[i].image);
      results[i].image = image;
    }

    return results;
  }

  function _checkCustomLabel(tags) {
    if (!tags.length) {
      return false;
    }

    for (var i = tags.length - 1; i >= 0; i--) {
      if (tags[i].indexOf('_label_') !== -1) {
        return tags[i].replace('_label_', '');
      }
    }

    return false;
  }

  function _normalizeQuery(string) {
    if (typeof string !== 'string') {
      return null;
    }

    return string
    .trim()
    .replace(/\ /g, '-')
    .toLowerCase();
  }

  function navigationEvent(evt, direction) {

  }

  return {
    init: init
  };
})();

theme.initQuickShop = function() {
  var ids = [];
  var $buttons = $('.quick-product__btn');

  $buttons.each(function() {
    var id = $(this).data('product-id');
    var modalId = 'QuickShopModal-' + id;
    var name = 'quick-modal-' + id;

    // If another identical modal exists, remove duplicates
    if (ids.indexOf(id) > -1) {
      $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
        if (i > 0) {
          $(this).remove();
        }
      });
      return;
    }

    new theme.Modals(modalId, name);
    ids.push(id);
  });
};

// Video modal will auto-initialize for any anchor link that points to YouTube
// MP4 videos must manually be enabled with:
//   - .product-video-trigger--mp4 (trigger button)
//   - .product-video-mp4-sound video player element (cloned into modal)
//     - see media.liquid for example of this
theme.videoModal = function() {
  var youtubePlayer = null;
  var videoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      branding: 0,
      cc_load_policy: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onPlayerReady
    }
  };

  var videoHolderId = 'VideoHolder';
  var activeVideo = false;

  var selectors = {
    videoHolder: '#' + videoHolderId,
    youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
    mp4Trigger: '.product-video-trigger--mp4',
    mp4Player: '.product-video-mp4-sound'
  };

  if (!$(selectors.youtube).length && !$(selectors.mp4Trigger).length) {
    return;
  }

  var modal = new theme.Modals('VideoModal', 'video-modal', {
    closeOffContentClick: true,
    solid: true
  });

  $(selectors.youtube).on('click', triggerYouTubeModal);
  $(selectors.mp4Trigger).on('click', triggerMp4Modal);

  // Handle closing video modal
  $('body').on('modalClose.VideoModal', function() {
    // Slight timeout so YouTube player is destroyed after the modal closes
    if (youtubePlayer && activeVideo === 'youtube') {
      setTimeout(function() {
        youtubePlayer.destroy();
      }, 500); // modal close css transition
    } else {
      emptyVideoHolder();
    }
  });

  function triggerYouTubeModal(evt) {
    emptyVideoHolder();

    evt.preventDefault();
    theme.LibraryLoader.load('youtubeSdk');

    if (theme.config.youTubeReady) {
      startYoutubeOnClick(evt);
    } else {
      $('body').on('youTubeReady', function() {
        startYoutubeOnClick(evt);
      });
    }
  }

  function triggerMp4Modal(evt) {
    emptyVideoHolder();

    var $el = $(evt.currentTarget);
    var $mp4Player = $el.next(selectors.mp4Player);

    $mp4Player.clone().removeClass('hide').appendTo(selectors.videoHolder);

    modal.open(evt);

    // Play new video element
    $(selectors.videoHolder).find('video')[0].play();

    activeVideo = 'mp4';
  }

  function startYoutubeOnClick(evt) {
    var $el = $(evt.currentTarget);
    var videoId = getYoutubeVideoId($el.attr('href'));

    var args = $.extend({}, videoOptions, {
      videoId: videoId
    });

    // Disable plays inline on mobile
    args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

    youtubePlayer = new YT.Player(videoHolderId, args);
    modal.open(evt);

    activeVideo = 'youtube';
  }

  function onPlayerReady(evt) {
    evt.target.playVideo();
  }

  function getYoutubeVideoId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }

  function emptyVideoHolder() {
    $(selectors.videoHolder).empty();
  }
};

theme.RecentlyViewed = (function() {
  var selectors = {
    template: '#RecentlyViewedProduct',
    outputContainer: '#RecentlyViewed-'
  };

  var init = false;

  function RecentlyViewed(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    this.namespace = '.recently-viewed' + sectionId;

    if (!$(selectors.template).length) {
      return;
    }

    // Lazyload API
    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
  };

  RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
    init: function() {
      if (init) {
        return;
      }

      init = true;

      if ($.isEmptyObject(theme.recentlyViewed.recent)) {
        // No previous history on page load, so bail
        return;
      }

      this.outputContainer = $(selectors.outputContainer + this.sectionId);
      this.handle = this.$container.attr('data-product-handle');

      // Request new product info via JS API
      var promises = [];
      for (handle in theme.recentlyViewed.recent) {
        promises.push(this.getProductInfo(handle));
      }

      Promise.all(promises).then(function(result) {
        this.setupOutput(result);
        this.captureProductDetails(result);
      }.bind(this), function(error) {
        console.warn('Theme | recently viewed products failed to load');
      });
    },

    checkVisibility: function() {
      if (theme.isElementVisible(this.$container, 600)) {
        this.init();
        $(window).off('scroll' + this.namespace);
      }
    },

    getProductInfo: function(handle) {
      return new Promise(function(resolve, reject) {
        if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
          resolve(theme.recentlyViewed.productInfo[handle]);
        } else {
          jQuery.getJSON('/products/'+ handle +'.js', function(product) {
            resolve(product);
          });
        }
      });
    },

    setupOutput: function(products) {
      var allProducts = [];
      var data = {};
      var limit = this.$container.attr('data-recent-count');

      var i = 0;
      for (key in products) {
        var product = products[key];
        // Ignore current product
        if (product.handle === this.handle) {
          continue;
        }

        i++;

        // New or formatted properties
        product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
        product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
        product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
        product.on_sale = product.compare_at_price > product.price;
        product.sold_out = !product.available;
        product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
        product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
        product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
        product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);

        // Unit pricing checks first variant
        var firstVariant = product.variants[0];
        if (firstVariant && firstVariant.unit_price) {
          var baseUnit = '';

          if (firstVariant.unit_price_measurement) {
            if (firstVariant.unit_price_measurement.reference_value != 1) {
              baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
            }
            baseUnit += firstVariant.unit_price_measurement.reference_unit;
          }

          product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
          if (baseUnit != '') {
            product.unit_price += '/' + baseUnit;
          }
        }

        allProducts.unshift(product);
      }

      data = {
        items: allProducts.slice(0, limit),
        grid_item_width: this.$container.attr('data-grid-item-class')
      };

      if (allProducts.length === 0) {
        return;
      }

      // Prep handlebars template
      var source = $(selectors.template).html();
      var template = Handlebars.compile(source);
      this.outputContainer.append(template(data));

      if (AOS) {
        AOS.refreshHard();
      }
    },

    captureProductDetails: function(products) {
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        theme.recentlyViewed.productInfo[product.handle] = product;
      }

      // Add data to session storage to reduce API requests later
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
      }
    },

    onUnload: function() {
      init = false;
      $('window').off(this.namespace);
    }
  });

  return RecentlyViewed;
})();

theme.parallaxSections = {};

theme.Parallax = (function() {
  var speed = 7; // higher is slower

  function parallax(el, args) {
    this.$container = $(el);
    this.namespace = args.namespace;

    if (!this.$container.length) {
      return;
    }

    if (args.desktopOnly) {
      this.desktopInit();
    } else {
      this.init(this.$container, args)
    }
  }

  parallax.prototype = $.extend({}, parallax.prototype, {
    init: function(desktopOnly) {
      var $window = this.$window = $(window);
      var elTop = this.$container.offset().top;

      $window.on('scroll' + this.namespace, function(evt) {
        var scrolled = $window.scrollTop();
        var shiftDistance = (elTop - scrolled) / speed;
        this.$container.css({
          'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
        });
      }.bind(this));

      // Reinit on resize
      $window.on('resize' + this.namespace, $.debounce(350, function() {
        $window.off(this.namespace);

        if (desktopOnly) {
          if (!theme.config.bpSmall) {
            this.init(true);
            return;
          }
        }

        this.init();
      }.bind(this)));
    },

    desktopInit: function() {
      if (!theme.config.bpSmall) {
        this.init(true);
      }

      $('body').on('matchSmall', function() {
        this.destroy();
      }.bind(this));

      $('body').on('matchLarge', function() {
        this.init(true);
      }.bind(this));
    },

    destroy: function() {
      this.$container.removeAttr('style');
      this.$window.off(this.namespace);
    }
  });

  return parallax;
})();

// Select-like popovers for currency and language selection
theme.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = $.extend({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== 27) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      $('body').addClass('unloading');
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();

theme.ProductMedia = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
        .closest(selectors.mediaGroup)
        .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);

    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (theme.config.isTouch) return;
      model.modelViewerUi.play();
    });

    model.$container
    .on('mediaHidden', function() {
      xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
      model.modelViewerUi.pause();
    })
    .on('xrLaunch', function() {
      model.modelViewerUi.pause();
    });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();


theme.collectionTemplate = (function() {
  var isAnimating = false;

  var selectors = {
    collectionGrid: '.collection-grid__wrapper',
    sidebar: '#CollectionSidebar',
    activeTagList: '.tag-list--active-tags',
    tags: '.tag-list a',
    filters: '.collection-filter'
  };

  var settings = {
    combineTags: $(selectors.sidebar).data('combine-tags')
  };

  var classes = {
    activeTag: 'tag--active',
    removeTagParent: 'tag--remove'
  };

  function init() {
    // Ajax pagination
    $(window).on('popstate', function(state) {
      if (state) {
        getNewCollectionContent(location.href);
      }
    });

    // Set mobile top value for filters if sticky header enabled
    if (theme.config.stickyHeader) {
      setFilterStickyPosition();
      $(window).on('resize', $.debounce(150, setFilterStickyPosition));
    }

    initTagClicks();
  }

  function initTagClicks() {
    $('body').on('click', selectors.tags, function(evt) {
      var $el = $(this);
      if (theme.FilterDrawer) {
        theme.FilterDrawer.close();
      }

      if ($el.hasClass('no-ajax')) {
        return;
      }

      evt.preventDefault();
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      var $el = $(evt.currentTarget);
      var $parent = $el.parent();
      var newUrl = $el.attr('href');

      if (settings.combineTags) {
        if ($parent.hasClass(classes.activeTag)) {
          $parent.removeClass(classes.activeTag);
        } else {
          $parent.addClass(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if ($el.parent('li').hasClass(classes.removeTagParent)) {
            $(this).parent().remove();
          } else {
            $(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' + $el.text() + '</a></li>');
          }
        }
      } else {
        $(selectors.tags).parent().removeClass(classes.activeTag);
        $parent.addClass(classes.activeTag);
      }

      updateScroll(true);

      history.pushState({}, '', newUrl);
      $(selectors.collectionGrid).addClass('unload');
      getNewCollectionContent(newUrl);
    });
  }

  function updateScroll(animate) {
    var scrollTo;
    if (theme.config.bpSmall) {
      // 60 is ~ height of sticky filters
      scrollTo = $('[data-scroll-to]').offset().top - 60;
    } else {
      scrollTo = $('#CollectionAjaxResult').offset().top + 1;
    }

    if (theme.config.stickyHeader) {
      var heightOfStickyNav = $('.site-header').outerHeight(true);
      scrollTo = scrollTo - heightOfStickyNav;
    }

    // if (animate) {
    //   $('html, body').animate({ scrollTop: scrollTo }, 300);
    // } else {
    //   $('html, body').scrollTop(scrollTo);
    // }
  }

  function setFilterStickyPosition() {
    var headerHeight = $('.site-header').outerHeight(true);
    $(selectors.filters).css('top', headerHeight + 10);
  }

  function getNewCollectionContent(url) {
    url = url + '?view=ajax';
    $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
      isAnimating = false;
      theme.reinitSection('collection-template');
      theme.collectionTemplate.reinit();
    }.bind(this));
  }

  function reinit() {
    settings.combineTags = $(selectors.sidebar).data('combine-tags');

    updateScroll(false);

    // Setup page transition classes
    theme.pageTransitions();

    theme.reinitProductGridItem();

    // Trigger resize for sticky sidebar styles to update
    $('body').trigger('resize');
  }

  return {
    init: init,
    reinit: reinit
  };
})();

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
     *
     *  Show/Hide recover password form
     *
     */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
     *
     *  Show reset password success message
     *
     */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submitted
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
     *
     *  Show/hide customer address forms
     *
     */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $addressForms = $('.js-address-form');

    if (!$newAddressForm.length || !$addressForms.length) {
      return;
    }

    if (Shopify) {
      $('.js-address-country').each(function() {
        var $container = $(this);
        var countryId = $container.data('country-id');
        var provinceId = $container.data('province-id');
        var provinceContainerId = $container.data('province-container-id');

        new Shopify.CountryProvinceSelector(
          countryId,
          provinceId,
          {
            hideElement: provinceContainerId
          }
        );
      });
    }

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
      //         $('.address_form').css({"display": "block"});
    });
    //       $('.cancle_edit').on('click',function(){        
    //        $('.address_form').css({"display": "flex"});

    //       })

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
     *
     *  Check URL for reset password hash
     *
     */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


theme.Product = (function() {

  var classes = {
    onSale: 'on-sale',
    disabled: 'disabled',
    isModal: 'is-modal',
    loading: 'loading',
    loaded: 'loaded',
    hidden: 'hide',
    interactable: 'video-interactable',
    visuallyHide: 'visually-invisible'
  };

  var selectors = {
    productVideo: '.product__video',
    videoParent: '.product__video-wrapper',
    currentSlide: '.slick-current',
    startingSlide: '.starting-slide'
  };

  var youtubeReady;
  var videos = {};
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    height: '480',
    width: '850',
    playerVars :{
      autohide: 0,
      autoplay: 0,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    }
  };

  function onVideoPlayerReady(evt, id) {
    var $player = $('#' + id);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    if (videos[playerId].style === 'muted') {
      youtubePlayers[playerId].mute();
    } else {
      setParentAsLoaded($player);
    }

    // If first slide or only photo, start video
    if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].playVideo();
        initCheckVisibility(playerId);
      }
    }
  }

  function initCheckVisibility(playerId) {
    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      if (!id.data) {return}
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      if (videos[playerId] && videos[playerId].style === 'unmuted') {
        return;
      }
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt, id) {
    var $player = $('#' + id);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        if (videos[playerId] && videos[playerId].loop) {
          player.playVideo();
        }
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
    .closest(selectors.videoParent)
    .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
    .closest(selectors.videoParent)
    .removeClass(classes.loading)
    .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
    .closest(selectors.videoParent)
    .addClass(classes.interactable);
  }

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    this.inModal = $container.closest('.modal').length;
    this.$modal;

    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      inventory: $container.data('inventory') || false,
      incomingInventory: $container.data('incoming-inventory') || false,
      modalInit: false,
      slickMainInitialized: false,
      slickThumbInitialized: false,
      thumbArrows: false,
      thumbVertical: false,
      hasImages: true,
      hasMultipleImages: false,
      has3d: false,
      imageSize: '620x',
      videoLooping: $container.data('video-looping')
    };

    // Overwrite some settings when loaded in modal
    if (this.inModal) {
      this.settings.enableHistoryState = false;
      this.settings.namespace = '.product-' + sectionId + '-modal';
      this.$modal = $('#QuickShopModal-' + sectionId);
    }

    this.selectors = {
      variantsJson: 'VariantsJson-' + sectionId,
      currentVariantJson: 'CurrentVariantJson-' + sectionId,

      video: 'ProductVideo-' + sectionId,
      media: '[data-product-media-type-model]',
      closeMedia: '.product-single__close-media',
      photoThumbs: '.product__thumb-' + sectionId,
      thumbSlider: '#ProductThumbs-' + sectionId,
      mainSlider: '#ProductPhotos-' + sectionId,
      imageContainer: '[data-product-images]',
      productImageMain: '.product-image-main--' + sectionId,
      dotsContainer: '.product__photo-dots--' + sectionId,

      priceWrapper: '.product__price-wrap-' + sectionId,
      price: '.product__priceforproductpage',
      comparePrice: '.product__price--compare',
      savePrice: '#SavePrice-' + sectionId,
      priceA11y: '#PriceA11y-' + sectionId,
      comparePriceA11y: '#ComparePriceA11y-' + sectionId,
      unitWrapper: '.product__unit-price-wrapper--' + sectionId,
      unitPrice: '.product__unit-price--' + sectionId,
      unitPriceBaseUnit: '.product__unit-base--' + sectionId,
      sku: '#Sku-' + sectionId,
      inventory: '#ProductInventory-' + sectionId,
      incomingInventory: '#ProductIncomingInventory-' + sectionId,

      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.variant__input-' + sectionId,
      variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

      modalFormHolder: '#ProductFormHolder-' + sectionId,
      formContainer: '#AddToCartForm-' + sectionId
    };

    this.$mainSlider = $(this.selectors.mainSlider);
    this.$thumbSlider = $(this.selectors.thumbSlider);
    this.$firstProductImage = this.$mainSlider.find('img').first();

    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    init: function() {
      if (this.inModal) {
        this.$container.addClass(classes.isModal);
        $('body')
        .off('modalOpen.QuickShopModal-' + this.sectionId)
        .off('modalClose.QuickShopModal-' + this.sectionId);
        $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
        $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
      }

      if (!this.inModal) {
        this.stringOverrides();
        this.formSetup();
        this.productSetup();

        this.checkIfVideos();
        this.createImageCarousels();
        this.customMediaListners();

        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      }
    },

    formSetup: function() {
      // Determine how to handle variant availability selectors
      if (theme.settings.dynamicVariantsEnable) {
        this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
      }

      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },

    productSetup: function() {
      this.setImageSizes();
      this.initImageSwitch();
      this.initImageZoom();
      this.initModelViewerLibraries();
      this.initShopifyXrLaunch();
    },

    addIdToRecentlyViewed: function() {
      var handle = this.$container.attr('data-product-handle');
      var url = this.$container.attr('data-product-url');
      var aspectRatio = this.$container.attr('data-aspect-ratio');
      var featuredImage = this.$container.attr('data-img-url');

      // Remove current product if already in set of recent
      if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
        delete theme.recentlyViewed.recent[handle];
      }

      // Add it back to the end
      theme.recentlyViewed.recent[handle] = {
        url: url,
        aspectRatio: aspectRatio,
        featuredImage: featuredImage
      };

      if (theme.config.hasLocalStorage) {
        window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
      }
    },

    stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    initVariants: function() {
      if (!document.getElementById(this.selectors.variantsJson)) {
        return;
      }

      this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);

      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        variants: this.variantsObject
      };

      if ($(this.selectors.variantColorSwatch).length) {
        $(this.selectors.variantColorSwatch).on('change', function(evt) {
          var $el = $(evt.currentTarget);
          var color = $el.data('color-name');
          var index = $el.data('color-index');
          this.updateColorName(color, index);
        }.bind(this));
      }

      this.variants = new theme.Variants(options);

      this.$container
      .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
      .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
      .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
      .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));

      if ($(this.selectors.sku).length) {
        this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
      }
      if (this.settings.inventory || this.settings.incomingInventory) {
        this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
      }

      // Update individual variant availability on each selection
      if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
        this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);

        this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));

        // Set default state based on current selected variant
        this.setCurrentVariantAvailability(this.currentVariantObject, true);
      }
    },

    initQtySelector: function() {
      this.$container.find('.js-qty__wrapper').each(function() {
        new theme.QtySelector($(this), {
          namespace: '.product'
        });
      });
    },

    initAjaxProductForm: function() {
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },

    /*============================================================================
        Dynamic variant availability
          - To disable, set dynamicVariantsEnable to false in theme.liquid
      ==============================================================================*/
    setCurrentVariantAvailability: function(variant) {
      var valuesToEnable = {
        option1: [],
        option2: [],
        option3: []
      };

      // Disable all options to start
      this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));

      // Combine all available variants
      var availableVariants = this.variantsObject.filter(function(el) {
        if (variant.id === el.id) {
          return false;
        }

        // Option 1
        if (variant.option2 === el.option2 && variant.option3 === el.option3) {
          return true;
        }

        // Option 2
        if (variant.option1 === el.option1 && variant.option3 === el.option3) {
          return true;
        }

        // Option 3
        if (variant.option1 === el.option1 && variant.option2 === el.option2) {
          return true;
        }
      });


      // IE11 can't handle shortform of {variant} so extra step is needed
      var variantObject = {
        variant: variant
      };

      availableVariants = Object.assign({}, variantObject, availableVariants);

      // Loop through each available variant to gather variant values
      for (var property in availableVariants) {
        if (availableVariants.hasOwnProperty(property)) {
          var item = availableVariants[property];
          var option1 = item.option1;
          var option2 = item.option2;
          var option3 = item.option3;

          if (option1) {
            if (valuesToEnable.option1.indexOf(option1) === -1) {
              valuesToEnable.option1.push(option1);
            }
          }
          if (option2) {
            if (valuesToEnable.option2.indexOf(option2) === -1) {
              valuesToEnable.option2.push(option2);
            }
          }
          if (option3) {
            if (valuesToEnable.option3.indexOf(option3) === -1) {
              valuesToEnable.option3.push(option3);
            }
          }
        }
      }

      // Have values to enable, separated by option index
      if (valuesToEnable.option1.length) {
        this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
      }
      if (valuesToEnable.option2.length) {
        this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
      }
      if (valuesToEnable.option3.length) {
        this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
      }
    },

    updateVariantAvailability: function(evt, value, index) {
      if (value && index) {
        var newVal = value;
        var optionIndex = index;
      } else {
        var $el = $(evt.currentTarget);
        var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
        var optionIndex = $el.data('index');
      }

      var variants = this.variantsObject.filter(function(el) {
        return el[optionIndex] === newVal;
      });

      // Disable all buttons/dropdown options that aren't the current index
      $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
        var $group = $(el);
        var currentOptionIndex = $group.data('index');

        if (currentOptionIndex !== optionIndex) {
          // Disable all options as a starting point
          this.disableVariantGroup($group);

          // Loop through legit available options and enable
          for (var i = 0; i < variants.length; i++) {
            this.enableVariantOption($group, variants[i][currentOptionIndex]);
          }
        }
      }.bind(this));
    },

    disableVariantGroup: function($group) {
      if (theme.settings.dynamicVariantType === 'dropdown') {
        $group.find('option').prop('disabled', true)
      } else {
         var idcheck = $group.find('input').parents('fieldset').attr('id');
        var classCheck = $group.find('input').parents('fieldset').attr('class_ele');
          if (idcheck == 'ProductSelect-decorative-panel-option-222' || 
              idcheck == 'ProductSelect-checkbox-option-1' || 
              idcheck == 'ProductSelect-checkbox-option-1-lumifence' || 
              idcheck == 'ProductSelect-checkbox-option-1-lumifence_type' || 
              idcheck == 'ProductSelect-6597875499179-option-0' || 
              idcheck == 'ProductSelect-7906287878360-option-1' || 
              classCheck == 'extra-step-cls' || 
              classCheck == 'driveway_aluminium_gate_post_required_c' || 
              idcheck == 'ProductSelect-7906271264984-option-1' ||
              idcheck == 'ProductSelect-6597875499179-option-0-itsfixingkit') {
              } else {
            $group.find('input').prop('disabled', true);
            $group.find('label').toggleClass('disabled', true);
          }
      }
    },

    enableVariantOptionByValue: function(array, index) {
      var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="'+ index +'"]');

      for (var i = 0; i < array.length; i++) {
        this.enableVariantOption($group, array[i]);
      }
    },

    enableVariantOption: function($group, value) {
      // Selecting by value so escape it
      if (value) {
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
      }
      
      if (theme.settings.dynamicVariantType === 'dropdown') {
        $group.find('option[value="'+ value +'"]').prop('disabled', false);
      } else {
        
        var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
        $buttonGroup.find('input').prop('disabled', false);
        $buttonGroup.find('label').toggleClass('disabled', false);
      }
    },

    /*============================================================================
        Variant change methods
      ==============================================================================*/
    updateColorName: function(color, index) {
      // Updates on radio button change, not variant.js
      $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
    },

    updateCartButton: function(evt) {
      var variant = evt.variant;
      var screenAvailable = false;
      if (variant) {
        $('.skuchangeedynamically').html(variant.sku);
        var tmpsfx = $('#templatesuffix').val();
        if (tmpsfx == 'kit') {
          $('#sumaryfenceheight').html(variant.title);
        }
        if (variant.available) {
          // Available, enable the submit button and change text
          $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);
          $(this.selectors.addToCart).html(theme.strings.addToCart);
        } else {
          // Sold out, disable the submit button and change text
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          $(this.selectors.addToCart).html(theme.strings.soldOut);
        }
        
                // Regular price
        var pp = variant.price;
        var additionalSlat = [];
        var additionalScreen = [];
        var screenAvailable = false;
        if ($('#additional-slatpack').val()) {
          additionalSlat = JSON.parse($('#additional-slatpack').val());
        }
        
        if ($('#additional-screen').val()) {
          additionalScreen = JSON.parse($('#additional-screen').val());
        }
        var aurl = location.href;
        var vvprice = variant.price;
        var vvcprice = variant.compare_at_price;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());
        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
        }

        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;
        
        if (variant.compare_at_price > variant.price) {
          var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
          ab += '<span class="price-current">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
        
          $(this.selectors.price).html(ab);
          $('#ProductPriceGetByVariantSelection').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
          $('#ProductCompPriceGetByVariantSelection').html(theme.Currency.formatMoney(vvcprice, theme.settings.moneyFormat));
        } else {
           $(this.selectors.price).html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)).show();
            $('#ProductPriceGetByVariantSelection').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
        }
        
        // if(evt.target.baseURI.includes('classic-composite')) {
        // 	screenAvailable = true;
        // }
        $('body').removeClass('unavailable_product_size_ele');
      } else {
        // The variant doesn't exist, disable submit button
        $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
        $(this.selectors.addToCartText).html('Unavailable in this size');
        $(this.selectors.addToCart).html('Unavailable in this size');
        $('body').addClass('unavailable_product_size_ele');
      }

      if ($('#templatesuffix').val() == 'gates-kit') {
        $('.elehide-gate-post-required .manageipv').trigger('click');        
      }
      if ($(".elehide-planter-post-required")[0]){
        $('.elehide-planter-post-required').find('input:checked').parent('.manageipv').trigger('click');
      }
    },

    updatePrice: function(evt) {
      var variant = evt.variant;
      if (variant) {

        // Sale price, if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
          $(this.selectors.priceWrapper).removeClass('hide');
          $(this.selectors.price).addClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
          $(this.selectors.priceA11y).attr('aria-hidden', 'false');

          var savings = variant.compare_at_price - variant.price;

          if (theme.settings.saveType == 'percent') {
            savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
          } else {
            savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          }

          $(this.selectors.savePrice)
          .removeClass('hide')
          .html(theme.strings.savePrice.replace('[saved_amount]', savings));
        } else {
          $(this.selectors.priceWrapper).addClass('hide');
          $(this.selectors.price).removeClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
          $(this.selectors.priceA11y).attr('aria-hidden', 'true');
          $(this.selectors.savePrice).addClass('hide')
        }
        var ppid = $('#product-template-product-id').val();
        $('#ProductPrice-'+ppid+'-3').html($('#ProductPrice-'+ppid+'-3').html());
      }
    },

    updateUnitPrice: function(evt) {
      var variant = evt.variant;

      if (variant && variant.unit_price) {
        $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
        $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
        $(this.selectors.unitWrapper).removeClass('hide').removeClass(classes.visuallyHide);
      } else {
        $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
      }
    },

    updateSku: function(evt) {
      var variant = evt.variant;
      var newSku = '';

      if (variant) {
        if (variant.sku) {
          newSku = variant.sku;
        }

        $(this.selectors.sku).html(newSku);
      }
    },

    updateInventory: function(evt) {
      var variant = evt.variant;

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        return;
      }

      if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
        variantInventoryObject = window.inventories[this.sectionId][variant.id];
        var quantity = variantInventoryObject.quantity;
        var showInventory = true;
        var showIncomingInventory = false;

        if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
          showInventory = false;
        }

        this.toggleInventoryQuantity(showInventory, quantity);

        if (!showInventory && variantInventoryObject.incoming) {
          showIncomingInventory = true;
        }

        this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
      }
    },

    toggleInventoryQuantity: function(show, qty) {
      if (!this.settings.inventory) {
        show = false;
      }

      if (show) {
        $(this.selectors.inventory)
        .removeClass('hide')
        .text(theme.strings.stockLabel.replace('[count]', qty));
      } else {
        $(this.selectors.inventory).addClass('hide');
      }
    },

    toggleIncomingInventory: function(show, available, date) {
      if (!this.settings.incomingInventory) {
        show = false;
      }

      if (show) {
        var string = available ?
            theme.strings.willNotShipUntil.replace('[date]', date) :
        theme.strings.willBeInStockAfter.replace('[date]', date);

        if (!date) {
          string = theme.strings.waitingForStock;
        }

        $(this.selectors.incomingInventory)
        .removeClass('hide')
        .text(string);
      } else {
        $(this.selectors.incomingInventory).addClass('hide');
      }
    },

    /*============================================================================
        Product videos
      ==============================================================================*/
    checkIfVideos: function() {
      var $productVideos = this.$mainSlider.find(selectors.productVideo);

      // Stop if there are 0 videos
      if (!$productVideos.length) {
        return false;
      }

      var videoTypes = [];

      $productVideos.each(function() {
        var type = $(this).data('video-type');

        if (videoTypes.indexOf(type) < 0) {
          videoTypes.push(type);
        }
      });

      // Load YouTube API if not already loaded
      if (videoTypes.indexOf('youtube') > -1) {
        if (!theme.config.youTubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.settings.namespace, function() {
            this.loadYoutubeVideos($productVideos);
          }.bind(this));
        } else {
          this.loadYoutubeVideos($productVideos);
        }
      }

      // Add mp4 video players
      if (videoTypes.indexOf('mp4') > -1) {
        this.loadMp4Videos($productVideos);
      }

      return videoTypes;
    },

    loadMp4Videos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'mp4') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[id] = {
          type: 'mp4',
          divId: id,
          style: $el.data('video-style')
        };
      });
    },

    loadYoutubeVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'youtube') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('youtube-id');

        videos[id] = {
          type: 'youtube',
          id: id,
          videoId: videoId,
          style: $el.data('video-style'),
          loop: $el.data('video-loop'),
          attemptedToPlay: false,
          events: {
            onReady: function(evt) {
              onVideoPlayerReady(evt, id);
            },
            onStateChange: function(evt) {
              onVideoStateChange(evt, id);
            }
          }
        };
      });

      // Create a player for each YouTube video
      for (var key in videos) {
        if (videos[key].type === 'youtube') {
          if (videos.hasOwnProperty(key)) {
            var args = $.extend({}, youtubeVideoOptions, videos[key]);

            if (args.style === 'muted') {
              // default youtubeVideoOptions, no need to change anything
            } else {
              args.playerVars.controls = 1;
              args.playerVars.autoplay = 0;
            }

            youtubePlayers[key] = new YT.Player(key, args);
          }
        }
      }

      youtubeReady = true;
    },

    initVideo: function($video) {
      var videoType = $video.data('video-type');
      var divId = $video.attr('id');

      if (videoType === 'mp4' && videos[divId].style === 'muted') {
        this.playMp4Video(divId);
      }

      if (videoType === 'youtube') {
        if (youtubeReady && videos[divId].style === 'muted') {
          this.requestToPlayYoutubeVideo(divId);
        }
      }

      // Hacky way to trigger resetting the slider layout in modals
      if (this.inModal) {
        this.resizeSlides();
      }
    },

    stopVideo: function(id, type) {
      if (!id) {
        this.stopYoutubeVideo();
        this.stopMp4Video();
      }

      if (type === 'youtube') {
        this.stopYoutubeVideo(id);
      }

      if (type === 'mp4') {
        this.stopMp4Video(id);
      }
    },

    getVideoType: function($video) {
      return $video.data('video-type');
    },

    getVideoId: function($video) {
      return $video.attr('id');
    },

    // Sub video functions (MP4 and YouTube)
    requestToPlayYoutubeVideo: function(id, forcePlay) {
      if (!theme.config.youTubeReady) {
        return;
      }

      var $player = $('#' + id);
      setParentAsLoading($player);

      // If video is requested too soon, player might not be ready.
      // Set arbitrary timeout to request it again in a second
      if (typeof youtubePlayers[id].playVideo != 'function') {
        setTimeout(function() {
          this.playYoutubeVideo(id, forcePlay);
        }.bind(this), 1000);
        return;
      }

      this.playYoutubeVideo(id, forcePlay);
    },

    playYoutubeVideo: function (id, forcePlay) {
      var $player = $('#' + id);
      setParentAsLoaded($player);
      if (typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }

      // forcePlay is sent as true from beforeSlideChange so the visibility
      // check isn't fooled by the next slide positioning
      if (!forcePlay) {
        initCheckVisibility(id);
      }
    },

    stopYoutubeVideo: function(id) {
      if (!theme.config.youTubeReady) {
        return;
      }

      if (id && youtubePlayers[id]) {
        if (typeof youtubePlayers[id].pauseVideo === 'function') {
          youtubePlayers[id].pauseVideo();
        }
        $(window).off('scroll.' + id);
      } else {
        for (key in youtubePlayers) {
          var childVideo = this.$container.find('#' + key);
          if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
            youtubePlayers[key].pauseVideo();
            $(window).off('scroll.' + key);
          }
        }
      }
    },

    playMp4Video: function(id) {
      var $player = $('#' + id);
      setParentAsLoaded($player);

      var playPromise = $player[0].play();

      if (playPromise !== undefined) {
        playPromise.then(function() {})
        .catch(function(error) {
          // Likely low power mode on iOS, show controls
          $player[0].setAttribute('controls', '');
          $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
        });
      }
    },

    stopMp4Video: function(id) {
      if (id) {
        $('#' + id)[0].pause();
      } else {
        // loop through all mp4 videos to stop them
        for (var key in videos) {
          var childVideo = this.$container.find('#' + key);
          if (childVideo.length && videos[key].type === 'mp4') {
            var player = $('#' + videos[key].divId)[0];
            if (player && typeof player.pause === 'function') {
              player.pause();
            }
          }
        }
      }
    },

    /*============================================================================
        Product images
      ==============================================================================*/
    initImageZoom: function() {
      var $container = $(this.selectors.imageContainer, this.$container);
      var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
    },

    setImageSizes: function() {
      if (!this.settings.hasImages) {
        return;
      }

      // Get srcset image src, works on most modern browsers
      // otherwise defaults to settings.imageSize
      var currentImage = this.$firstProductImage[0].currentSrc;

      if (currentImage) {
        this.settings.imageSize = theme.Images.imageSize(currentImage);
      }
    },

    updateVariantImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
      var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
      var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

      // No image, bail
      if (typeof imageIndex === 'undefined') {
        return;
      }

      this.$mainSlider.slick('slickGoTo', imageIndex);
    },

    initImageSwitch: function() {
      if (!$(this.selectors.photoThumbs).length) {
        return;
      }

      $(this.selectors.photoThumbs)
      .on('click', function(evt) {
        evt.preventDefault();
      })
      .on('focus', function(evt) {
        if (!this.settings.slickThumbInitialized) { return }
        var index = $(evt.currentTarget).data('index');
        if (index !== undefined) {
          this.$thumbSlider.slick('slickGoTo', index);
        }
      }.bind(this))
      .on('keydown', function(evt) {
        if (evt.keyCode === 13) {
          this.$container.find(selectors.currentSlide).focus();
        }
      }.bind(this));
    },

    createImageCarousels: function() {
      if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
        // Single product image. Init video if it exists
        var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
        if ($video.length) {
          this.initVideo($video);
        }
        return;
      }

      this.settings.hasMultipleImages = true;
      this.settings.has3d = this.$container.find(this.selectors.media).length;

      // Set starting slide (for both sliders)
      var $activeSlide = this.$mainSlider.find('.starting-slide');
      var startIndex = this._slideIndex($activeSlide);

      // Lame way to prevent duplicate event listeners
      this.$mainSlider.off('init');
      this.$mainSlider.off('beforeChange');
      this.$mainSlider.on('init', this.mainSlideInit.bind(this));
      this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));

      // Default (mobile) slider settings
      this.mainSliderArgs = {
        infinite: this.settings.has3d ? false : true,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        initialSlide: startIndex,
        appendDots: this.selectors.dotsContainer,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              arrows: true,
              slidesToShow: 1,
              centerMode: true,
              slidesToScroll: 1,
              centerPadding: 0
            }
          }
        ]
      };

      this.thumbSliderArgs = {
        accessibility: false,
        initialSlide: startIndex
      };

      // Init sliders normally
      var sliderArgs = this.setSliderArgs();
      this.initSliders(sliderArgs);

      // Re-init slider when a breakpoint is hit
      $('body').on('matchSmall matchLarge', function() {
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
      }.bind(this));

      // Too many thumbnails can cause the AOS calculations to be off
      // so refresh that when the slider is ready
      if (AOS) {
        AOS.refresh();
      }
    },

    initSliders: function(args) {
      this.destroyImageCarousels();
      this.$mainSlider.slick(args.main);
      if (!theme.config.bpSmall) {
        this.$thumbSlider.slick(args.thumbs);
      }

      this.settings.slickMainInitialized = true;
    },

    setSliderArgs: function() {
      var args = {};

      var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
      var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');

      var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
      (thumbnailsVertical ? 3 : 5);

      if (theme.config.bpSmall) {
        args.main = this.mainSliderArgs;
        args.thumbs = this.thumbSliderArgs;
      } else {
        args.main = $.extend({}, this.mainSliderArgs, {
          asNavFor: this.selectors.thumbSlider,
          adaptiveHeight: thumbnailsVertical ? false : true,
          dots: false,
          infinite: false,
          fade: true
        });
        args.thumbs = $.extend({}, this.thumbSliderArgs, {
          asNavFor: this.selectors.mainSlider,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: thumbArrows,
          dots: false,
          vertical: thumbnailsVertical,
          verticalSwiping: thumbnailsVertical,
          focusOnSelect: true,
          infinite: false,
          customHeightMatching: thumbArrows ? false : thumbnailsVertical,
          customSlideAdvancement: true
        });
      }

      return args;
    },

    destroyImageCarousels: function() {
      if (this.$mainSlider && this.settings.slickMainInitialized) {
        this.$mainSlider.slick('unslick');
        this.settings.slickMainInitialized = false;
      }

      if (this.$thumbSlider && this.settings.slickThumbInitialized) {
        this.$thumbSlider.slick('unslick');
        this.settings.slickThumbInitialized = false;
      }

      this.settings.slickMainInitialized = false;
      this.settings.slickThumbInitialized = false;
    },

    mainSlideInit: function(event, slick) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $video = $currentSlide.find(selectors.productVideo);

      if (!$video.length) {
        return;
      }

      this.initVideo($video);
    },

    thumbSlideInit: function(event, slick) {
      this.settings.slickThumbInitialized = true;

      // Check if we need to hide the arrows
      if (this.settings.thumbArrows) {
        this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
      }
    },

    thumbSlideArrowVisibility: function(event, slick) {
      var $slider = slick.$slider;
      var $arrows = $slider.find('.slick-arrow');
      var showArrows = false;

      if (this.settings.thumbVertical) {
        var $trackHeight = $slider.find('.slick-track').height();
        if ($trackHeight >= $slider.height()) {
          showArrows = true;
        }
      } else {
        var $trackWidth = $slider.find('.slick-track').width();
        if ($trackWidth >= $slider.width()) {
          showArrows = true;
        }
      }

      if (showArrows) {
        $arrows.removeClass('hide');
      } else {
        $arrows.addClass('hide');
      }
    },

    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $prevVideo = $currentSlide.find('.product__video');
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
      var $nextVideo = $nextSlide.find('.product__video');

      // Pause any existing slide video
      if (currentSlide !== nextSlide && $prevVideo.length) {
        var prevVideoType = this.getVideoType($prevVideo);
        var prevVideoId = this.getVideoId($prevVideo);

        if (prevVideoId) {
          this.stopVideo(prevVideoId, prevVideoType);
        }
      }

      // Prep next slide video
      if ($nextVideo.length) {
        var nextVideoType = this.getVideoType($nextVideo);
        var nextVideoId = this.getVideoId($nextVideo);

        // Prep YouTube with a backup in case API isn't ready
        if (nextVideoId && nextVideoType === 'youtube') {
          if (youtubeReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.requestToPlayYoutubeVideo(nextVideoId, true);
            }
          } else {
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            }.bind(this))
          }
        }

        // Autoplay muted MP4 videos
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
          if (nextVideoType === 'mp4') {
            this.playMp4Video(nextVideoId);
          }
        }

        // Set unmuted videos to loaded state
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
          setParentAsLoaded($('#' + nextVideoId));
        }
      }

      // Pause any existing media
      var $currentMedia = $currentSlide.find(this.selectors.media);
      if ($currentMedia.length) {
        $currentMedia.trigger('mediaHidden');
      }

      // Prep next slide media
      var $nextMedia = $nextSlide.find(this.selectors.media);
      if ($nextMedia.length) {
        $nextMedia.trigger('mediaVisible');
        $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
        $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
      }
    },

    resizeSlides: function() {
      if (!this.settings.hasMultipleImages) {
        return;
      }

      $(window).trigger('resize.slick');
      setTimeout(function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('setPosition');
        }
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('setPosition');
        }
      }.bind(this), 500); // same timing as modal open transition
    },

    _slideIndex: function($el) {
      return $el.data('index');
    },

    /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
    openModalProduct: function() {
      if (!this.settings.modalInit) {
        var $formHolder = $(this.selectors.modalFormHolder);
        var url = $formHolder.data('url');
        var template = $formHolder.data('template');

        // If no alt template, use stripped down ajax version
        if (!template) {
          url = url + '?view=ajax';
        }

        $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
          $formHolder.addClass('is-active');
          this.formSetup();
          if (Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }.bind(this));

        this.productSetup();
        this.loadModalContent();
        this.createImageCarousels();
        this.customMediaListners();
        this.settings.modalInit = true;
      }

      this.resizeSlides();

      // Add product id to recently viewed array
      this.addIdToRecentlyViewed();
    },

    closeModalProduct: function() {
      this.stopVideo();
      $('body').off(this.settings.namespace);
      $(window).off(this.settings.namespace);
    },

    loadModalContent: function() {
      // Load videos if they exist
      var videoTypes = this.checkIfVideos();

      // Lazyload mp4 videos
      if (videoTypes && videoTypes.indexOf('mp4') > -1) {
        this.$modal
        .find('.product__video[data-video-type="mp4"]')
        .find('.product__video-src')
        .each(function(i, video) {
          var $el = $(video);
          var src = $el.attr('src');
          var type = $el.attr('type')
          var newEl = document.createElement('source');
          newEl.src = src;
          newEl.type = type;
          $el.after(newEl);
        }.bind(this));
      }
    },

    /*============================================================================
        Product media (3D)
      ==============================================================================*/
    initModelViewerLibraries: function() {
      var $modelViewerElements = $(
        this.selectors.media,
        this.$container
      );

      if ($modelViewerElements.length < 1) return;

      theme.ProductMedia.init($modelViewerElements, this.sectionId);
    },

    initShopifyXrLaunch: function() {
      var self = this;
      $(document).on('shopify_xr_launch', function() {
        var $currentMedia = $(
          self.selectors.productMediaWrapper +
          ':not(.' +
          classes.hidden +
          ')',
          self.$container
        );
        $currentMedia.trigger('xrLaunch');
      });
    },

    customMediaListners: function() {
      $('body').on('click', this.selectors.closeMedia, function() {
        this.$mainSlider
        .find(selectors.currentSlide)
        .find(this.selectors.media)
        .trigger('mediaHidden');
      }.bind(this));

      this.$container.find('model-viewer')
      .on('shopify_model_viewer_ui_toggle_play', function(evt) {
        this.mediaLoaded(evt);
      }.bind(this))
      .on('shopify_model_viewer_ui_toggle_pause', function(evt) {
        this.mediaUnloaded(evt);
      }.bind(this));
    },

    mediaLoaded: function(evt) {
      this.$container.find(this.selectors.closeMedia).removeClass('hide');
      this.toggleSliderSwiping(false);
    },

    mediaUnloaded: function(evt) {
      this.$container.find(this.selectors.closeMedia).addClass('hide');
      this.toggleSliderSwiping(true);
    },

    toggleSliderSwiping: function(enable) {
      if (this.$mainSlider && this.settings.slickMainInitialized) {
        this.$mainSlider.slick('slickSetOption', 'swipe', enable);
        this.$mainSlider.slick('slickSetOption', 'draggable', enable);
        this.$mainSlider.slick('slickSetOption', 'touchMove', enable);
        this.$mainSlider.slick('slickSetOption', 'accessibility', enable);
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      $('body').off(this.settings.namespace);
      this.destroyImageCarousels();
      theme.ProductMedia.removeSectionModels(this.sectionId);
    }
  });

  return Product;
})();

theme.Recommendations = (function() {

  function Recommendations(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    this.url = $container.data('url');

    this.selectors = {
      recommendations: '#Recommendations-' + sectionId,
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    };

    this.init();
  }

  Recommendations.prototype = $.extend({}, Recommendations.prototype, {
    init: function() {
      var $section = $(this.selectors.recommendations);

      if (!$section.length || $section.data('enable') === false) {
        return;
      }

      var $placeholder = $section.find(this.selectors.placeholder);
      var id = $section.data('product-id');
      var limit = $section.data('limit');

      var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;

      $placeholder.load(url + this.selectors.sectionClass, function(data) {
        theme.reinitProductGridItem($section);
        this.updateVariantInventory($section);

        // If no results, hide the entire section
        if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
          $section.addClass('hide');
        }
      }.bind(this));
    },

    // Recommended products load via JS and don't add variant inventory to the
    // global variable that we later check. This function scrapes a data div
    // to get that info and manually add the values.
    updateVariantInventory: function($section) {
      window.inventories = window.inventories || {};

      $section.find('.js-product-inventory-data').each(function() {
        var $el = $(this);
        var sectionId = $el.data('section-id');
        window.inventories[sectionId] = {};
        $('.js-variant-inventory-data', $el).each(function() {
          var $child = $(this);
          window.inventories[sectionId][$child.data('id')] = {
            'quantity': $child.data('quantity'),
            'incoming': $child.data('incoming'),
            'next_incoming_date': $child.data('date')
          }
        });
      });
    }
  });

  return Recommendations;
})();

theme.CollectionHeader = (function() {

  var selectors = {
    hero: '.collection-hero',
    parallaxContainer: '.parallax-container'
  };

  function CollectionHeader(container) {
    var $container = $(container);
    this.namespace = '.collection-header';

    var $heroImageContainer = this.$heroContainer = $container.find(selectors.hero);
    if ($heroImageContainer.length) {
      this.checkIfNeedReload();

      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    } else {
      // Prevent 'Overlay header over collection' header setting
      // from breaking layout. Required because settings from two
      // different sections rely on each other on page load.
      theme.headerNav.disableOverlayHeader();
    }
  }

  CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
    // A liquid variable in the header needs a full page refresh
    // if the collection header hero image setting is enabled
    // and the header is set to sticky. Only necessary in the editor.
    checkIfNeedReload: function() {
      if (!Shopify.designMode) {
        return;
      }

      if (!theme.settings.overlayHeader) {
        return;
      }
      var $header = $('.header-wrapper');
      if (!$header.hasClass('is-light') && !$('.header-wrapper').hasClass('header-wrapper--sticky')) {
        location.reload();
      }
    },

    onUnload: function() {
      if (theme.parallaxSections[this.namespace]) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    }
  });

  return CollectionHeader;
})();

theme.CollectionSidebar = (function() {
  var drawerStyle = false;

  function CollectionSidebar(container) {
    this.$container = $(container);
    this.init();
  }

  CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
    init: function() {
      // Force close the drawer if it exists
      this.onUnload();

      drawerStyle = this.$container.data('style') === 'drawer';
      theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
    },

    forceReload: function() {
      this.init();
    },

    onSelect: function() {
      if (theme.FilterDrawer) {
        if (!drawerStyle) {
          theme.FilterDrawer.close();
          return;
        }

        if (drawerStyle || theme.config.bpSmall) {
          theme.FilterDrawer.open();
        }
      }
    },

    onDeselect: function() {
      if (theme.FilterDrawer) {
        theme.FilterDrawer.close();
      }
    },

    onUnload: function() {
      if (theme.FilterDrawer) {
        theme.FilterDrawer.close();
      }
    }
  });

  return CollectionSidebar;
})();

theme.Collection = (function() {

  var selectors = {
    colorSwatchImage: '.grid-product__color-image',
    colorSwatch: '.color-swatch--with-image',
    sortSelect: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function() {
      // init is called on load and when tags are selected
      this.$container = $(this.container);
      var sectionId = this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.collection-' + sectionId;

      this.$sortSelect = $(selectors.sortSelect);
      this.$sortSelect.on('change', this.onSortChange.bind(this));
      this.defaultSort = this.getDefaultSortValue();

      this.initParams();
      this.colorSwatchHovering();

      theme.reinitSection('collection-sidebar');
    },

    initParams: function() {
      this.queryParams = {};

      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    onSortChange: function() {
      this.queryParams.sort_by = this.getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = $.param(this.queryParams);
    },

    colorSwatchHovering: function() {
      var $colorImage = $(selectors.colorSwatchImage);
      if (!$colorImage.length) {
        return;
      }

      $(selectors.colorSwatch).on({
        mouseenter: function (evt) {
          $el = $(evt.currentTarget);
          var id = $el.data('variant-id');
          var image = $el.data('variant-image');
          $('.grid-product__color-image--' + id)
          .css('background-image', 'url(' + image + ')')
          .addClass('is-active');
        },
        mouseleave: function (evt) {
          $el = $(evt.currentTarget);
          var id = $el.data('variant-id');
          $('.grid-product__color-image--' + id).removeClass('is-active');
        }
      });
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      $(window).off(this.namespace);
      this.$container.off(this.namespace);
      $(selectors.colorSwatch).off(this.namespace);
    }
  });

  return Collection;
})();

theme.HeaderSection = (function() {

  var selectors = {
    drawer: '#NavDrawer',
    mobileSubNavToggle: '.mobile-nav__toggle-btn',
    hasSublist: '.mobile-nav__has-sublist',
    disclosureLocale: '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
  };

  var classes = {
    navExpanded: 'mobile-nav--expanded'
  };

  function Header(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Reload any slideshow if when the header is reloaded to make sure the
    // sticky header works as expected
    theme.reinitSection('slideshow-section');

    this.initDrawers();
    theme.headerNav.init();
    theme.announcementBar.init();

    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }

    // Set a timer to resize the header in case the logo changes size
    if (Shopify.designMode) {
      setTimeout(function() {
        $('body').trigger('resize');
      }, 500);
    }
  }

  Header.prototype = $.extend({}, Header.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.settings.cartType === 'drawer') {
        new theme.CartDrawer();
      }

      this.drawerMenuButtons();
    },

    drawerMenuButtons: function() {
      $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
        evt.preventDefault();
        theme.NavDrawer.close();
      });

      var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

      $mobileSubNavToggle.attr('aria-expanded', 'false');
      $mobileSubNavToggle.each(function (i, el) {
        var $el = $(el);
        $el.attr('aria-controls', $el.attr('data-aria-controls'));
      });

      $mobileSubNavToggle.on('click', function() {
        var $el = $(this);
        var currentlyExpanded = $el.attr('aria-expanded');
        var toggleState = false;

        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $el.attr('aria-expanded', 'false');
        } else {
          $el.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle class that expands/collapses sublist
        $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
      });
    },

    onBlockSelect: function(evt) {
      theme.announcementBar.onBlockSelect(evt.detail.blockId);
    },

    onDeselect: function() {
      theme.announcementBar.onBlockDeselect();
    },

    onUnload: function() {
      theme.NavDrawer.close();
      theme.headerNav.unload();
      theme.announcementBar.unload();

      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Header;

})();

theme.FooterSection = (function() {

  var selectors = {
    disclosureLocale: '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
  };

  function Footer(container) {
    var $container = this.$container = $(container);

    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }

  Footer.prototype = $.extend({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();

theme.FeaturedContentSection = (function() {

  function FeaturedContent() {
    $('.rte').find('a:not(:has(img))').addClass('text-link');
  }

  return FeaturedContent;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {

  var selectors = {
    parallaxContainer: '.parallax-container'
  };

  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var $section = $container.parent();
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;
    this.namespace = '.' + sectionId;

    var $imageContainer = $(container).find('.hero');
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }

    this.init();

    if ($container.data('parallax')) {
      var args = {
        namespace: this.namespace
      };
      theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
    }
  }

  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {
      // Prevent slideshows from initializing on top of themselves
      this.onUnload();

      var $slideshow = $(this.slideshow);
      var args = {
        autoplay: $slideshow.data('autoplay'),
        arrows: $slideshow.data('arrows'),
        dots: $slideshow.data('dots'),
        fade: true,
        speed: 500 // same as $slideshowImageAnimationSpeed in CSS
      };

      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
    },

    forceReload: function() {
      this.init();
    },

    onUnload: function() {
      if (theme.parallaxSections[this.namespace]) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
      if (theme.slideshows[this.slideshow]) {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
      }
    },

    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();

theme.VideoSection = (function() {
  var youtubeReady;
  var videos = [];
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    }
  };

  var vimeoReady = false;
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true
  };

  var selectors = {
    videoParent: '.video-parent-section',
    promoContainer: '.promo-grid__container'
  };

  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable'
  };

  function videoSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
    this.namespace = '.' + youtubePlayerId;
    var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
    var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
    var mp4Video = 'Mp4Video-' + this.sectionId;

    var $youtubeDiv = $('#' + youtubePlayerId);
    var $vimeoDiv = $('#' + vimeoPlayerId);
    var $mp4Div = $('#' + mp4Video);

    this.vimeoPlayer = [];

    if ($youtubeDiv.length) {
      this.youtubeVideoId = $youtubeDiv.data('video-id');
      this.initYoutubeVideo();
    }

    if ($vimeoDiv.length) {
      this.vimeoVideoId = $vimeoDiv.data('video-id');
      this.initVimeoVideo();
    }

    if ($mp4Div.length) {
      setParentAsLoaded($mp4Div);

      startMp4Playback(mp4Video).then(function() {
        // Video played as expected, don't do anything
      }).catch(function(error) {
        // Video cannot be played with autoplay, so let
        // user interact with video element itself
        $mp4Div.attr('controls', '');
        setVideoToBeInteractedWith($mp4Div);
      })
    }
  }

  function startMp4Playback(mp4Video) {
    return document.querySelector('#' + mp4Video).play();
  }

  function onVideoPlayerReady(evt, id) {
    var $player = $('#' + id);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    youtubePlayers[playerId].mute();

    // Remove from tabindex because YouTube iframes are annoying and you can focus
    // on the YouTube logo and it breaks
    $player.attr('tabindex', '-1');

    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data ? id.data.id : false;
    }

    if (playerId) {
      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt, id) {
    var $player = $('#' + id);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
    .closest(selectors.videoParent)
    .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
    .closest(selectors.videoParent)
    .removeClass(classes.loading)
    .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
    .closest(selectors.videoParent)
    .addClass(classes.interactable);

    $el
    .closest(selectors.promoContainer)
    .addClass(classes.interactable);
  }

  videoSection.prototype = $.extend({}, videoSection.prototype, {
    initYoutubeVideo: function() {
      videos[this.youtubePlayerId] = {
        id: this.youtubePlayerId,
        videoId: this.youtubeVideoId,
        type: 'youtube',
        attemptedToPlay: false,
        events: {
          onReady: function(evt) {
            onVideoPlayerReady(evt, this.youtubePlayerId);
          }.bind(this),
          onStateChange: function(evt) {
            onVideoStateChange(evt, this.youtubePlayerId);
          }.bind(this)
        }
      };

      if (!youtubeReady) {
        theme.LibraryLoader.load('youtubeSdk');
        $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
      } else {
        this.loadYoutubeVideo();
      }
    },

    loadYoutubeVideo: function() {
      var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
      args.playerVars.controls = 0;
      youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

      youtubeReady = true;
    },

    initVimeoVideo: function() {
      videos[this.vimeoPlayerId] = {
        divId: this.vimeoPlayerId,
        id: this.vimeoVideoId,
        type: 'vimeo'
      };

      var $player = $('#' + this.vimeoPlayerId);
      setParentAsLoading($player);

      // Button to play video on mobile
      this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
        // $(evt.currentTarget).addClass('hide');
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      }.bind(this));

      if (!vimeoReady) {
        window.loadVimeo();
        $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
      } else {
        this.loadVimeoVideo();
      }
    },

    loadVimeoVideo: function() {
      var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
      this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

      vimeoReady = true;

      // Only autoplay on larger screens
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      } else {
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      this.vimeoPlayer[id].play();
      this.vimeoPlayer[id].setVolume(0);

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    onUnload: function(evt) {
      var sectionId = evt.target.id.replace('shopify-section-', '');
      var playerId = 'YouTubeVideo-' + sectionId;
      youtubePlayers[playerId].destroy();
      $(window).off('scroll' + this.namespace);
      $('body').off('vimeoReady' + this.namespace);
    }
  });

  return videoSection;
})();

theme.BackgroundImage = (function() {

  var selectors = {
    parallaxContainer: '.parallax-container'
  };

  function backgroundImage(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.namespace = '.' + sectionId;

    if (!$container.length) {
      return;
    }

    if ($container.data('parallax')) {
      var $parallaxContainer = $container.find(selectors.parallaxContainer);
      var args = {
        namespace: this.namespace,
        desktopOnly: true
      };

      theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
    }
  }

  backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
    onUnload: function(evt) {
      theme.parallaxSections[this.namespace].destroy();
      delete theme.parallaxSections[this.namespace];
    }
  });

  return backgroundImage;
})();

theme.Testimonials = (function() {
  var slideCount = 0;
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Testimonials(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.testimonials-wrapper';
    var slider = this.slider = '#Testimonials-' + sectionId;
    var $slider = $(slider);

    this.sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = slideCount;
      defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if (theme.config.bpSmall) {
      this.init($slider, mobileOptions);
    } else {
      this.init($slider, defaults);
    }

    $('body').on('matchSmall', function() {
      this.init($slider, mobileOptions);
    }.bind(this));

    $('body').on('matchLarge', function() {
      this.init($slider, defaults);
    }.bind(this));
  }

  Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;

      if (AOS) {
        AOS.refresh();
      }
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Testimonials;
})();

theme.NewsletterPopup = (function() {
  function NewsletterPopup(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.cookieName = 'newsletter-' + sectionId;

    if (!$container.length) {
      return;
    }

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.data = {
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: Cookies.get(this.cookieName),
      testMode: $container.data('test-mode')
    };

    this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

    // Open modal if errors or success message exist
    if ($container.find('.errors').length || $container.find('.note--success').length) {
      this.modal.open();
    }

    // Set cookie as opened if success message
    if ($container.find('.note--success').length) {
      this.closePopup(true);
      return;
    }

    $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

    if (!this.data.cookie || this.data.testMode) {
      this.initPopupDelay();
    }
  }

  NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
    initPopupDelay: function() {
      setTimeout(function() {
        this.modal.open();
      }.bind(this), this.data.secondsBeforeShow * 1000);
    },

    closePopup: function(success) {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode) {
        Cookies.remove(this.cookieName, { path: '/' });
        return;
      }

      var expiry = success ? 200 : this.data.daysBeforeReappear;

      Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
    },

    onLoad: function() {
      this.modal.open();
    },

    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    },

    onUnload: function() {}
  });

  return NewsletterPopup;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.map-' + this.sectionId;
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (!this.key) {
      return;
    }

    // Lazyload API
    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    prepMapApi: function() {
      if (apiStatus === 'loaded') {
        this.createMap();
      } else {
        mapsToLoad.push(this);

        if (apiStatus !== 'loading') {
          apiStatus = 'loading';
          if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
            $.getScript(
              'https://maps.googleapis.com/maps/api/js?key=' + this.key
            ).then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
          }
        }
      }
    },

    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            backgroundColor: 'none',
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());

          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    checkVisibility: function() {
      if (theme.isElementVisible(this.$container, 600)) {
        this.prepMapApi();
        $(window).off(this.namespace);
      }
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.Blog = (function() {

  function Blog(container) {
    this.tagFilters();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    tagFilters: function() {
      var $filterBy = $('#BlogTagFilter');

      if (!$filterBy.length) {
        return;
      }

      $filterBy.on('change', function() {
        location.href = $(this).val();
      });
    },

    onUnload: function() {

    }
  });

  return Blog;
})();

theme.Photoswipe = (function() {
  var selectors = {
    trigger: '.js-photoswipe__zoom',
    images: '.photoswipe__image',
    activeImage: '.slick-active .photoswipe__image'
  };

  function Photoswipe(container, sectionId) {
    this.$container = $(container);
    this.sectionId = sectionId;
    this.namespace = '.photoswipe-' + this.sectionId;
    this.gallery;
    this.$images;
    this.inSlideshow = false;

    if (this.$container.attr('data-zoom') === 'false') {
      return;
    }

    if (this.$container.attr('data-has-slideshow') === 'true') {
      this.inSlideshow = true;
    }

    this.init();
  }

  Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
    init: function() {
      var $trigger = this.$container.find(selectors.trigger);
      this.$images = this.$container.find(selectors.images);
      var items = [];

      // Init gallery on active image
      $trigger.on('click' + this.namespace, function(evt) {
        items = this.getImageData();
        if (this.inSlideshow) {
          var index = this.$container.find(selectors.activeImage).data('index');
        } else {
          var index = $(evt.currentTarget).data('index');
        }
        this.initGallery(items, index);
      }.bind(this));
    },

    getImageData: function() {
      var haveImages = false;
      var items = [];
      var options = {};

      this.$images.each(function() {
        var haveImages = true;
        var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
        var item = {
          msrc: smallSrc,
          src: $(this).data('photoswipe-src'),
          w: $(this).data('photoswipe-width'),
          h: $(this).data('photoswipe-height'),
          el: $(this)[0],
          initialZoomLevel: 0.5
        };

        items.push(item);
      });

      return items;
    },

    initGallery: function(items, index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];

      var options = {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: index - 1,
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'zoom',
        shareEl: false,
        tapToToggleControls: false,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = items[index].el;
          var rect = thumbnail.getBoundingClientRect();
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      }

      this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      this.gallery.init();
      this.gallery.listen('afterChange', this.afterChange.bind(this));
    },

    afterChange: function() {
      if (this.inSlideshow) {
        var $slideshow = $('#ProductPhotos-' + this.sectionId);
        if ($slideshow.hasClass('slick-initialized')) {
          var newIndex = this.gallery.getCurrentIndex();
          $slideshow.slick('slickGoTo', newIndex);
        }
      }
    }
  });

  return Photoswipe;
})();



// Medium breakpoint is also set in theme.scss.liquid and inline throughout some templates.
// Do not change values unless you know what you're doing.
theme.bp = {};
theme.bp.smallUp = 769;
theme.bp.small = theme.bp.smallUp - 1;

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
  mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1),
  stickyHeader: false,
  recentlyViewed: []
};

if (theme.config.isIpad) {
  document.documentElement.className += ' js-ipad';
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.onYouTubeIframeAPIReady = function() {
  theme.config.youTubeReady = true;
  $('body').trigger('youTubeReady');
}

window.loadVimeo = function() {
  if (theme.config.vimeoLoading) {
    return;
  }

  if (!theme.config.vimeoReady) {
    theme.config.vimeoLoading = true;
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
    .then(function() {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      $('body').trigger('vimeoReady');
    })
    .fail(function() {
      // No vimeo API to talk to
    });
  }
}

function checkIfVimeoIsReady() {
  var deferred = $.Deferred();
  var wait;
  var timeout;

  wait = setInterval(function() {
    if (!Vimeo) {
      return;
    }

    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
  }, 500);

  timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
  }, 4000); // subjective. test up to 8 times over 4 seconds

  return deferred;
}

theme.init = function() {
  theme.setGlobals();
  theme.pageTransitions();
  theme.collapsibles.init();
  theme.rte.init();

  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('tab-outline');
      $(document.documentElement).off('keyup.tab');
    }
  });

  // Change email icon to submit text
  $('.footer__newsletter-input').on('keyup', function() {
    $(this).addClass('footer__newsletter-input--active');
  });
};

theme.initSecondary = function() {
  theme.initQuickShop();
  if (theme.settings.predictiveSearch) {
    theme.predictiveSearch.init();
  }
  theme.collectionTemplate.init();
  theme.customerTemplates.init();
  theme.videoModal();
};

theme.setGlobals = function() {
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  if (theme.config.isTouch) {
    $('body').addClass('supports-touch');
  }

  enquire.register(theme.config.mediaQuerySmall, {
    match: function() {
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.config.mediaQuerySmallUp, {
    match: function() {
      $('body').trigger('matchLarge');
    },
    unmatch: function() {
      $('body').trigger('unmatchLarge');
    }
  });
};

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};

theme.isStorageSupported = function(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.isElementVisible = function($el, threshold) {
  var rect = $el[0].getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

theme.pageTransitions = function() {
  if ($('body').data('transitions') == true) {
    var namespace = '.page-transition';

    // Hack test to fix Safari page cache issue.
    // window.onpageshow doesn't always run when navigating
    // back to the page, so the unloading class remains, leaving
    // a white page. Setting a timeout to remove that class when leaving
    // the page actually finishes running when they come back.
    if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
      $('a').off(namespace).on('click' + namespace, function() {
        window.setTimeout(function() {
          $('body').removeClass('unloading');
        }, 1200);
      });
    }

    // Add disable transition class to malito, anchor, and YouTube links
    $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
      $(this).addClass('js-no-transition');
    });

    $('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function(evt) {
      if (evt.metaKey) return true;
      evt.preventDefault();
      $('body').addClass('unloading');
      var src = $(this).attr('href');
      window.setTimeout(function() {
        location.href = src;
      }, 50);
    });

    // iOS caches the page state, so close the drawer when navigating away
    $('a.mobile-nav__link').off(namespace).on('click' + namespace, function() {
      theme.NavDrawer.close();
    });
  }
};

theme.reinitSection = function(section) {
  for (var i = 0; i < sections.instances.length; i++) {
    var instance = sections.instances[i];
    if (instance['type'] === section) {
      if (typeof instance.forceReload === 'function') {
        instance.forceReload();
      }
    }
  }
};

theme.reinitProductGridItem = function($scope) {
  if (AOS) {
    AOS.refreshHard();
  }

  // Reload quick shop buttons
  theme.initQuickShop();

  // Refresh reviews app
  if (window.SPR) {
    SPR.initDomEls();SPR.loadBadges();
  }

  // Re-register product templates in quick view modals.
  // Will not double-register.
  sections.register('product-template', theme.Product, $scope);

  // Re-hook up collapsible box triggers
  theme.collapsibles.init();
};

window.onpageshow = function(evt) {
  // Removes unload class when returning to page via history
  if (evt.persisted) {
    $('body').removeClass('unloading');
  }
};

$(document).ready(function() {
  theme.init();

  window.sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('background-image', theme.BackgroundImage);
  sections.register('recently-viewed', theme.RecentlyViewed);
  sections.register('product', theme.Product);
  sections.register('product-recommendations', theme.Recommendations);
  sections.register('product-template', theme.Product);
  sections.register('collection-header', theme.CollectionHeader);
  sections.register('collection-sidebar', theme.CollectionSidebar);
  sections.register('collection-template', theme.Collection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('newsletter-popup', theme.NewsletterPopup);
  sections.register('map', theme.Maps);
  sections.register('blog', theme.Blog);
  sections.register('photoswipe', theme.Photoswipe);
  sections.register('footer-section', theme.FooterSection);

  theme.initSecondary();
});
})(theme.jQuery);


// NEWSLETTER POPUP A
$(document).ready(function() {
  $('.itsNewsletter').click(function(e) {
    e.preventDefault();
    $('html').addClass('modal-open');
    $('body').addClass('modal-open');
    $('#NewsletterPopup-newsletter-popup').addClass('modal--is-active');
    $('#NewsletterPopup-newsletter-popup').attr('tabindex', '-1');

  });

  $('.modal__inner .js-modal-close').click(function(e) {
    e.preventDefault();
    $('html').removeClass('modal-open');
    $('body').removeClass('modal-open');
    $('#NewsletterPopup-newsletter-popup').removeClass('modal--is-active');
    $('#NewsletterPopup-newsletter-popup').attr('tabindex', '0');

  });

  $("#its_slick_products").not('.order-a-sample-temp').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    prevArrow:"<img class='a-left control-c prev slick-prev' src='//www.charlesandivy.co.uk/cdn/shop/t/244/assets/back.svg?v=30776576670876837991740837063'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='//www.charlesandivy.co.uk/cdn/shop/t/244/assets/next.svg?v=55079854589860590101740837222'>",
    responsive: [
    {
      breakpoint: 761,
      settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '40px',
      slidesToScroll: 1
    }}]
 });
  
  $(".order-a-sample #its_slick_products").slick({
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    prevArrow:"<img class='a-left control-c prev slick-prev' src='//www.charlesandivy.co.uk/cdn/shop/t/244/assets/back.svg?v=30776576670876837991740837063'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='//www.charlesandivy.co.uk/cdn/shop/t/244/assets/next.svg?v=55079854589860590101740837222'>",
    responsive: [
    {
      breakpoint: 761,
      settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '40px',
      slidesToScroll: 1
    }}]
 });

  function checkScreenSize(){
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 769) {
      $("#AnnouncementSlider").slick({
        infinite: true,
        arrows: false,
        autoplay: true
      });
    }
  }

  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  // var selectedVariant = $('.product-single__variants').find(":selected").text();
  // console.log('selectedVariant', selectedVariant)
  // if (selectedVariant && selectedVariant.includes('Bespoke')) {
  //   $('.manageipv.variant-input.vv-bespoke').trigger('click');
  // }
});

$(window).on('load', function() {
  setTimeout(function() {
    $('.announcement-bar .page-width').css('opacity', '1');
  }, 100);
  $('#its_slick_products').slick('setPosition');
  
  var selectedVariant = $('.product-single__variants').find(":selected").text();
  let selectedVariantLower = selectedVariant.toLowerCase();

  if (selectedVariant && selectedVariantLower.includes('bespoke')) {
    $('.manageipv.variant-input.vv-bespoke').trigger('click');
  }
});

$(document).on('click', '.cpb-option', function() {
  $('.cpb-selection-summary').show();
  setTimeout(function() {
    $('.cpb-selection-summary-list-item-category-title').each(function() {
      var a = $(this).text();
      a = a.replace(':', '');
      a = a + ':'
      a = a.replace('Select ', '');
      a = a.replace('Choose ', '');
      $(this).text(a);
    });
  }, 150);
});

$(window).on('load', function() {
  $('.wrp-inline1').trigger('click');
  $('.template-index div[data-section-type="collection-template"]').css({opacity: '1', width: 'auto', overflow: 'auto'});
});

$('.wrp-inline').click(function() {
  var id = $(this).attr('id-var');
  $('.size_img').each(function() {
    var imgid = $(this).attr('id-img');
    if (imgid && imgid.includes(id)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
});
// .cpb-root .cpb-preview-container
$(window).scroll(function(){
  if ($(this).scrollTop() > 50) {
    $('.cpb-root .cpb-preview-container').addClass('newClass');
  } else {
    $('.cpb-root .cpb-preview-container').removeClass('newClass');
  }
});
$(window).resize(function() {
  var headerheight = $('#myheadersticky').outerHeight();
  // console.log('headerheightheaderheight', headerheight)
  // $('#MainContent').css('padding-top', headerheight);
});
$(document).ready(function() {
  // setTimeout(function() {  
  //   var headerheight = $('#myheadersticky').outerHeight();
  //   var newWindowWidth = $(window).width();
  //   if (newWindowWidth > 767 && headerheight < 100) {
  //     headerheight = 160;
  //   }
  //   headerheight = parseInt(headerheight);
  //   $('#MainContent').css('padding-top', headerheight);
  // }, 500);
  
  $('section.step-1.fencewrapper .onethird').click(function() {
    var currentclick = $(this).attr('data-attr');
    var urlpost = '';
    var urlslat = '';
    $('.imgstatus').removeClass('active');
    if (currentclick == 'decorative') {
      $('.imgstatus[activeattr="decorative"]').addClass('active');
      urlpost = '/products/customizable-fence-builder';
      urlslat = '/products/customizable-fence-builder-1';
    } else if (currentclick == 'slatted') {
      $('.imgstatus[activeattr="slatted"]').addClass('active');
      urlpost = '/products/fence-builder';
      urlslat = '/products/fence-builder-1';
    } else if (currentclick == 'plainfence') {
      $('.imgstatus[activeattr="plainfence"]').addClass('active');
      urlpost = '/products/plain-fence-builder';
      urlslat = '/products/plain-fence-builder-1';
    }
    $('section.step-1.fencewrapper .onethird').removeClass('active');
    $(this).addClass('active');
    $('.postshref').attr('href', urlpost);
    $('.slattedhref').attr('href', urlslat);
    $('html, body').animate({
      scrollTop: $("#step2fencewrapper").offset().top - 130
    }, 1000);
  });

  $('.contentbtnwrp').click(function() {
    $('.postshref').attr('href', '#');
    $('.slattedhref').attr('href', '#');
  });

  var timing = 300;
  var questionDiv = $('#FAQ .faq-q');
  var answerDiv = $('.faq-a');
  // add class-name 'closedFAQ' to 'faq-a' DIVs

  $(questionDiv).click(function() {
    if ($(this).children(answerDiv).hasClass('openFAQ')) {
      $(this).children(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
      $(this).removeClass('openFAQA').addClass('closedFAQA');
    } else if ($(answerDiv).hasClass('openFAQ')) {
      $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
      $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
      $(this).removeClass('closedFAQA').addClass('openFAQA');
    } else {
      $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
      $(this).removeClass('closedFAQA').addClass('openFAQA');
    }
  });

  $('.cnus').click(function() {
    $('.contactusbtn').trigger('click');
    $('.contactusbtn').addClass('active');
  });

});

$(document).ready(function() {
  $('.ajcart .minus').click(function () {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $('.ajcart .plus').click(function () {
    var $input = $(this).parent().find('input');
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });

  var sticky = $('.cpb-preview-wrapper');
  var headerHeight = $('#myheadersticky').outerHeight();
  $('.filter-wrapper-width').css('top', headerHeight+'px');
  $('.collection-filter').css('top', headerHeight-2+'px');
  $('.upper-filter-bar').css('top', headerHeight-2+'px');
});

$(window).scroll(function(){ 
  // var headerheight = $('#myheadersticky').outerHeight();
  // $('#MainContent').css('padding-top', headerheight);
  
  // var sticky = $('.cpb-preview-wrapper');
  // var headerHeight = $('#myheadersticky').outerHeight();
  // $('.filter-wrapper-width').css('top', headerHeight+'px');
  // $('.collection-filter').css('top', headerHeight-2+'px');
  // $('.upper-filter-bar').css('top', headerHeight-2+'px');

  // if ($('.cpb-product-actions-container').offset()) {
  //   var hT = $('.cpb-product-actions-container').offset().top,
  //       hH = $('.cpb-product-actions-container').outerHeight(),
  //       wH = $(window).height(),
  //       wS = $(this).scrollTop();
  //   if (wS > (hT+hH+120-wH)){
  //     sticky.removeClass('fixed');
  //   } else {
  //     sticky.addClass('fixed');
  //   }
  //   if (wS < 200){
  //     sticky.removeClass('fixed');
  //   }
  // }
  // if ($('#in12yearklarna').length) {
  //   var a = $('#in12yearklarna').offset().top;
  //   var b = $(document).scrollTop() + 100;

  //   if (b > a) {
  //     $('.imgaj').css('position', 'relative');
  //   } else {
  //     $('.imgaj').css('position', 'sticky');
  //   }
  // }
});


$(window).on('load', function () {
  if(window.location.href.includes('/cart')) {
    setTimeout(() => {
               var cartContents = fetch('/cart.js')
      .then(response => {
        response.json().then((a) => {
          a = theme.Currency.formatMoney(a.total_price);
          $('.pprice p').html(a);
        });
      })
    }, 500);
  }

    var d = new Date();
    var n = d.getDay();
//     if (n == 0 || n == 6) {
//       $('.wrapod').hide();
//     } else {
   var session_floating_button_visibility = sessionStorage.getItem("session_floating_button_visibility");
    if (session_floating_button_visibility && session_floating_button_visibility == 'true') {
      $('.wrapod').hide();
    } else {
      $('.wrapod').show();
    }
//     }
//   if ($('.variant-input[data-value="210cm"]')) {
//       $('.variant-input[data-value="180cm"] input').trigger('click');
//       setTimeout(() => {
//          $('.variant-input[data-value="210cm"] input').trigger('click');     
//       },40);
//   } else {
//       $('.variant-input[data-value="150cm"] input').trigger('click');
//       setTimeout(() => {
//          $('.variant-input[data-value="180cm"] input').trigger('click');     
//       },40);	
//   }
});
$(document).ready(function() {
  $(document).on('click', '.select-screen-step2 .cpb-option-type-img', function() {
    setTimeout(function() {   
      $('.select-color-step3 .option-type-color:first-child span').trigger('click');
    }, 1000);
    setTimeout(function() {   
      $('.select-color-step4 .option-type-color:last-child span').trigger('click');
    }, 1500);
    setTimeout(function() {   
      $('.step-fixing-kit .option-type-text:first-child span').trigger('click');
    }, 2100);

    setTimeout(function() {   
      $('.channel-type-last.step-channel .option-type-text:first-child span').trigger('click');
    }, 2200);
  });

  $(document).on('click', '.step-plain-slat-colour .cpb-option-type-color', function() {
    setTimeout(function() {   
      $('.step-fixing-kit .option-type-text:first-child span').trigger('click');
    }, 1000);
  });

  $(document).on('click', '.step-1-update-image .cpb-option-type-img', function() {
    setTimeout(function() {   
      $('.cpb-preview-container').css('background', '#F5F5F5');
    }, 700);
    setTimeout(function() {
      $('.template-product .cpb-category-text.hide-fence-builder-slat-capping .option-type-text:first-child span').trigger('click');
    }, 1200);

  });

  $(document).on('click', '.cartClear', function () {

    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        location.reload();
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    return false;
  });
});
var changeAddToCartText = (function() {
  if( $('.cpb-add-to-cart-button span').length) {
    $('.cpb-add-to-cart-button span').text('Add to basket');
    $('.cpb-add-to-cart-button .lnr.lnr-cart').hide();
  } else {
    window.requestAnimationFrame(changeAddToCartText);
  }
});
changeAddToCartText();
$('.variant-input label').click(function(e) {
  var atrr = $(this).parents('.variant-input').attr('data-value');
   if ($(this).hasClass('disabled')) {} else {
    if ($(this).parents('.variant-input').find('input:checked').length > 0) {} else {
      $(this).parents('.variant-wrapper--button').find('.selectec_variant_value').html(atrr);
      $(this).parents('.variant-wrapper--button').find('.selectec_variant_value_ip').val(atrr);
    }
  }
});

$('.variant-input').click(function(e) {  
  var atrr = $(this).attr('data-value');
  var stepname = $(this).attr('data-step-name');
  var stephandle = $(this).attr('data-step-handle');
  
  if (atrr == '90cm') {
    $('.its90cmpost').addClass('bundlethree ');
    $('.its30cmpost').removeClass('bundlethree ');
  }

  if (atrr == '30cm') {
    $('.its30cmpost').addClass('bundlethree ');
    $('.its90cmpost').removeClass('bundlethree ');
  }
    
  if ($(this).find('label').hasClass('disabled')) {} else {
    if ($(this).find('input:checked').length > 0) {} else {
      // $(this).parents('.variant-wrapper--button').find('.selectec_variant_value').html(atrr);
    }
    if (stephandle) {
      $("."+stephandle).val(atrr);
    }
  }
});

function renderListSale() {
  var sizeF = [];
  var colorF = [];
  var disF = [];
  var screenF = [];
  var i = 0;
  var j = 0;
  var k = 0;
  var l = 0;
  var numberOfChecked = $('input:checkbox:checked').length;
  var numberOfRadio = $('input:radio:checked').length;

  if ((numberOfChecked + numberOfRadio) == 0 ) {
      $('.saleproductslist').removeClass('hideee');
      return false;
  }
  
  $('.sizecheckboxfilter').each(function() {
        if ($(this).is(':checked')) {
          sizeF[i] = $(this).val(); 
          i++;
        }
  });
  
  $('.colourcheckboxfilter').each(function() {
        if ($(this).is(':checked')) {
          colorF[j] = $(this).val(); 
          j++;
        }
  });
  
  $('.discountcheckboxfilter').each(function() {
        if ($(this).is(':checked')) {
          disF[k] = $(this).val(); 
          k++;
        }
  });
  
  $('.screentypecheckboxfilter').each(function() {
        if ($(this).is(':checked')) {
          screenF[l] = $(this).val(); 
          l++;
        }
  });
  
  setTimeout(function() {
  $('.saleproductslist').addClass('hideee');    
    $('.saleproductslist').each(function() {
        var atr = $(this).attr('data-filter');
        var disatr = $(this).attr('data-dis');
      
        var siz = true;
        if (sizeF.length > 0) {
          siz = atr.includes(sizeF[0]) || atr.includes(sizeF[1]) || atr.includes(sizeF[2]) || atr.includes(sizeF[3]);
        }
        var col = true;
        if (colorF.length > 0) {
          col = atr.includes(colorF[0]) || atr.includes(colorF[1]) || atr.includes(colorF[2]) || atr.includes(colorF[3]);
        }
        var dis = true;
        if (disF.length > 0) {
          dis = disatr.includes(disF[0]) || disatr.includes(disF[1]) || disatr.includes(disF[2]) || disatr.includes(disF[3]);
        }
        var screen = true;  
        if (screenF.length > 0) {
          screen = atr.includes(screenF[0]) || atr.includes(screenF[1]) || atr.includes(screenF[2]) || atr.includes(screenF[3]) || atr.includes(screenF[4]) || atr.includes(screenF[5])  || atr.includes(screenF[6])  || atr.includes(screenF[7])  || atr.includes(screenF[8])  || atr.includes(screenF[9]);
        } 
        if (siz && col && dis && screen) {
          $(this).removeClass('hideee');
        }
    });
  },500);
}

$('.sizecheckboxfilter, .colourcheckboxfilter, .discountcheckboxfilter, .screentypecheckboxfilter').change(function() {
    $('span.clearfiler').fadeIn();
  renderListSale();
});

$('span.clearfiler').click(function() {
  $('input:radio').prop('checked', false);
  $('input:radio').attr('checked', false);
  $('.saleproductslist').removeClass('hideee');  
  $('span.clearfiler').fadeOut();
});

$('.template-product .variant-input').click(function() {
  $('select.product-single__variants').trigger('change');
});

// $('button.togglefilterdesk').click(function() {
//   	$('.coll-composite-fences .grid__item--sidebar, .coll-composite-gates .grid__item--sidebar').toggleClass('w-0');
// 	$('.coll-composite-fences .medium-up--four-fifths, .coll-composite-gates .medium-up--four-fifths').toggleClass('w-100');
//   	var lab = $(this).children('span').text().toLowerCase();
//     if (lab == 'refine your search') {
//       $(this).children('span').text('Hide filters');
//     } else {
//       $(this).children('span').text('Refine your search');
//     }
// });

$(document).on("click", "ul.tag-list--checkboxes .init", function() {
    $(this).parent('ul').find("ul.no-bullets.aj").toggle();
});

var allOptions = $("ul.tag-list--checkboxes").children('li:not(.init)');
// $(document).on("click", "ul.tag-list--checkboxes li:not(.init)", function() {
//     allOptions.removeClass('selected');
//     $(this).addClass('selected');
//     $("ul.tag-list--checkboxes").children('.init').html($(this).html());
//     allOptions.toggle();
// });

$(document).on("click", "ul.no-bullets.aj .tag.tag-selected-aj a", function(e) {
  e.preventDefault();
  var a = $(this).attr('data-current-tag');
  a = a.replace('by-', '');
  a = a.replace('post-', '');
  location.href = $('.remove-'+a+' a').attr('href');

});

$(document).ready(function() {
  $("input.widthincm").change(function(){
    var width = parseFloat($(this).val());
    var height = 1; 
    var packs = width * height;
    packs = packs/40;
    $('.widthheightincm').val(Math.ceil(packs));
  });
  $("input.heightincm").change(function(){
    var width = parseFloat($(this).val());
    var height = parseFloat($('.widthincm').val()); 
    var packs = width * height;
    packs = packs/10000;
    $('.widthheightincm').val(Math.ceil(packs));
  });

  
  $("input.widthincm_wall_panel").change(function(){
    var width = parseFloat($(this).val());
    var height = parseFloat($('.heightincm_wall_panel').val()); 
    if (height && width) {
      var packs = width * height;
      packs = packs/10000;
      var isspecialpacksize = $('#its-special-panel-size').val();
      var isspecialpacksizestaggered = $('#its-special-panel-size-staggered').val();
      var areacovered_slatwall = 0;
      var templatesuffix = $('#templatesuffix').val();
        var url = location.href;

      if (templatesuffix == 'aquaslat_wall_panel') {
        var size_of_aquaslat = $('.size_of_aquaslat').val();
        if (size_of_aquaslat == 'h250-x-w20cm') {          
          packs = packs/1;     
          areacovered_slatwall = packs*1;
        } else {          
          packs = packs/1.2;     
          areacovered_slatwall = packs*1.2;
        }
      } else {
        if (url && url.includes('240cm-x-60cm-2-pack') && url.includes('240cm-x-60cm-2-pack')) {
          packs = packs/2.88;     
          areacovered_slatwall = packs*2.88;          
        } else if (isspecialpacksize == 'true') {
          packs = packs/1.8;     
          areacovered_slatwall = packs*1.8;
        } else if (isspecialpacksizestaggered == 'true') {
          packs = packs/2.88;        
          areacovered_slatwall = packs*1.88;
        } else {
          packs = packs/1.44;
          areacovered_slatwall = packs*1.44;
        }
      }
      $('.widthheightincm').html(Math.ceil(packs));
      $('.areacovered_slatwall').html(areacovered_slatwall.toFixed(2));
      $('.widthheightincm_btn').html(Math.ceil(packs)+' Packs');
      if (Math.ceil(packs) > 0) {
        $('button.btn.addpacks_btn').css('opacity', 1);
      } else {        
        $('button.btn.addpacks_btn').css('opacity', 0.4);
      }
    }
  });
  
  $("input.heightincm_wall_panel").change(function(){
    var height = parseFloat($(this).val());
    var width = parseFloat($('.widthincm_wall_panel').val()); 
    if (height && width) {
      var packs = width * height;
      packs = packs/10000;
      var isspecialpacksize = $('#its-special-panel-size').val();
      var isspecialpacksizestaggered = $('#its-special-panel-size-staggered').val();
      var areacovered_slatwall = 0;
      var templatesuffix = $('#templatesuffix').val();
        var url = location.href;

      if (templatesuffix == 'aquaslat_wall_panel') {
        var size_of_aquaslat = $('.size_of_aquaslat').val();
        if (size_of_aquaslat == 'h250-x-w20cm') {          
          packs = packs/1;     
          areacovered_slatwall = packs*1;
        } else {          
          packs = packs/1.2;     
          areacovered_slatwall = packs*1.2;
        }
      } else {
        if (url && url.includes('240cm-x-60cm-2-pack') && url.includes('240cm-x-60cm-2-pack')) {
          packs = packs/2.88;     
          areacovered_slatwall = packs*2.88;          
        } else if (isspecialpacksize == 'true') {
          packs = packs/1.8;
          areacovered_slatwall = packs*1.8;
        } else if (isspecialpacksizestaggered == 'true') {
          packs = packs/2.88;       
          areacovered_slatwall = packs*1.88; 
        } else {
          packs = packs/1.44;
          areacovered_slatwall = packs*1.44;
        }
      }
      $('.widthheightincm').html(Math.ceil(packs));
      $('.areacovered_slatwall').html(areacovered_slatwall.toFixed(2));
      $('.widthheightincm_btn').html(Math.ceil(packs)+' Packs');
      if (Math.ceil(packs) > 0) {
        $('button.btn.addpacks_btn').css('opacity', 1);
      } else {        
        $('button.btn.addpacks_btn').css('opacity', 0.4);
      }
    }
  });

  $(document).on('change', 'input.bespoke_width', function() {
  // $("input.bespoke_width").change(function() {
    var width = parseFloat($(this).val());    
    var idd = $('#productidkit').val();
    var height = parseFloat($('.bespoke_height').val()); 
    if (height && width) {
      var packs = width * height;
      if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("driveway-gate") > -1) { 
        packs = (width * height)/100;
      }
      var price = packs * 0.011;
      var cmp_price = 0;
      var selectedVariant = $('.product-single__variants').find(":selected").text();
      if (selectedVariant && selectedVariant.includes('18mm')) {
        price = packs * 0.017;
      }
      
      price = parseFloat(price) * 100;
      if (price < 8500) {
        price = 8500;
      }
      if (selectedVariant && selectedVariant.includes('18mm')) {
        if (price < 10500) {
          price = 10500;
        }
      }
      if (window.location.href.indexOf("pedestrian") > -1) { 
        cmp_price = packs * 0.068;
        price = packs * 0.060;
        price = parseFloat(price) * 100;
        cmp_price = parseFloat(cmp_price) * 100;
        if (price < 64350) {
          price = 64350;
          cmp_price = 56628;
        }
      }
      if (window.location.href.indexOf("driveway-gate") > -1) {
        var initialPriceGate = $('#ProductPriceGetByVariantSelection').html();
        initialPriceGate = parseFloat(initialPriceGate.replace('£', '').replace(',', '')) * 100;

        price = packs * 0.027;
        price = parseFloat(price) * 100;
        cmp_price = packs * 0.031;
        cmp_price = parseFloat(cmp_price) * 100;
        if (price < initialPriceGate) {
          price = initialPriceGate;
        }
      }
    if (cmp_price > price) {  
        var ab = '<s class="colorred">'+theme.Currency.formatMoney(cmp_price, theme.settings.moneyFormat)+'</s>'
        ab += '<span class="price-current">'+theme.Currency.formatMoney(price, theme.settings.moneyFormat)+'</span>';

      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
      $('#ProductPrice-'+idd+'-3').html(ab);
    } else {
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-3').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
    }
      $('.selected_bespoke_area').html(packs/100+' cm sq');
     if (window.location.href.indexOf("driveway-gate") > -1) {
      $('.elehide-gate-post-required .manageipv').trigger('click');  
     }
    }
  });

  $(document).on('change', 'input.pedestriangates_ip', function() {
    var width = parseFloat($(this).val());    
    var idd = $('#productidkit').val();
    var height = parseFloat($('.bespoke_height').val()); 
    if (height && width) {
      var packs = (width * height)/100;
      var price = packs * 0.060;
      var cmp_price = packs * 0.068;
      price = parseFloat(price) * 100;
      cmp_price = parseFloat(cmp_price) * 100;
      
      if (price < 64350) {
        price = 64350;
        cmp_price = 56628;
      }
    if (cmp_price > price) {  
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(cmp_price, theme.settings.moneyFormat)+'</s>'
      ab += '<span class="price-current">'+theme.Currency.formatMoney(price, theme.settings.moneyFormat)+'</span>';

      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
      $('#ProductPrice-'+idd+'-3').html(ab);
    } else {
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-3').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
    }
      $('.gateprice_lineitem').val(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('.selected_bespoke_area').html(packs/100+' cm sq');

     if (window.location.href.indexOf("pedestrian") > -1) {
      $('.active_automation .manageipv').click();
     }
    }
  });

  $(document).on('change', 'input.bespoke_height', function() {
  // $("input.bespoke_height").change(function() {
    var height = parseFloat($(this).val());
    var idd = $('#productidkit').val();
    var width = parseFloat($('.bespoke_width').val()); 
    if (window.location.href.indexOf("pedestrian") > -1) {  
      width = parseFloat($('.pedestriangates_ip').val());   
    }
    if (height && width) {
      var packs = width * height;
      if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("driveway-gate") > -1) {
        packs = (width * height)/100;
      }
      var price = packs * 0.011;
      var cmp_price = 0;
      var selectedVariant = $('.product-single__variants').find(":selected").text();
      if (selectedVariant && selectedVariant.includes('18mm')) {
        price = packs * 0.017;
      }
      price = parseFloat(price) * 100;
      if (price < 8500) {
        price = 8500;
      }
      if (selectedVariant && selectedVariant.includes('18mm')) {
        if (price < 10500) {
          price = 10500;
        }
      }
      if (window.location.href.indexOf("pedestrian") > -1) {
        price = packs * 0.060;
        cmp_price = packs * 0.068;
        price = parseFloat(price) * 100;
        cmp_price = parseFloat(cmp_price) * 100;
        if (price < 64350) {
          price = 64350;
          cmp_price = 56628;
        }
      }
      if (window.location.href.indexOf("driveway-gate") > -1) { 
        price = packs * 0.027;
        price = parseFloat(price) * 100;
        cmp_price = packs * 0.031;
        cmp_price = parseFloat(cmp_price) * 100;
        var initialPriceGate = $('#ProductPriceGetByVariantSelection').html();
        initialPriceGate = parseFloat(initialPriceGate.replace('£', '').replace(',', '')) * 100;
        if (price < initialPriceGate) {
          price = initialPriceGate;
        }
      }

    if (cmp_price > price) {  
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(cmp_price, theme.settings.moneyFormat)+'</s>'
      ab += '<span class="price-current">'+theme.Currency.formatMoney(price, theme.settings.moneyFormat)+'</span>';

      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
      $('#ProductPrice-'+idd+'-3').html(ab);
    } else {
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-3').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
    }
      $('.gateprice_lineitem').val(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
            $('.selected_bespoke_area').html(packs/100+' cm sq');
     if (window.location.href.indexOf("driveway-gate") > -1 || window.location.href.indexOf("pedestrian") > -1) {
      $('.elehide-gate-post-required .manageipv').trigger('click');  
     }
    }
  });
  
  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
  });

  $('.image_with_text_carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
          slidesToScroll: 1
        }
      }
  ]
  });

  $('.basic-text-icon-wrapper').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '40px',
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.toggle_filter_button').click(function() {
    $(this).parents('#CollectionAjaxContent').find('.grid__item--sidebar').hide();
    $(this).parents('#CollectionAjaxContent').find('.grid__item--content').removeClass('.medium-up--four-fifths');
    $(this).parents('#CollectionAjaxContent').find('.grid__item--content').addClass('w-100');
    $('.open_filter_button').removeClass('hide');
  });
  
  $('.open_filter_button').click(function() {
    $(this).parents('#CollectionAjaxContent').find('.grid__item--sidebar').show();
    $(this).parents('#CollectionAjaxContent').find('.grid__item--content').addClass('.medium-up--four-fifths');
    $(this).parents('#CollectionAjaxContent').find('.grid__item--content').removeClass('w-100');
    $('.open_filter_button').addClass('hide');
  });
  
  $('.variant__button-label[slat_type="one-side"]').click(function() {
    $('input.custom_grained').removeAttr('checked');
    $('input.one-lined-other-grained').attr('checked', 'checked');

  });
  $('.variant__button-label[slat_type="both-side"]').click(function() {
    $('input.custom_grained').removeAttr('checked');
    $('input.both-grained').attr('checked', 'checked');
  });

  if ($('input[slat_type_input="both-side"]').is(':checked')) {
    $('input.custom_grained').removeAttr('checked');
    $('input.both-grained').attr('checked', 'checked');
  } else {
    $('input.custom_grained').removeAttr('checked');
    $('input.one-lined-other-grained').attr('checked', 'checked');
  }

  $('.owl-next-custom').click(function() {
  	$(this).parents('.index-section-coll').find('.slick-next').trigger('click');
  	$(this).parents('.index-section-coll').find('.owl-next').trigger('click');
  });

  $('.owl-prev-custom').click(function() {
  	$(this).parents('.index-section-coll').find('.slick-prev').trigger('click');
  	$(this).parents('.index-section-coll').find('.owl-prev').trigger('click');
  });

  $('.variant-input-wrap[name="fixing kit"] .variant-input').click(function() {
    var op = $(this).attr('data-value');
    $('#fixing-kit-info').html(op);   
    $('.selectedfixingkit').html(op);
  });
  
  $('.variant-input-wrap[name="fence height"] .variant-input, .variant-input-wrap[name="Fence height"] .variant-input').click(function() {
    var op = $(this).attr('data-value');
    op = op.replace('cm', '');
    op = parseInt(op);
    if (op == 210 || op == 240) {
      op = op;
    } else {
      op = op + 7;
    }
    $('.specifications_post_height').html(op+'cm');    
    $('.specificationheightin').html(($(this).attr('data-value')).replace('cm', ''));    
  });
  
  $('.variant-input-wrap[name="post height"] .variant-input, .variant-input-wrap[name="Post height"] .variant-input').click(function() {
    var op = $(this).attr('data-value');
    op = op.replace('cm', '');
    op = parseInt(op);
    if (op == 210 || op == 240) {
      op = op;
    } else {
      op = op + 7;
    }
    $('.specifications_post_height').html(op+'cm');    
    $('.specificationheightin').html(($(this).attr('data-value')).replace('cm', ''));    
  });
  
  $('.variant-input-wrap[name="Gate height"] .variant-input').click(function() {
    var op = $(this).attr('data-value');
    op = op.replace('cm', '');
    op = parseInt(op);
    // if (op == 210 || op == 240) {
    //   op = op;
    // } else {
    //   op = op + 7;
    // }
    $('.specifications_post_height').html(op+'cm');    
    $('.specificationheightin').html(($(this).attr('data-value')).replace('cm', ''));    
  });
  
});

$(document).on('click', '.btn.addpacks_btn', function() {
  var qty = parseInt($('.widthheightincm').html());
  if (qty > 1) {
    qty = qty - 1;
  }
  $('.wrapper-btn-qty .js-qty__num').val(qty);
  $('.wrapper-btn-qty button.js-qty__adjust.js-qty__adjust--plus').click();
  $('button.add-to-cart').click();
  $('.overlay_drawer').click();
});
  
  
$('.elehide-gate-post-required .manageipv').click(function() {
  var atr = $(this).attr('managev');
  var idd = $(this).attr('pid');
  var initialPrice = $(this).find('input:checked').attr('price');
  gatePriceCalculateFun(atr, idd, initialPrice);
});

$('.active_automation .manageipv').click(function() {
  var idd = $(this).attr('pid');
    if (window.location.href.indexOf("pedestrian")) {   
    var drivewayBespoke_Pedes_array = calculateBespokePrice(true);
    if ($('.vv-bespoke-ral-colour input').is(':checked')) {
      drivewayBespoke_Pedes_array = calculateBespokePrice();
    }
    var drivewayBespoke_Pedes = drivewayBespoke_Pedes_array[0];
    var comp_drivewayBespoke_Pedes = drivewayBespoke_Pedes;
      if (drivewayBespoke_Pedes_array && drivewayBespoke_Pedes_array[1]) {
        comp_drivewayBespoke_Pedes = drivewayBespoke_Pedes_array[1];
      }
    var qty = parseInt($('.wrapper-btn-qty .js-qty__num').val());
    var crntprice = $('#ProductPriceGetByVariantSelection').html();
    crntprice = parseFloat(crntprice.replace('£', '').replace(',', ''))  *  qty * 100;

    var crntcmpprice = $('#ProductCompPriceGetByVariantSelection').html();
    crntcmpprice = parseFloat(crntcmpprice.replace('£', '').replace(',', ''))  *  qty * 100;
    if (drivewayBespoke_Pedes) {} else {
      drivewayBespoke_Pedes = crntprice;
      comp_drivewayBespoke_Pedes = crntcmpprice;
    }    

    var activeOptionsPrice = 0;
    $('.active_automation').each(function() {
      var price_activateoptions = $(this).find('input:checked').attr('price') ? parseFloat($(this).find('input:checked').attr('price')) : 0;
      activeOptionsPrice = activeOptionsPrice + price_activateoptions;
    });
    activeOptionsPrice = activeOptionsPrice * qty;

    var gatePostReq = $('.elehide-gate-post-required .manageipv').find('input:checked').attr('valuehandle');
    var gatePostPrice = 0;
    if (gatePostReq == 'yes') {
      gatePostPrice = parseFloat($('.elehide-gate-post-required .manageipv').find('input:checked').attr('price')) * 100 * qty * 2;
    }
    drivewayBespoke_Pedes = drivewayBespoke_Pedes + activeOptionsPrice + gatePostPrice;
    comp_drivewayBespoke_Pedes = comp_drivewayBespoke_Pedes + activeOptionsPrice + gatePostPrice;


    if (crntcmpprice > crntprice || comp_drivewayBespoke_Pedes > drivewayBespoke_Pedes) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(comp_drivewayBespoke_Pedes, theme.settings.moneyFormat)+'</s>'
          ab += '<span class="redtext">'+theme.Currency.formatMoney(drivewayBespoke_Pedes, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
      $('#ProductPrice-'+idd+'-3').html(ab);
    } else {    
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(drivewayBespoke_Pedes, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(drivewayBespoke_Pedes, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(drivewayBespoke_Pedes, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-3').html(theme.Currency.formatMoney(drivewayBespoke_Pedes, theme.settings.moneyFormat));
    }
        
  } else {
    var atr = $('.elehide-gate-post-required').find('input:checked').parent('.manageipv').attr('managev');
    var idd = $('.elehide-gate-post-required').find('input:checked').parent('.manageipv').attr('pid');
    var initialPrice =$('.elehide-gate-post-required').find('input:checked').attr('price');
    gatePriceCalculateFun(atr, idd, initialPrice);
  }
});

function gatePriceCalculateFun(atr, idd, initialPrice) {  
  var atr = atr;
  var idd = idd;
  var initialPrice = initialPrice;
  var qty = parseInt($('.wrapper-btn-qty .js-qty__num').val());
  var price = parseFloat(initialPrice);
      price =  price * 2 * qty * 100;

  if (price && price != 'NaN') {
    var crntprice = $('#ProductPriceGetByVariantSelection').html();
    crntprice = parseFloat(crntprice.replace('£', '').replace(',', '')) * 100 * qty;

    var crntcmpprice = $('#ProductCompPriceGetByVariantSelection').html();
    crntcmpprice = parseFloat(crntcmpprice.replace('£', '').replace(',', '')) * 100 * qty;
    var pr = 0;
    var prcmp = 0;
    var drivewayBespoke_array = calculateBespokePrice();
    var drivewayBespoke = drivewayBespoke_array[0];
    var drivewayBespokeComp = drivewayBespoke;
    if (drivewayBespoke_array && drivewayBespoke_array[1]) {
      drivewayBespokeComp = drivewayBespoke_array[1];
    }

    var activeOptionsPrice = 0;
    $('.active_automation').each(function() {
      var price_activateoptions = $(this).find('input:checked').attr('price') ? parseFloat($(this).find('input:checked').attr('price')) : 0;
      activeOptionsPrice = activeOptionsPrice + price_activateoptions;
    });
    activeOptionsPrice = activeOptionsPrice * qty;
    drivewayBespoke = drivewayBespoke + activeOptionsPrice;
    drivewayBespokeComp = drivewayBespokeComp + activeOptionsPrice;
        
    if (atr == 'v-yes') {
      if (window.location.href.indexOf("driveway-gate") > -1 && drivewayBespoke) {         
        pr = drivewayBespoke + price;
        prcmp = drivewayBespokeComp + price;
      } else {
        pr = crntprice + price;
        prcmp = crntcmpprice + price;
      }
    } else {
      if (window.location.href.indexOf("driveway-gate") > -1 && drivewayBespoke) {    
        pr = drivewayBespoke;
        prcmp = drivewayBespokeComp;
      } else {
        pr = crntprice;
        prcmp = crntcmpprice;
      }
    }

    var vvprice = pr;
    var vvcprice = prcmp;
    var pid = $('#productidkit').val();
    var quantityy = parseInt($('#Quantity-'+pid).val());
    var lightengingvalue = $('.type_of_power_lightening:checked').val();

    var prc = 0;
    var cprc = 0;
    var isLighteningSelected = $('.dflx_lumifence input:checked').val();
    if (lightengingvalue && isLighteningSelected == 'Yes') {
      if (lightengingvalue && lightengingvalue.includes('solar')) {
        cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
        prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
      } else {
        cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
        prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
      }
    }

    var vprice = vvprice + prc;
    var vcprice = vvcprice + cprc;

    if (prcmp > pr || drivewayBespokeComp > drivewayBespoke) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
          ab += '<span class="redtext">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
    } else {    
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
    }
  }
}

  $('.ele-lumiplanter-required .variant-input').click(function() {
    var v = $(this).attr('data-value');
    v = v.trim();
    if (v == 'Yes') {
      $('.elehide-led-lighting .variant-input[managev="v-with-led"] label').trigger('click');
    } else {      
      $('.elehide-led-lighting .variant-input[managev="v-without-led"] label').trigger('click');
    }
    $('.elehide-planter-post-required  input[type=radio]:checked+label').trigger('click');
  });
  
$('.elehide-planter-post-required .manageipv').click(function() {
  var atr = $(this).attr('managev');
  var idd = $(this).attr('pid');
  var qty = parseInt($('.wrapper-btn-qty .js-qty__num').val());

  var planterType = $('#plantertype').val();
  var selectedBaseColor = $('.elehide-base-colour').find('input:checked').attr('valuehandle');
  
  var price = parseFloat($('.planter-'+planterType+'-'+selectedBaseColor).attr('price'));
      price =  price * qty;
  if (price && price != 'NaN') {
    var crntprice = $('#ProductPriceGetByVariantSelection').html();
    crntprice = parseFloat(crntprice.replace('£', '').replace(',', '')) * 100 * qty;
    var crntcmpprice = $('#ProductCompPriceGetByVariantSelection').html();
    crntcmpprice = parseFloat(crntcmpprice.replace('£', '').replace(',', '')) * 100 * qty;

    var pr = 0;
    var prcmp = 0;
    if (atr == 'v-yes') {
      pr = crntprice + price;
      prcmp = crntcmpprice + price;
    } else {
      pr = crntprice;
      prcmp = crntcmpprice;
    }

        var vvprice = pr;
        var vvcprice = prcmp;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());
        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
        }

        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;

    if (prcmp > pr) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="redtext">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+idd).html(ab);
      $('#ProductPrice-'+idd+'-1').html(ab);
      $('#ProductPrice-'+idd+'-2').html(ab);
    } else {    
      $('#ProductPrice-'+idd).html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-1').html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
      $('#ProductPrice-'+idd+'-2').html(theme.Currency.formatMoney(pr, theme.settings.moneyFormat));
    }
  }
});

function checkStatusLumi(tht) {
  var that = tht;
  setTimeout(function() {
        var a = $('#ProductPriceGetByVariantSelection').text();
        var b = $('#ProductCompPriceGetByVariantSelection').text();
        a = a.replace('£', '');
        a = a.replace(',', '');
        a = parseFloat(a);
        a = a * 100;
        
        b = b.replace('£', '');
        b = b.replace(',', '');
        b = parseFloat(b);
        b = b * 100;
          
        var vvprice = a;
        var vvcprice = b;
        var pid = $('#productidkit').val();
        var quantityy = parseInt($('#Quantity-'+pid).val());

        var lightengingvalue = $('.type_of_power_lightening:checked').val();
        var prc = 0;
        var cprc = 0;
        var isLighteningSelected = $('.dflx_lumifence input:checked').val();
        if (lightengingvalue && isLighteningSelected == 'Yes') {
          if (lightengingvalue && lightengingvalue.includes('solar')) {
            cprc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.solar_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          } else {
            cprc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('datacprice'));
            prc = parseFloat($('.mains_lumifence[data-qty="'+quantityy+'"]').attr('dataprice'));
          }
          $('.selected_lumifence_light').html('Yes');
        } else {
          $('.selected_lumifence_light').html('No');
        }
        vvprice = vvprice * quantityy;
        vvcprice = vvcprice  * quantityy;
        var vprice = vvprice + prc;
        var vcprice = vvcprice + cprc;
       
    if ($('#templatesuffix').val() == 'wall_panel') {
      var typeOfBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('datatype');
      var sizeOfBatten = $('.extra-step-wall-panel-sizes.active .variant-input.current_active').attr('data-value');
      var ledBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('data-value');

            var sidetrim_batten = false;
            if ($('.led_lighting_wall_panel .variant-input.current_active').hasClass('sidetrim_batten')) {
              sidetrim_batten = true;
            }
      
        var battenPrice = '';
        if (sidetrim_batten) {
            if (typeOfBatten == 'no-batten') {
              battenPrice = 0;
            } else if (typeOfBatten == 'black-side') {
              battenPrice = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
            } else if (typeOfBatten == 'slat-colour-side') {
              battenPrice = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
            }          
        } else {
            if (typeOfBatten == 'no-batten') {
              battenPrice = 0;
            } else if (typeOfBatten == 'black') {
              battenPrice = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
            } else if (typeOfBatten == 'slat-colour') {
              battenPrice = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
            }          
        }

        var vprice = vvprice + (battenPrice * 1);
        var vcprice = vvcprice + (battenPrice * 1);

        var additionalBatten = $('.dflx_additional_batten_type input:checked').val();
        if (additionalBatten == sizeOfBatten) {
            vprice = vvprice + (battenPrice * 2);
            vcprice = vvcprice + (battenPrice * 2);
        }
                var additionalBattenPrice = '';

                if (additionalBatten != 'no' && additionalBatten != sizeOfBatten) {
                  if (sidetrim_batten) {
                      if (typeOfBatten == 'no-batten') {
                        additionalBattenPrice = 0;
                      } else if (typeOfBatten == 'black-side') {
                        additionalBattenPrice = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').attr('dataprice');
                      } else if (typeOfBatten == 'slat-colour-side') {
                        additionalBattenPrice = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').attr('dataprice');
                      }          
                  } else {
                      if (typeOfBatten == 'no-batten') {
                        additionalBattenPrice = 0;
                      } else if (typeOfBatten == 'black') {
                        additionalBattenPrice = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').attr('dataprice');
                      } else if (typeOfBatten == 'slat-colour') {
                        additionalBattenPrice = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+additionalBatten+'"]').attr('dataprice');
                      }          
                  }

                  
                  vprice = vvprice + (battenPrice * 1) + (parseFloat(additionalBattenPrice) * 1);
                  vcprice = vvcprice + (battenPrice * 1) + (parseFloat(additionalBattenPrice) * 1);
                }

      var ledStripLightP = $('.insuslat-insuslat-led-strip-quantity.selected_ele .variant-input.current_active').find('input').attr('data-price');
      var ledStripLightCP = $('.insuslat-insuslat-led-strip-quantity.selected_ele .variant-input.current_active').find('input').attr('data-cprice');

      if (ledStripLightP) {
        ledStripLightP = parseFloat(ledStripLightP);
        vprice = vprice + ledStripLightP;
      }

      if (!ledStripLightCP) {
        ledStripLightCP = ledStripLightP;
      }
      if (ledStripLightCP) {
        ledStripLightCP = parseFloat(ledStripLightCP);
        if (vcprice) {} else {
          vcprice = vprice;
        }
        vcprice = vcprice + ledStripLightCP;
      }



      var hookShelvingLightP = $('.insuslat-insuslat-hook-shelving.selected_ele .variant-input.current_active').find('input').attr('data-price');
      var hookShelvingLightCP = $('.insuslat-insuslat-hook-shelving.selected_ele .variant-input.current_active').find('input').attr('data-cprice');

      if (hookShelvingLightP) {
        hookShelvingLightP = parseFloat(hookShelvingLightP);
        vprice = vprice + hookShelvingLightP;
      }
      
      if (!hookShelvingLightCP) {
        hookShelvingLightCP = hookShelvingLightP;
      }
      if (hookShelvingLightCP) {
        hookShelvingLightCP = parseFloat(hookShelvingLightCP);
        if (vcprice) {} else {
          vcprice = vprice;
        }
        vcprice = vcprice + hookShelvingLightCP;
      }
        if (battenPrice >= 0) {
              if (vcprice > vprice) {
                var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
                        ab += '<span class="redtext">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
                $('#ProductPrice-'+pid).html(ab);
                $('#ProductPrice-'+pid+'-1').html(ab);
                $('#ProductPrice-'+pid+'-2').html(ab);
                $('#ProductPrice-'+pid+'-3').html(ab);
              } else {    
                $('#ProductPrice-'+pid).html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
                $('#ProductPrice-'+pid+'-1').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
                $('#ProductPrice-'+pid+'-2').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
                $('#ProductPrice-'+pid+'-3').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
              }
        }      
    } else  if (that.hasClass('ele_additional-bin-store')) {
      var pri_add_btn = parseFloat(that.attr('dataprice'));
      if (pri_add_btn) {} else {
        pri_add_btn = 0;
      }
      var cpri_add_btn = parseFloat(that.attr('datacprice'));
      if (cpri_add_btn) {} else {
        cpri_add_btn = 0;
      }
      vprice = vvprice + (pri_add_btn * 1);
      vcprice = vvcprice + (cpri_add_btn * 1);
    if (vvcprice > vvprice) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="redtext">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+pid).html(ab);
      $('#ProductPrice-'+pid+'-1').html(ab);
      $('#ProductPrice-'+pid+'-2').html(ab);
      $('#ProductPrice-'+pid+'-3').html(ab);
    } else {    
      $('#ProductPrice-'+pid).html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-1').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-2').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-3').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
    }
    $('.ele-lumifence-type-required').addClass('active');
  } else  if (that.hasClass('ele_lumi_valhandle-pyes')) {
    if (vvcprice > vvprice) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(vcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="redtext">'+theme.Currency.formatMoney(vprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+pid).html(ab);
      $('#ProductPrice-'+pid+'-1').html(ab);
      $('#ProductPrice-'+pid+'-2').html(ab);
      $('#ProductPrice-'+pid+'-3').html(ab);
    } else {    
      $('#ProductPrice-'+pid).html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-1').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-2').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-3').html(theme.Currency.formatMoney(vprice, theme.settings.moneyFormat));
    }
    $('.ele-lumifence-type-required').addClass('active');
  } else {
    if (vvcprice > vvprice) {
      var ab = '<s class="colorred">'+theme.Currency.formatMoney(vvcprice, theme.settings.moneyFormat)+'</s>'
              ab += '<span class="redtext">'+theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+pid).html(ab);
      $('#ProductPrice-'+pid+'-1').html(ab);
      $('#ProductPrice-'+pid+'-2').html(ab);
      $('#ProductPrice-'+pid+'-3').html(ab);
    } else {
      var ab = '<span class="redtext">'+theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat)+'</span>';
      $('#ProductPrice-'+pid).html(ab);
      $('#ProductPrice-'+pid).html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-1').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-2').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
      $('#ProductPrice-'+pid+'-3').html(theme.Currency.formatMoney(vvprice, theme.settings.moneyFormat));
    }
    $('.ele-lumifence-type-required').removeClass('active');
  }

            if (lightengingvalue && isLighteningSelected == 'Yes') {
              // $('.template-product .btn.add-to-cart span').html('Pre-Order (Delivery end of August)');
              if ($(".click-lumifence-image")[0]){
                $('.template-product .product__photos .product__thumb-item.click-lumifence-image').click();
              } else {
                $('.template-product .product__photos .product__thumb-item[data-index="1"]').click();
              }
              var i = $('.mainslide-lumifence').attr('data-index');
              if (i && i >= 0) {
                $('.product__main-photos .slick-slider').slick('slickGoTo', i);
              }
            } else {
              // $('.template-product .btn.add-to-cart span').html('Add to basket');
            }
  }, 50);
}


$(document).on('click', '.pack-size .link-wrapper-bundle.metaimage_wrapper_step', function() {
  $(this).next().click();
});

$(document).on('click', '.size-depth .link-wrapper-bundle.metaimage_wrapper_step', function() {
  $(this).next().click();
});

$(document).on('click', '.dflex_steps_invisi', function() {
  $('.dflex_steps_invisi').removeClass('current_active');
  $(this).addClass('current_active');
  checkStatusLumi($(this));
});

$(document).on('click', '.dflex_steps_invisi_hook', function() {
  $('.dflex_steps_invisi_hook').removeClass('current_active');
  $(this).addClass('current_active');
  checkStatusLumi($(this));
});

$(document).on('click', '.insuslat-insuslat-led-strip-confirmation .variant-input', function() {
  var s = $(this).parents('.insuslat-insuslat-led-strip-confirmation').find('input:checked').val();
  $(this).parents('.insuslat-insuslat-led-strip-confirmation').addClass('toggle');
  $('.insuslat-insuslat-hook-shelving-strip-confirmation').addClass('toggle');
  setTimeout(() => {
    $(this).parents('.insuslat-insuslat-led-strip-confirmation').removeClass('toggle');
    $('.insuslat-insuslat-hook-shelving-strip-confirmation').removeClass('toggle');
  }, 10);
  if (s == 'Yes') {
    $('.insuslat-insuslat-led-strip-height').show();
    $('.insuslat-insuslat-led-strip-height').addClass('selected_ele');
    
    $('.insuslat-insuslat-led-strip-quantity').show();
    $('.insuslat-insuslat-led-strip-quantity').addClass('selected_ele');
  } else {
    $('.insuslat-insuslat-led-strip-height').hide();
    $('.insuslat-insuslat-led-strip-height').removeClass('selected_ele');
    
    $('.insuslat-insuslat-led-strip-quantity').hide();
    $('.insuslat-insuslat-led-strip-quantity').removeClass('selected_ele');
  }
  checkStatusLumi($(this));
});

$(document).on('click', '.insuslat-insuslat-led-strip-height .variant-input, .insuslat-invisible-led-strip-remote-control .elehide-size .variant-input', function() {
  var s = $(this).parents('.insuslat-insuslat-led-strip-height').find('input:checked').val();
  if (s) {} else {
    s = $(this).parents('.elehide-size').find('input:checked').val();
  }
  $('.dflex_steps_invisi').removeClass('current_active');
  $('.dflex_steps_invisi input').removeAttr('checked');
  if (s == '240cm') {
    $('.its240cm_invisible_light').show();
    $('.its300cm_invisible_light').hide();
    $('.its240cm_invisible_light.index_invisi_1').addClass('current_active');
    $('.its240cm_invisible_light.index_invisi_1 input').attr('checked', 'checked');
  } else {
    $('.its240cm_invisible_light').hide();
    $('.its300cm_invisible_light').show();
    $('.its300cm_invisible_light.index_invisi_1').addClass('current_active');
    $('.its300cm_invisible_light.index_invisi_1 input').attr('checked', 'checked');
  }
  checkStatusLumi($(this));
});

$(document).on('click', '.insuslat-insuslat-hook-shelving-strip-confirmation .variant-input', function() {
  var s = $(this).parents('.insuslat-insuslat-hook-shelving-strip-confirmation').find('input:checked').val();
  $('.insuslat-insuslat-hook-shelving-strip-confirmation').addClass('toggle');
  setTimeout(() => {
    $(this).parents('.insuslat-insuslat-led-strip-confirmation').removeClass('toggle');
    $('.insuslat-insuslat-hook-shelving-strip-confirmation').removeClass('toggle');
  }, 10);
  if (s == 'Yes') {
    $('.insuslat-insuslat-hook-shelving').show();
    $('.insuslat-insuslat-hook-shelving').addClass('selected_ele');
  } else {
    $('.insuslat-insuslat-hook-shelving').hide();
    $('.insuslat-insuslat-hook-shelving').removeClass('selected_ele');
  }
  checkStatusLumi($(this));
});


$(document).on('click', '.ele_lumi_valhandle', function() {
    checkStatusLumi($(this));
});

$('.additional-bin-store .variant-input').click(function(e) {
  e.preventDefault();
  $('.additional-bin-store .variant-input').removeClass('current_active');
  $(this).addClass('current_active');
  checkStatusLumi($(this));
  var s = $(this).attr('data-value');
  if (s == 'yes') {
    $('.selected_additional_batten_status').html('Yes');
  } else {
    $('.selected_additional_batten_status').html('No');
  }  
});

$(document).on('click', '.dflx_additional_batten_type .variant-input', function() {
  var additionalBatten = $('.dflx_additional_batten_type input:checked').val();
  if (additionalBatten) {
    const s1 = additionalBatten;
    const s2 = `${s1.charAt(0).toUpperCase()}${s1.slice(1)}`;
    $(this).parents('.variant-wrapper').find('.selected_lighting_power_method').html(s2);
  }
  checkStatusLumi($(this));
});

$(document).on('click', '.dflx_lumifence_type label', function() {
  $('.dflx_lumifence.variant-input-wrap input[type=radio]:checked+label').trigger('click');
  $('.selected_lighting_power_method').html($(this).find('span').html());
});

$(document).ready(function() {  
  function checkBattenPrice() {
  if ($('#templatesuffix').val() == 'wall_panel') {
      var typeOfBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('datatype');
      var sizeOfBatten = $('.extra-step-wall-panel-sizes.active .variant-input.current_active').attr('data-value');
      var ledBatten = $('.led_lighting_wall_panel .variant-input.current_active').attr('data-value');

        var battenPrice = '';
    var sidetrim_batten = false;
    if ($('.led_lighting_wall_panel .variant-input.current_active').hasClass('sidetrim_batten')) {
      sidetrim_batten = true;
    }

    if (sidetrim_batten) {
        if (typeOfBatten == 'black-side') {
          battenPrice = $('.sidebatten.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
        } else if (typeOfBatten == 'slat-colour-side') {
          battenPrice = $('.sidebatten.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
        }      
    } else {
        if (typeOfBatten == 'black') {
          battenPrice = $('.blackbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
        } else if (typeOfBatten == 'slat-colour') {
          battenPrice = $('.slatcolouredbatten_ids[option1="'+ledBatten+'"][option2="'+sizeOfBatten+'"]').attr('dataprice');
        }
    }
        if (battenPrice) {
        }
      
    }
  }

  $('.led_lighting_wall_panel .variant-input').click(function() {
    var at = $(this).attr('datatype');
    $('.led_lighting_wall_panel .variant-input').removeClass('current_active')
    $(this).addClass('current_active');
    
    if (at == 'no-batten') {
      $('.led_lighting_wall_panel').removeClass('active');
      $('.extra-step-wall-panel-sizes').removeClass('active');      
      $('.product__thumb img[alt="no-batten"]').parents('.product__thumb-item').click();
      var index = $('.mediaphone[alt="no-batten"]').attr('dataindex');
      $('.ProductPhotos-mobileslider').trigger('to.owl.carousel', [index, 500, true]);// 500 is the speed of the transition in ms
      $('.ele-additional_batten-type-required').hide();
      var atrname = $('.with_lighting_value_dynmic').attr('name');
      $('.with_lighting_value_dynmic').attr('name', 'eee_'+atrname);
    } else {
      
      var atrname = $('.with_lighting_value_dynmic').attr('name');
      $('.with_lighting_value_dynmic').attr('name', atrname.replace('eee_', ''));
      
      if ($(this).hasClass('sidetrim_batten')) {
        $('.ele-additional_batten-type-required').hide();
      } else {
        $('.ele-additional_batten-type-required').show();
      }
      $('.led_lighting_wall_panel').addClass('active');
      $('.extra-step-wall-panel-sizes').addClass('active');   

      var isled =  $('.led_lighting_wall_panel.active .variant-input.current_active').attr('data-value');
      var index = 0;
      if (isled == 'no') {
        $('.product__thumb img[alt="'+at+'-batten-without-led"]').parents('.product__thumb-item').click();
        index = $('.mediaphone[alt="'+at+'-batten-without-led"]').attr('dataindex');
        $('.with_lighting_value_dynmic').val('No');
      } else {
        $('.with_lighting_value_dynmic').val('Yes');
        $('.product__thumb img[alt="'+at+'-batten-with-led"]').parents('.product__thumb-item').click();
        index = $('.mediaphone[alt="'+at+'-batten-with-led"]').attr('dataindex');
      }      
      $('.ProductPhotos-mobileslider').trigger('to.owl.carousel', [index, 500, true]);// 500 is the speed of the transition in ms
      // if (at == 'black') {
      //   $('.blackbatten_image').show();
      //   $('.coloured_image_batten').hide();
      // } else {
      //   $('.blackbatten_image').hide();
      //   $('.coloured_image_batten').show();        
      // }
    }
   checkStatusLumi($(this));
    
      $('.product-steps-wrapper').addClass('no_batten_toggle_content_counter');
      setTimeout(function() {
        $('.product-steps-wrapper').removeClass('no_batten_toggle_content_counter');
      }, 10)
  });

  $('.driveway_aluminium_gate_post_required .variant-input .link-wrapper-bundle').click(function() {
    var managev = $(this).parent().attr('managev');
    if (managev == 'v-yes') {
      $('.product__thumb img[alt="gate-post"]').parents('.product__thumb-item').click();
    } else {
      $('.product__thumb-item[data-index="0"]').click();
    }
  });
  
  $('.extra-step-wall-panel-sizes .variant-input').click(function() {
    var at = $(this).attr('data-value');
    $('.extra-step-wall-panel-sizes .variant-input').removeClass('current_active')
    $(this).addClass('current_active');    
    checkStatusLumi($(this));
  });
  
  // $('.led_lighting_wall_panel .variant-input').click(function() {
  //   var at = $(this).attr('data-value');
  //   $('.led_lighting_wall_panel .variant-input').removeClass('current_active')
  //   $(this).addClass('current_active');    
  //   var index = 0;
  //   var isled =  $('.extra-step-wall-panel-type .variant-input.current_active').attr('data-value');
  //     if (at == 'no') {
  //       $('.product__thumb img[alt="'+isled+'-batten-without-led"]').parents('.product__thumb-item').click();
  //       index = $('.mediaphone[alt="'+isled+'-batten-without-led"]').attr('dataindex');
  //     } else {
  //       $('.product__thumb img[alt="'+isled+'-batten-with-led"]').parents('.product__thumb-item').click();
  //       index = $('.mediaphone[alt="'+isled+'-batten-with-led"]').attr('dataindex');
  //     }
  //     $('.ProductPhotos-mobileslider').trigger('to.owl.carousel', [index, 500, true]);// 500 is the speed of the transition in ms
  //    checkStatusLumi($(this));
  // });

  $('.temp-suffix-wall_panel .product__quantity button.js-qty__adjust').click(function() {
    setTimeout(function() {
    checkStatusLumi($(this));
    },51);
  });
 if (window.location.href.indexOf("pedestrian") > -1) {
   $('.elehide-frame-colour .variant-input label').click(function() {
     $('.totalpriceproduct').css('opacity', '0');
     setTimeout(function() {
      $('.active_automation .manageipv').click();        
       $('.totalpriceproduct').css('opacity', '1');
     }, 151);
   })
 }
  $('.manageipv.variant-input').click(function() {
  if ($(this).find('input').prop('disabled')) {
  } else {
    if ($(this).hasClass('vv-bespoke')) {
      if (atr && atr.includes('bespoke') && (atr && atr.includes('ral') || atr && atr.includes('colour'))) {
        $('.bespoke_panel_ral').addClass('active'); 
        $('.manageipv.variant-input[managev="v-bespoke-size-bespoke-size"] input').attr('disabled', true);
      } else {
        $('.bespoke_panel_ral').removeClass('active');        
      }
    } else {
      var atr = $(this).attr('managev');
      if (atr.includes('bespoke') && (atr && atr.includes('size') || atr && atr.includes('height'))) {
        $('.bespoke_panel_size').addClass('active');
        $('.bespoke-confirmation').addClass('active');
        $('span.infopro.w').addClass('shw');
        $('.template-product .product__quantity.product__quantity--button').addClass('visihide');
        $('.product-single__meta .wrapper-btn-qty').addClass('fullwidthele');
        $('.template-product main .js-qty__num').val('1');
      } else if (atr.includes('bespoke') && (atr && atr.includes('ral') || atr && atr.includes('colour'))) {
        $('.bespoke_panel_ral').addClass('active');
        $('.bespoke-confirmation').addClass('active');
        $('span.infopro.w').addClass('shw');
        $('.template-product .product__quantity.product__quantity--button').addClass('visihide');
        $('.product-single__meta .wrapper-btn-qty').addClass('fullwidthele');
        $('.template-product main .js-qty__num').val('1');
      } else if (atr.includes('digital-handle') || atr.includes('galvanised')) {
      }else {
        $('.bespoke_panel_size').removeClass('active');
        $('.bespoke_panel_ral').removeClass('active');   
         if (window.location.href.indexOf("pedestrian") > -1 || window.location.href.indexOf("bin-store") > -1) {}else {
          $('.bespoke-confirmation').removeClass('active');
         }
        $('span.infopro.w').removeClass('shw');
        $('.template-product .product__quantity.product__quantity--button').removeClass('visihide');
        $('.product-single__meta .wrapper-btn-qty').removeClass('fullwidthele');
      }
      if (window.location.href.indexOf("driveway") > -1) {
        $('.bespoke-confirmation').addClass('active');
        $('.template-product .product__quantity.product__quantity--button').addClass('visihide');
        $('.product-single__meta .wrapper-btn-qty').addClass('fullwidthele');
      }
    }

    if (window.location.href.indexOf("pedestrian") > -1) {
      
      setTimeout(() => {
      var name_pd = $('input.bespoke_height').attr('name');
      var atr = $(this).attr('managev');
      if (atr == 'v-bespoke-size-bespoke-size' || atr == 'v-bespoke-size-bespoke') {
        $('input.bespoke_height').attr('required', true);
        if (name_pd) {
          name_pd = name_pd.replace('ele_not_rew', '');
          $('input.bespoke_height').attr('name', name_pd);
        }
      } else {
        $('input.bespoke_height').removeAttr('required');
        if (name_pd) {
        $('input.bespoke_height').attr('name', 'ele_not_rew'+name_pd);
        }
      }
      }, 150);
    }
  }
  });

  $('.insuslat-bespoke-confirmation label').click(function() { 
      setTimeout(() => {
      var insuslatStatus = $(this).parents('.insuslat-bespoke-confirmation').find('input:checked').val();
      
      var insuslatHeighthtml = '<div class="variant-wrapper inususlat_bespoke_height_step">';  
      insuslatHeighthtml += '<label class="variant__label" for="width-in-cm">';
      insuslatHeighthtml += '<span>Step 5:</span>&nbsp;Please enter your required height&nbsp;<b class="selected_bespoke_height_insuslat"></b>';
      insuslatHeighthtml += '</label>';
      insuslatHeighthtml += '<div class="variant-input-wrap-line">';
      insuslatHeighthtml += '<div class="variant-input-line" data-index="option1">';
      if (window.location.href.indexOf("300cm-x-60cm") > -1) {
        insuslatHeighthtml += '<input type="number" class="insuslat_bespoke_height" required=""  max="3000" class="w-100" name="properties[Height of your insuslat wall (in mm)]" placeholder="Please enter your height in mm (maximum 3000mm)">';
      } else {
        insuslatHeighthtml += '<input type="number" class="insuslat_bespoke_height" required=""  max="2400" class="w-100" name="properties[Height of your insuslat wall (in mm)]" placeholder="Please enter your height in mm (maximum 2400mm)">';
      }
      insuslatHeighthtml += '</div>';
      insuslatHeighthtml += '</div>';
      insuslatHeighthtml += '<div class="additional_info_gates_height">';
      insuslatHeighthtml += '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><circle cx="17.5" cy="17.5" r="17.5" fill="#F0D2D2"></circle><path d="M18.29 14.87V25H16.51V14.87H18.29ZM18.67 11.69C18.67 11.8633 18.6333 12.0267 18.56 12.18C18.4933 12.3267 18.4 12.46 18.28 12.58C18.1667 12.6933 18.03 12.7833 17.87 12.85C17.7167 12.9167 17.5533 12.95 17.38 12.95C17.2067 12.95 17.0433 12.9167 16.89 12.85C16.7433 12.7833 16.6133 12.6933 16.5 12.58C16.3867 12.46 16.2967 12.3267 16.23 12.18C16.1633 12.0267 16.13 11.8633 16.13 11.69C16.13 11.5167 16.1633 11.3533 16.23 11.2C16.2967 11.04 16.3867 10.9033 16.5 10.79C16.6133 10.67 16.7433 10.5767 16.89 10.51C17.0433 10.4433 17.2067 10.41 17.38 10.41C17.5533 10.41 17.7167 10.4433 17.87 10.51C18.03 10.5767 18.1667 10.67 18.28 10.79C18.4 10.9033 18.4933 11.04 18.56 11.2C18.6333 11.3533 18.67 11.5167 18.67 11.69Z" fill="black"></path></svg>';
      insuslatHeighthtml += '<p>If you are pairing with our top trim batten, please reduce your height by 25mm.</p>';
      insuslatHeighthtml += '</div>';      
      insuslatHeighthtml += '</div>';

      if (insuslatStatus == 'No') {
        $('.inususlat_bespoke_height_step').remove();
      } else {
        if ($(".inususlat_bespoke_height_step")[0]){
        } else {
          $('.insuslat-bespoke-confirmation').after(insuslatHeighthtml);          
        }
      }
      }, 101);
  });

  $('.do-you-want-your-panel-made-to-your-custom-height .manageipv.variant-input, .do-you-want-the-height-cut-to-size .manageipv.variant-input').click(function() { 
      setTimeout(() => {
      var insuslatStatus = $(this).parents('.do-you-want-your-panel-made-to-your-custom-height').find('input:checked').val();
      if (insuslatStatus) {} else {
        insuslatStatus = $(this).parents('.do-you-want-the-height-cut-to-size').find('input:checked').val();
      }
      var insuslatHeighthtml = '<div class="variant-wrapper inususlat_bespoke_height_step">';  
      insuslatHeighthtml += '<label class="variant__label" for="width-in-cm">';
      insuslatHeighthtml += '<span>Step 5:</span>&nbsp;Please enter your required height&nbsp;<b class="selected_bespoke_height_insuslat"></b>';
      insuslatHeighthtml += '</label>';
      insuslatHeighthtml += '<div class="variant-input-wrap-line">';
      insuslatHeighthtml += '<div class="variant-input-line" data-index="option1">';
      if (window.location.href.indexOf("300cm-x-60cm") > -1) {
        insuslatHeighthtml += '<input type="number" class="insuslat_bespoke_height" required=""  max="3000" class="w-100" name="properties[Height of your insuslat wall (in mm)]" placeholder="Please enter your height in mm (maximum 3000mm)">';
      } else {
        insuslatHeighthtml += '<input type="number" class="insuslat_bespoke_height" required=""  max="2400" class="w-100" name="properties[Height of your insuslat wall (in mm)]" placeholder="Please enter your height in mm (maximum 2400mm)">';
      }
      insuslatHeighthtml += '</div>';
      insuslatHeighthtml += '</div>';
      insuslatHeighthtml += '<div class="additional_info_gates_height">';
      insuslatHeighthtml += '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><circle cx="17.5" cy="17.5" r="17.5" fill="#F0D2D2"></circle><path d="M18.29 14.87V25H16.51V14.87H18.29ZM18.67 11.69C18.67 11.8633 18.6333 12.0267 18.56 12.18C18.4933 12.3267 18.4 12.46 18.28 12.58C18.1667 12.6933 18.03 12.7833 17.87 12.85C17.7167 12.9167 17.5533 12.95 17.38 12.95C17.2067 12.95 17.0433 12.9167 16.89 12.85C16.7433 12.7833 16.6133 12.6933 16.5 12.58C16.3867 12.46 16.2967 12.3267 16.23 12.18C16.1633 12.0267 16.13 11.8633 16.13 11.69C16.13 11.5167 16.1633 11.3533 16.23 11.2C16.2967 11.04 16.3867 10.9033 16.5 10.79C16.6133 10.67 16.7433 10.5767 16.89 10.51C17.0433 10.4433 17.2067 10.41 17.38 10.41C17.5533 10.41 17.7167 10.4433 17.87 10.51C18.03 10.5767 18.1667 10.67 18.28 10.79C18.4 10.9033 18.4933 11.04 18.56 11.2C18.6333 11.3533 18.67 11.5167 18.67 11.69Z" fill="black"></path></svg>';
      insuslatHeighthtml += '<p>If you are pairing with our top trim batten, please reduce your height by 25mm.</p>';
      insuslatHeighthtml += '</div>';      
      insuslatHeighthtml += '</div>';

        
        var bespokeConf = '<div class="bespoke-confirmation active">';
        bespokeConf += '<div class="bespoke-inner-conf">';
        bespokeConf += '<input type="hidden" name="properties[T&Cs Accepted]" class="tc-accepted-bespoke" />';
        bespokeConf += '<svg class="ele_bcnf" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">';
        bespokeConf += '<circle cx="17.5" cy="17.5" r="17.5" fill="#F0D2D2"/>';
        bespokeConf += '<path d="M18.29 14.87V25H16.51V14.87H18.29ZM18.67 11.69C18.67 11.8633 18.6333 12.0267 18.56 12.18C18.4933 12.3267 18.4 12.46 18.28 12.58C18.1667 12.6933 18.03 12.7833 17.87 12.85C17.7167 12.9167 17.5533 12.95 17.38 12.95C17.2067 12.95 17.0433 12.9167 16.89 12.85C16.7433 12.7833 16.6133 12.6933 16.5 12.58C16.3867 12.46 16.2967 12.3267 16.23 12.18C16.1633 12.0267 16.13 11.8633 16.13 11.69C16.13 11.5167 16.1633 11.3533 16.23 11.2C16.2967 11.04 16.3867 10.9033 16.5 10.79C16.6133 10.67 16.7433 10.5767 16.89 10.51C17.0433 10.4433 17.2067 10.41 17.38 10.41C17.5533 10.41 17.7167 10.4433 17.87 10.51C18.03 10.5767 18.1667 10.67 18.28 10.79C18.4 10.9033 18.4933 11.04 18.56 11.2C18.6333 11.3533 18.67 11.5167 18.67 11.69Z" fill="black"/>';
        bespokeConf += '</svg>';
        bespokeConf += '<span>This InsuSlat Panel is bespoke and made to order. Please accept the terms and conditions before adding to basket. (Required)</span>';
        bespokeConf += '<p class="tickbox-wrapper">';
        bespokeConf += '<input type="checkbox" name="bespoke-confirmation" class="bespoke-confirmation-ip" />';
        bespokeConf += '<label class="ipstatus_bespoke">';
        bespokeConf += '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">';
        bespokeConf += '<circle opacity="0.8" cx="20" cy="20" r="20" fill="#F0D2D2"/>';
        bespokeConf += '<path d="M12 19.6422L17.922 25.12L28.3969 15" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>';
        bespokeConf += '</svg>';
        bespokeConf += '</label>';
        bespokeConf += '</p>';
        bespokeConf += '</div>';
        bespokeConf += '</div>';
        
      if (insuslatStatus == 'No') {
        $('.inususlat_bespoke_height_step').remove();
        var atrname = $('.bespoke-confirmation .tc-accepted-bespoke').attr('name');
        $('.bespoke-confirmation .tc-accepted-bespoke').attr('name', 'ele_not_selected_'+atrname);
      } else {
          if ($(".inususlat_bespoke_height_step")[0]){
          } else {
            $('.elehide-do-you-want-your-panel-made-to-your-custom-height').after(insuslatHeighthtml);    
            $('.elehide-do-you-want-the-height-cut-to-size').after(insuslatHeighthtml);          
          }
        

          if ($(".bespoke-confirmation")[0]){
            $('.bespoke-confirmation').addClass('active');
          } else {
            $('.product-single__meta form .btnprice-wrapper').before(bespokeConf);
          }
        
          var atrname = $('.bespoke-confirmation .tc-accepted-bespoke').attr('name');
          atrname = atrname.replace('ele_not_selected_', '');
          $('.bespoke-confirmation .tc-accepted-bespoke').attr('name', atrname);
      }
            checkStatusLumi($(this));

    }, 201);
    
  });


  
  
  $('.manageipv.variant-input.vv-bespoke').click(function() {
    var stehtml = ''; 
    var stehtmlBespokeRAL = ''; 
    if ($(this).hasClass('vv-bespoke-ral-colour')) {
      stehtmlBespokeRAL += '<div class="variant-wrapper bespoke_panel_ral active">';  
      stehtmlBespokeRAL += '<label class="variant__label" for="width-in-cm">';
      stehtmlBespokeRAL += '<span>Step 5:</span>&nbsp;Please Enter The RAL Code';
      stehtmlBespokeRAL += '</label>';
      stehtmlBespokeRAL += '<div class="variant-input-wrap-line">';
      stehtmlBespokeRAL += '<div class="variant-input-line" data-index="option1">';
      stehtmlBespokeRAL += '<input type="text" class="bespoke_ral_colour" required="" class="w-100" name="properties[Bespoke RAL colour]" placeholder="Enter the RAL code for the colour you would like the posts and capping to be painted.">';
      stehtmlBespokeRAL += '<span class="floatiglabel">Enter the RAL code for the colour you would like the posts and capping to be painted.</span>';
      stehtmlBespokeRAL += '</div>';
      stehtmlBespokeRAL += '</div>';
      
      stehtmlBespokeRAL += '</div>';
    }
    var typeofbespoke = 'This Pedestrian Gate ';
    if (window.location.href.indexOf("pedestrian") > -1) {
      var heightMM = 2100;
      if (window.location.href.indexOf("virtis") > -1) {
        heightMM = 2000;
      }
      stehtml += '<div class="variant-wrapper bespoke_panel_size active">';  
      stehtml += '<label class="variant__label" for="width-in-cm">';
      stehtml += '<span>Step 5:</span>&nbsp;Enter bespoke height in mm&nbsp;<b class="selected_bespoke_area"></b>';
      stehtml += '<span class="infopro shw" data-microtip-size="large" aria-label="Our Pedestrian Gates are available in heights from 800mm - '+heightMM+'mm" data-microtip-position="bottom-left" role="tooltip">';
      stehtml += '<img src="https://cdn.shopify.com/s/files/1/0520/1670/9803/files/info.svg?v=1718117516" /></span>';
      stehtml += '</label>';
      stehtml += '<div class="variant-input-wrap-line">';
      stehtml += '<div class="variant-input-line" data-index="option1">';
      stehtml += '<input type="number" class="bespoke_height" required="" min="800" max="'+heightMM+'" class="w-100" name="properties[Height of your gate (in mm)]" placeholder="Height of your gate in mm (800mm - '+heightMM+'mm)">';
      stehtml += '</div>';
      stehtml += '</div>';

      stehtml += '<div class="additional_info_gates_height">';
      stehtml += '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><circle cx="17.5" cy="17.5" r="17.5" fill="#F0D2D2"></circle><path d="M18.29 14.87V25H16.51V14.87H18.29ZM18.67 11.69C18.67 11.8633 18.6333 12.0267 18.56 12.18C18.4933 12.3267 18.4 12.46 18.28 12.58C18.1667 12.6933 18.03 12.7833 17.87 12.85C17.7167 12.9167 17.5533 12.95 17.38 12.95C17.2067 12.95 17.0433 12.9167 16.89 12.85C16.7433 12.7833 16.6133 12.6933 16.5 12.58C16.3867 12.46 16.2967 12.3267 16.23 12.18C16.1633 12.0267 16.13 11.8633 16.13 11.69C16.13 11.5167 16.1633 11.3533 16.23 11.2C16.2967 11.04 16.3867 10.9033 16.5 10.79C16.6133 10.67 16.7433 10.5767 16.89 10.51C17.0433 10.4433 17.2067 10.41 17.38 10.41C17.5533 10.41 17.7167 10.4433 17.87 10.51C18.03 10.5767 18.1667 10.67 18.28 10.79C18.4 10.9033 18.4933 11.04 18.56 11.2C18.6333 11.3533 18.67 11.5167 18.67 11.69Z" fill="black"></path></svg>';
      stehtml += '<p>Please allow an additional 45mm in height for the top and bottom gate hinges. (view technical drawing <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none"> <path d="M10.5734 7.22514C10.5734 7.65127 10.1959 7.99995 9.73449 7.99995H1.34474C0.883329 7.99995 0.505859 7.65134 0.505859 7.22514V1.33627C0.505859 0.910137 0.883329 0.561523 1.34474 0.561523H9.73449C10.1959 0.561523 10.5734 0.910137 10.5734 1.33627V7.22514ZM1.34474 1.18136C1.25563 1.18136 1.17708 1.25418 1.17708 1.33621V7.22507C1.17708 7.30736 1.2557 7.37991 1.34474 7.37991H9.73449C9.8233 7.37991 9.90237 7.30736 9.90237 7.22507V1.33621C9.90237 1.25418 9.8233 1.18136 9.73449 1.18136H1.34474ZM2.85506 3.6608C2.29923 3.6608 1.84801 3.24434 1.84801 2.73114C1.84801 2.21793 2.29923 1.80127 2.85506 1.80127C3.41067 1.80127 3.86145 2.21793 3.86145 2.73114C3.86145 3.24434 3.41075 3.6608 2.85506 3.6608ZM9.23093 6.76027H1.84801V5.83027L3.52606 4.28091L4.36494 5.05546L7.0496 2.5763L9.23093 4.59086V6.76027Z" fill="black"/> </svg>)';
      stehtml += '</div>';
      
      stehtml += '</div>';
    } else {
      if ($('body').hasClass('composite-fences-collection-ele')) {
        typeofbespoke = 'This Fence ';
      } else {
        typeofbespoke = 'This Decorative Screen ';
      }
      
      stehtml += '<div class="variant-wrapper bespoke_panel_size active">';  
      stehtml += '<label class="variant__label" for="width-in-cm">';
      stehtml += '<span>Step 5:</span>&nbsp;Enter bespoke size screen height in cm&nbsp;<b class="selected_bespoke_area"></b>';
      stehtml += '<span class="infopro shw" data-microtip-size="large" aria-label="Our bespoke Decorative Screens are available from 60cm - 240cm (Height)" data-microtip-position="bottom-left" role="tooltip">';
      stehtml += '<img src="https://cdn.shopify.com/s/files/1/0520/1670/9803/files/info.svg?v=1718117516" /></span>';
      stehtml += '</label>';
      stehtml += '<div class="variant-input-wrap-line">';
      stehtml += '<div class="variant-input-line" data-index="option1">';
      stehtml += '<input type="number" class="bespoke_height" required="" min="60" max="240" class="w-100" name="properties[Screen height]" placeholder="Height of your screen in cm (60cm - 240cm)">';
      stehtml += '</div>';
      stehtml += '</div>';
      stehtml += '</div>';
      stehtml += '<div class="variant-wrapper bespoke_panel_size active">';    
      stehtml += '<label class="variant__label" for="width-in-cm">';
      stehtml += '<span>Step 5:</span>&nbsp;Enter bespoke size screen width in cm&nbsp;<b class="selected_bespoke_area"></b>';
      stehtml += '<span class="infopro shw" data-microtip-size="large" aria-label="Our bespoke Decorative Screens are available from 30cm - 120cm (Width)" data-microtip-position="bottom-left" role="tooltip">';
      stehtml += '<img src="https://cdn.shopify.com/s/files/1/0520/1670/9803/files/info.svg?v=1718117516" /></span>';
      stehtml += '</label>';
      stehtml += '<div class="variant-input-wrap-line">';
      stehtml += '<div class="variant-input-line" data-index="option1">';
      stehtml += '<input type="number" class="bespoke_width" required="" min="30" max="120" class="w-100" name="properties[Screen width]" placeholder="Width of your screen in cm (30cm - 120cm)">';
      stehtml += '</div>';
      stehtml += '</div>';
      stehtml += '</div>';
    }

    var bespokeConf = '<div class="bespoke-confirmation active">';
    bespokeConf += '<div class="bespoke-inner-conf">';
    bespokeConf += '<input type="hidden" name="properties[T&Cs Accepted]" class="tc-accepted-bespoke" />';
    bespokeConf += '<svg class="ele_bcnf" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">';
    bespokeConf += '<circle cx="17.5" cy="17.5" r="17.5" fill="#F0D2D2"/>';
    bespokeConf += '<path d="M18.29 14.87V25H16.51V14.87H18.29ZM18.67 11.69C18.67 11.8633 18.6333 12.0267 18.56 12.18C18.4933 12.3267 18.4 12.46 18.28 12.58C18.1667 12.6933 18.03 12.7833 17.87 12.85C17.7167 12.9167 17.5533 12.95 17.38 12.95C17.2067 12.95 17.0433 12.9167 16.89 12.85C16.7433 12.7833 16.6133 12.6933 16.5 12.58C16.3867 12.46 16.2967 12.3267 16.23 12.18C16.1633 12.0267 16.13 11.8633 16.13 11.69C16.13 11.5167 16.1633 11.3533 16.23 11.2C16.2967 11.04 16.3867 10.9033 16.5 10.79C16.6133 10.67 16.7433 10.5767 16.89 10.51C17.0433 10.4433 17.2067 10.41 17.38 10.41C17.5533 10.41 17.7167 10.4433 17.87 10.51C18.03 10.5767 18.1667 10.67 18.28 10.79C18.4 10.9033 18.4933 11.04 18.56 11.2C18.6333 11.3533 18.67 11.5167 18.67 11.69Z" fill="black"/>';
    bespokeConf += '</svg>';
    bespokeConf += '<span>'+typeofbespoke+'is bespoke and made to order. Please accept the terms and conditions before adding to basket. (Required)</span>';
    bespokeConf += '<p class="tickbox-wrapper">';
    bespokeConf += '<input type="checkbox" name="bespoke-confirmation" class="bespoke-confirmation-ip" />';
    bespokeConf += '<label class="ipstatus_bespoke">';
    bespokeConf += '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">';
    bespokeConf += '<circle opacity="0.8" cx="20" cy="20" r="20" fill="#F0D2D2"/>';
    bespokeConf += '<path d="M12 19.6422L17.922 25.12L28.3969 15" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>';
    bespokeConf += '</svg>';
    bespokeConf += '</label>';
    bespokeConf += '</p>';
    bespokeConf += '</div>';
    bespokeConf += '</div>';

    var atr = $(this).find('input:checked').attr('valuehandle');

    setTimeout(() => {
      if (atr && atr.includes('bespoke') && (atr.includes('size') || atr.includes('height'))) {
        if ($(".bespoke_panel_size")[0]){
          $('.bespoke_panel_size').addClass('active');
        } else {
          if (window.location.href.indexOf("pedestrian") > -1) {
            $(this).parents('.product-steps-wrapper').after(stehtml);
            $(this).parents('.variant-wrapper').after(stehtmlBespokeRAL);          
          } else {
            $(this).parents('.variant-wrapper').after(stehtmlBespokeRAL);     
            $(this).parents('.variant-wrapper').after(stehtml);
          }
        }
      }

    if (atr && atr.includes('bespoke') && atr.includes('ral') && atr.includes('colour')) {
      if ($(".bespoke_panel_ral")[0]){
        $('.bespoke_panel_ral').addClass('active');
      } else {
        $(this).parents('.variant-wrapper').after(stehtmlBespokeRAL);
      }
    }
      
      $('.template-product .product__quantity.product__quantity--button').addClass('visihide');
      $('.product-single__meta .wrapper-btn-qty').addClass('fullwidthele');
      $('.template-product main .js-qty__num').val('1');
      if ($(".bespoke-confirmation")[0]){
        $('.bespoke-confirmation').addClass('active');
      } else {
        $('.product-single__meta form .btnprice-wrapper').before(bespokeConf);
      }
      $('span.infopro.w').addClass('shw');

          if($('.vv-bespoke-ral-colour').find('input').is(':checked')) {
            var nm_ip = $('input.bespoke_ral_colour').attr('name');
            nm_ip = nm_ip.replace('ele_not_req_', '');
            $('input.bespoke_ral_colour').attr('name', nm_ip);
            $('input.bespoke_ral_colour').attr('required', true);
          } else {
              var nm_ip = $('input.bespoke_ral_colour').attr('name');
             $('input.bespoke_ral_colour').attr('name', 'ele_not_req_'+nm_ip); 
            $('input.bespoke_ral_colour').removeAttr('required');
          }
      
    }, 101);
    return;
  });  

  $('.aluminiumpostcap_solar_powered').click(function() {
    var id = $(this).attr('dataid');
    var qt = $('#ele_Quantity-optional_product_qty_picker').val();
    var finalTy = 'form_type=product'+'&id='+id+'&quantity='+ qt;
    $(this).addClass('btn--loading');
    theme.cart.addItemFromForm(finalTy)
    .then(function(product) {          
      $('body').trigger('added.ajaxProduct', this.$addToCart);
    }.bind(this))
    .catch(function(XMLHttpRequest) {
      console.log(XMLHttpRequest);
    }.bind(this))
    .always(function() {
      $('.aluminiumpostcap_solar_powered').removeClass('btn--loading');
    }.bind(this));
  });  

  $('button.btn.insuslat-sample-pack_btn').click(function() {
      var id = [];    
      var tele = false;
      var teleMultiSelect = false;
      $('.temp-insuslat-sample-pack main .variant-input-wrap input').each(function() {
        if ($(this).is(':checked')) {
          tele = true
        }
      });
      $('.temp-aquaslat-sample-pack main .variant-input-wrap input').each(function() {
        if ($(this).is(':checked')) {
          tele = true
        }
      });
      var totalMultiSelect = 0;
      var checkedMultiSelect = 0;
      $('.temp_multiselect_sample_pack main .product-single__meta .variant-input-wrap input').each(function() {
        totalMultiSelect++;
        if ($(this).is(':checked')) {
          tele = true;
          teleMultiSelect = true;
          checkedMultiSelect++;
        }
      });
      // var checkedMultiSelect = $('.temp_multiselect_sample_pack .variant-input-wrap input:checked').length;
    
      if (teleMultiSelect) {
        if (checkedMultiSelect == 4 || checkedMultiSelect == 8) {
          
        } else {
          var rem = 0;
          var isittrueCond = checkedMultiSelect % 4;
          if (checkedMultiSelect < 4) {
            rem = 4 - checkedMultiSelect;
            $('.error_multiselect').html('Please select '+rem+' additional colours to fill your sample pack*');
          } else if (checkedMultiSelect < 8 && totalMultiSelect >= 8) {
            rem = 8 - checkedMultiSelect;
            $('.error_multiselect').html('Please select '+rem+' additional colours to fill your sample pack*');
          } else if (isittrueCond != 0) {
            if (totalMultiSelect >= 8) {
              $('.error_multiselect').html('You can select either 4 or 8 colours.');
            } else if (totalMultiSelect < 8 && checkedMultiSelect > 4) {
              $('.error_multiselect').html('You can only select 4 colours.');       
            } else {
              $('.error_multiselect').html('Please select any 4 colours.');              
            }  
          }
          
            setTimeout(() => {
              $('.error_multiselect').html('');
            }, 3500);
            return;
        }
      }
    if (tele) {
      id = [];    
      $(this).addClass('btn--loading');
      $('main div:not(.QuickShopModal) form .manageipv.variant-input input:checked').each(function() {
        var idd = $(this).attr('vidid');
        var a = {
          id: idd,
          quantity: 1
        }
        id.push(a);
      })
      let formData = {
       'items': id
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response && response.ok) {
          $('body').trigger('added.ajaxProduct', this.$addToCart);
        } else {
          $('.error_multiselect').html('Product not in stock');
          setTimeout(() => {
            $('.error_multiselect').html('');
          }, 3500);
        }
        $(this).removeClass('btn--loading');
      })
      .catch((error) => {
        console.error('Error:', error);
        $(this).removeClass('btn--loading');
      });
    }    
  });

  $('.temp-insuslat-sample-pack main .colour.variant-input-wrap .variant-input, .temp-aquaslat-sample-pack main .colour.variant-input-wrap .variant-input, .temp_multiselect_sample_pack main .colour.variant-input-wrap .variant-input').click(function() {
    var ht = $('.insuslat-sample-pack_btn').html();
    if (ht == 'Select colours') {
      $('.insuslat-sample-pack_btn').html('Add to Basket');
    }
      var tele = false;
      $('.temp-insuslat-sample-pack main .variant-input-wrap input').each(function() {
        if ($(this).is(':checked')) {
          tele = true
        }
      });
      $('.temp-aquaslat-sample-pack main .variant-input-wrap input').each(function() {
        if ($(this).is(':checked')) {
          tele = true
        }
      });
      $('.temp_multiselect_sample_pack main .variant-input-wrap input').each(function() {
        if ($(this).is(':checked')) {
          tele = true
        }
      });
      if(!tele) {
        $('.temp-insuslat-sample-pack main .insuslat-sample-pack_btn').html('Select colours');
        $('.temp-aquaslat-sample-pack main .insuslat-sample-pack_btn').html('Select colours');
        $('.temp_multiselect_sample_pack main .insuslat-sample-pack_btn').html('Select colours');
      }
  })

  $('.insuslat-sample-pack main .manageipv.variant-input').click(function() {
    var v = $('.insuslat-sample-pack main .manageipv.variant-input input:checked').length;
    var price = $('#ProductPriceGetByVariantSelection').html();
    var p = price.replace('£', '');
    p = parseFloat(p);
    if (v > 0) {
      var final = p*v;
      $('.ac.product__priceforproductpage.product__price').html('£'+final.toFixed(2));
      $('.totalpriceproduct .product__priceforproductpage').html('£'+final.toFixed(2));
    }
  });
  
  $('.temp-aquaslat-sample-pack main .manageipv.variant-input').click(function() {
    var v = $('.temp-aquaslat-sample-pack main .manageipv.variant-input input:checked').length;
    var price = $('#ProductPriceGetByVariantSelection').html();
    var p = price.replace('£', '');
    p = parseFloat(p);
    if (v > 0) {
      var final = p*v;
      $('.ac.product__priceforproductpage.product__price').html('£'+final.toFixed(2));
      $('.totalpriceproduct .product__priceforproductpage').html('£'+final.toFixed(2));
    }
  });
  
  $('.temp_multiselect_sample_pack main .manageipv.variant-input').click(function() {
    var v = $('.temp_multiselect_sample_pack main .manageipv.variant-input input:checked').length;
    var totalCheckedMultiSelect = $('.temp_multiselect_sample_pack main .variant-input-wrap input').length;
    if (v <= 4) {
      v = 4;
    } else if (v > 4 && v <= 8 && totalCheckedMultiSelect >= 8) {
      v = 8;
    } else {
      v = 4
    }
    var price = $('#ProductPriceGetByVariantSelection').html();
    var p = price.replace('£', '');
    p = parseFloat(p);
    // console.log(p)
    if (v > 0) {
      var final = p*v;
      $('.temp_multiselect_sample_pack main .ac.product__priceforproductpage.product__price').html('£'+final.toFixed(2));
      $('.temp_multiselect_sample_pack main .totalpriceproduct .product__priceforproductpage').html('£'+final.toFixed(2));
    }
  });
   $(window).on('load', function () {
            setTimeout(() => {
        $('.temp_multiselect_sample_pack .product__priceforproductpage').css('visibility', 'visible');
        $('.temp_multiselect_sample_pack .ac.product__priceforproductpage.product__price').css('visibility', 'visible');
      }, 100);
   });
  
  // $('.temp_multiselect_sample_pack main .manageipv.variant-input').trigger('click');
  
  setTimeout(() => {
      // $('.temp-insuslat-sample-pack .variant-input-wrap .variant-input[managev="v-natural-oak"] label').trigger('click');
      $('.temp-insuslat-sample-pack main .insuslat-sample-pack_btn').html('Select colours');
      $('.temp-aquaslat-sample-pack main .insuslat-sample-pack_btn').html('Select colours');
      $('.temp_multiselect_sample_pack main .insuslat-sample-pack_btn').html('Select colours');
  },200);

  
  $('.ele_js-qty__adjust--plus').click(function() {
      var qt = parseInt($(this).siblings('input').val());
      qt = qt + 1;
      $(this).siblings('input').val(qt);
  });
  $('.ele_js-qty__adjust--minus').click(function() {
      var qt = parseInt($(this).siblings('input').val());
      if (qt > 1) {
        qt = qt - 1;
      }
      $(this).siblings('input').val(qt);
  });

  $('.temp-gate_Pedestrian .product__thumb-item[data-index="0"]').trigger('click');

  // $(document).on('click', '.minus-classic-grained-finish-fence-slat-sample-pack', function() {
  //    var cartUpdates = {};
  //    cartUpdates[44529224581336] = 0;
  //    cartUpdates[44529224614104] = 0;
  //    cartUpdates[44529224646872] = 0;
  //    cartUpdates[44529224679640] = 0;
  //    cartUpdates[44529224712408] = 0;
  //    cartUpdates[44529224745176] = 0;
  //    cartUpdates[44529224777944] = 0;
  //    cartUpdates[44529224810712] = 0;
  //    cartUpdates[44529224843480] = 0;

  //     var that = this;
  //     var params = {
  //       type: 'POST',
  //       url: '/cart/update.js',
  //       data: { updates: cartUpdates },
  //       dataType: 'json',
  //       success: function(stuff) { 
  //         if(window.location.href.includes('/cart')) {
  //           location.reload();
  //         } else {
  //           $('body').trigger('added.ajaxProduct', this.$addToCart);
  //         }
  //       }
  //     };
      
  //     if (!($('body').hasClass('js-drawer-open'))) {
  //       $.ajax(params);
  //     } else {
  //       $.ajax(params);
  //        $('body').trigger('added.ajaxProduct', this.$addToCart);
  //     }
  // });

  $(document).on('click', '.isBespoke--true', function() {
    setTimeout(() => {
    var id = $(this).attr('itemid');
    
    var qt = $(this).siblings('.js-qty__num').val();
     var cartUpdates = {};
    $('#CartDrawer .ajaxcart__product').each(function() {
      var ref = $(this).attr('bespokeparentreference');
      if (ref == id) {
        var itemidParent = $(this).attr('itemidParent');
        cartUpdates[itemidParent] = 0;
      }
    });
     // cartUpdates[44666671857880] = 0;
     // cartUpdates[44666671890648] = 0;
     // cartUpdates[45112763777240] = 0;      

      var that = this;
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(stuff) { 
          if(window.location.href.includes('/cart')) {
            location.reload();
          } else {
            $('body').trigger('added.ajaxProduct', this.$addToCart);
          }
        }
      };
      
      if (!($('body').hasClass('js-drawer-open'))) {
        $.ajax(params);
      } else {
        $.ajax(params);
         $('body').trigger('added.ajaxProduct', this.$addToCart);
      }
    }, 1000);
  });
  
  $(document).on('click', '.isDriveway--true-minus', function() {
    setTimeout(() => {
    var qt = $(this).siblings('.js-qty__num').val();
     var cartUpdates = {};
     cartUpdates[45121951596760] = 0;

      var that = this;
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(stuff) { 
          if(window.location.href.includes('/cart')) {
            location.reload();
          } else {
            $('body').trigger('added.ajaxProduct', this.$addToCart);
          }
        }
      };
      
      if (!($('body').hasClass('js-drawer-open'))) {
        $.ajax(params);
      } else {
        $.ajax(params);
         $('body').trigger('added.ajaxProduct', this.$addToCart);
      }
    }, 1000);
  });
});

